import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CKEditor from '@ckeditor/ckeditor5-react';
import AddSharpIcon from "@mui/icons-material/AddSharp";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import AddIcon from '@mui/icons-material/Add';
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import SearchIcon from "@mui/icons-material/Search";
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import {
  IconButton,
  Tooltip,
  Typography
} from "@mui/material";
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useHistory, useParams } from "react-router";
import Select from "react-select";
import TrashIcon from "../../assets/images/icons/Trash.svg";
import Constant from "../../Constant";
import "../../sass/responsive.scss";
import { Service } from "../../Service/ApiService";
import { CommonService } from "../../Service/CommonService";
import { InventoryApiService } from "../../Service/InventoryApiService";
import { SupportApiService } from "../../Service/SupportApiService";
import Spinner from "../Common/Spinner";
import "../Dynamic/AddSupportRequest.scss";
import "../Dynamic/GroupMessageBox.scss";
import SupportFaqPanel from "./SupportFaqPanel";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import LoginIcon from '@mui/icons-material/Login';
import BarrelOwnerAssignmentPopup from '../popups/BarrelOwnerAssignmentPopup';
import SellRequestEditValidationPopup from '../popups/SellRequestEditValidationPopup';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import { title } from 'process';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import LoaderImage from '../../assets/images/loader-image.png'
import InfoIcon from '../../assets/images/icons/Info.svg'
import { Button, Dropdown, OverlayTrigger } from 'react-bootstrap';
import LinkIcon from '@mui/icons-material/Link';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import EmptyBarrel from '../../../src/assets/images/icons/EmptyBarrel.svg';
import FilledBarrel from '../../../src/assets/images/icons/FilledBarrel.svg';
import CreatableSelect from 'react-select/creatable';

// Define the structure for a single tab
interface Tab {
  id: number;
  name: string;
  fieldValues: { [key: string]: any }; // To store form data for this tab
}

interface LocationState {
  data: string;
  companyId: string;
  lots: string[];
}

const AddSupportRequest: React.FC = () => {
  const history = useHistory();
  const locationState = history.location.state as LocationState;
  const [state, setState] = useState<LocationState | undefined>(locationState);
  const [files, setFiles] = useState<File[]>([]);
  const [file, setFile] = useState<File>(null);
  const [signatureFile, setSignatureFile] = useState<File>();
  const [activeTab, setActiveTab] = useState("open");
  const [search, setSearch] = useState("");
  const [selectedRequest, setSelectedRequest] = useState<any>(null);
  const [openRequestCount, setOpenRequestCount] = useState<number>(0);
  const [closedRequestCount, setClosedRequestCount] = useState<number>(0);
  const [supportRequests, setSupportRequests] = useState<any[]>([]);
  const [isNewTicket, setNewTicket] = useState(true);
  const [comment, setComment] = useState("");
  const [selectedCurrentUser, setSelectedCurrentUser] = useState(
    CommonService.getUserId()
  );
  const [isCreateShipment, setCreateShipment] = useState(false);
  const [conflictCount, setConflictCount] = useState(0);
  const [serviceDocDetails, setServiceDocDetails] = useState([]);
  const [requestDescription, setRequestDescription] = useState("");
  const [commentForTabs, setCommentForTabs] = useState<{ [tabId: string]: string }>({});
  const [sellRequestFee, setSellRequestFee] = useState('');
  const [sellRequestFeeType, setSellRequestFeeType] = useState('');
  const [selectedServiceName, setSelectedServiceName] = useState("");
  const [services, setServices] = useState([]);
  const [selectedService, setSelectedService] = useState("");
  const [selectedCompany, setSelectedCompany] = useState("");
  const [selectedCompanyError, setSelectedCompanyError] = useState("");
  const [barrelSourceError, setBarrelSourceError] = useState("");
  const [selectedTitle, setSelectedTitle] = useState("");
  const [titleError, setTitleError] = useState("");
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedInventory, setSelectedInventory] = useState("");
  const [fields, setFields] = useState([]);
  const [fieldsForUploadInventory, setFieldsForUploadInventory] = useState([]);
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [errorsForTabs, setErrorsForTabs] = useState<Record<string, Record<string, string>>>({});
  const [formData, setFormData] = useState<Record<string, any>>({});
  const [errorsForInventoryUpload, setErrorsForInventoryUpload] = useState<Record<string, string>>({});
  const [formDataForInventoryUpload, setFormDataForInventoryUpload] = useState<Record<string, any>>({});
  const [formDataForTabs, setFormDataForTabs] = useState<Record<string, Record<string, string>>>({});
  const [isLoading, setIsLoading] = useState(false);
  const [isServiceFieldLoading, setServiceFieldLoading] = useState(false);
  const [companiesList, setCompaniesList] = useState([]);
  const [filteredCompaniesList, setFilteredCompaniesList] = useState([]);
  const [activeInactiveCompaniesList, setActiveInactiveCompaniesList] = useState([]);
  const [filteredActiveInactiveCompaniesList, setFilteredActiveInactiveCompaniesList] = useState([]);
  const [carrierList, setCarrierList] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [ownerList, setOwnerList] = useState([]);
  const [currentCompaniesUserList, setCurrentCompaniesUserList] = useState([]);
  const [inventoriesList, setInventoriesList] = useState([]);
  const [quantity, setQuantity] = useState<number>(0);
  const [price, setPrice] = useState<number>(0);
  const [searchedInventories, setSearchedInventories] = useState<any>([]);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const singleFileInputRef = useRef<HTMLInputElement>(null);
  const [searchSelectedInventory, setSearchSelectedInventory] = useState(null);
  const [barrelSearchTerm, setBarrelSearchTerm] = useState("");
  const [selectedBarrels, setSelectedBarrels] = useState([]);
  const [desiredQuantity, setDesiredQuantity] = useState("");
  const [isSearch, setIsSearch] = useState(false);
  const [isAdminSelectService, setAdminSelectService] = useState(false);
  const [isDoneButtonClicked, setIsDoneButtonClicked] = useState(false);
  const [companyInputValue, setCompanyInputValue] = useState('');
  const [carrierInputValue, setCarrierInputValue] = useState('');
  const [userInputValue, setUserInputValue] = useState('');
  const [showCompanyDropdown, setShowCompanyDropdown] = useState(false);
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [showCarrierDropdown, setShowCarrierDropdown] = useState(false);
  const filteredCompanyOptions = filteredActiveInactiveCompaniesList.filter(company =>
    companyInputValue !== '' && company.companyName.toLowerCase().includes(companyInputValue.toLowerCase())
  );
  const filteredCarrierOptions = carrierList.filter(
    (carrier) =>
      carrierInputValue &&
      carrier.name.toLowerCase().includes(carrierInputValue.toLowerCase())
  );
  const filteredUserOptions = usersList.filter(user =>
    userInputValue !== '' && user.userName.toLowerCase().includes(userInputValue.toLowerCase())
  );
  const [debounceTimeout, setDebounceTimeout] = useState<NodeJS.Timeout | null>(null);
  const [viewFaq, setViewFaq] = useState(false);
  const handleCloseFaq = () => setViewFaq(false);
  const handleShowFaq = () => setViewFaq(true);
  const [selectedDsp, setSelectedDsp] = useState('');
  const [selectedMashBill, setSelectedMashBill] = useState('');
  const [isInventoryNotFound, setIsInventoryNotFound] = useState(false);
  const [selectedBarrelInventoryId, setSelectedBarrelInventoryId] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [pendingSubmitData, setPendingSubmitData] = useState(null);
  const [originalRequestData, setOriginRequestData] = useState<any>();
  const [originalSelectedInventoryBarrels, setOriginalSelectedInventoryBarrels] = useState();
  const [selectedCompanyName, setSelectedCompanyName] = useState("");
  const [isValidated, setIsValidated] = useState(false);
  const [validationsList, setValidationsList] = useState<any[]>([]);
  const [isEditMode, setEditMode] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isOwnerDropdownDisabled, setOwnerDropdownDisabled] = useState(false);
  const [ownerNameError, setOwnerNameError] = useState<string>("");
  const [receivingCompanyError, setReceivingCompanyError] = useState<string>("");
  const [ownerName, setOwnerName] = useState<string>("");
  const serviceRequestUpdateStatus = useRef({
        customerServiceRequestId: "",
        reason: "",
        status: "",
        spendHourOnRequest: ""
      });
  const [isRequestLoading, setIsRequestLoading] = useState(false);
  const [isShowSellRequestEditValidationPopup, setShowSellRequestEditValidationPopup] = useState(false)
  const [sellRequestEditValidationType, setSellRequestEditValidationType] = useState('');
  const [shouldCallSelectAll, setShouldCallSelectAll] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const {id} = useParams<{id: string}>();
  const [selectedCarrierId, setSelectedCarrierId] = useState<string | null>(null);
  const [loadingCompanies, setLoadingCompanies] = useState(true);
  const [tabs, setTabs] = useState<Tab[]>([]);
  const [activeTabId, setActiveTabId] = useState<number | null>(null);
  const [nextTabId, setNextTabId] = useState<number>(2);
  const [selectedCompanies, setSelectedCompanies] = useState<Record<string, string>>({});
  const [selectedCompanyErrors, setSelectedCompanyErrors] = useState<Record<string, string>>({});
  const [tabFiles, setTabFiles] = useState<{ [tabId: string]: File[] }>({});
  const [finalSelectedInventoriesWithBarrelForTabs, setFinalSelectedInventoriesWithBarrelsForTabs] = useState<any[]>([]);  
  const [showShipFromAddressDropdown, setShowShipFromAddressDropdown] = useState(false);
  const [showShipToAddressDropdown, setShowShipToAddressDropdown] = useState(false);
  const [shipFromAddressInputValue, setShipFromAddressInputValue] = useState('');
  const [shipToAddressInputValue, setShipToAddressInputValue] = useState('');
  const [shipFromAddressList, setShipFromAddressList] = useState([]);
  const [shipToAddressList, setShipToAddressList] = useState([]);
  const hasPrefilled = useRef(false);
const [mashBillInputValue, setMashBillInputValue] = useState('');
const PREFILL_TEMPLATE = "00% Corn, 00% Rye, 00% Wheat, 00% Malted Barley";
// Ensure showMashBillMessage is false initially so it doesn't pop up on load
// const [isShowMashBillMessage, setShowMashBillMessage] = useState(false);
  const [selectedMashBillId, setSelectedMashBillId] = useState<string | null>(null);
  const [showMashBillDropdown, setShowMashBillDropdown] = useState(false);
  const [mashBillList, setMashBillList] = useState([]);
  const [isDestination, setIsDestination] = useState(false);
  const [searchedSourceToDestinationInventory, setSearchedSourceToDestinationInventory] = useState<any>([]);
  const [searchSelectedSourceToDestinationInventory, setSearchSelectedSourceToDestinationInventory] = useState(null);
  const [showDestinationPopup, setShowDestinationPopup] = useState(false);
  const [selectedSourceBarrel, setSelectedSourceBarrel] = useState(null);
  const [barrelVolumes, setBarrelVolumes] = useState({});
  const [openPopupForBarrelId, setOpenPopupForBarrelId] = useState(null);
  const [destinationBarrelSearchTerm, setDestinationBarrelSearchTerm] = useState("");
  const [barrelErrors, setBarrelErrors] = useState({});
  const [barrelCapacityErrors, setBarrelCapacityErrors] = useState<Record<string, boolean>>({});
  const [hasBarrelValidationError, setHasBarrelValidationError] = useState(false);
  const [shouldValidate, setShouldValidate] = useState(false);
  const [managedByWhitedogFilter, setManagedByWhitedogFilter] = useState<'all' | 'managed'>('all');

  const filteredMashBillOptions = mashBillList.filter((item) =>
    mashBillInputValue &&
    item.name.toLowerCase().includes(mashBillInputValue.toLowerCase())
   );
 
  const filteredShipFromAddressOptions = shipFromAddressList.filter(
    (shipFromAddress) =>
      shipFromAddressInputValue &&
      shipFromAddress.facilityName.toLowerCase().includes(shipFromAddressInputValue.toLowerCase())
  );

  const filteredShipToAddressOptions = shipToAddressList.filter(
    (shipToAddress) =>
      shipToAddressInputValue &&
      shipToAddress.facilityName.toLowerCase().includes(shipToAddressInputValue.toLowerCase())
  );

  useEffect(() => {
    if (shouldValidate) {
      isValidate();
      setShouldValidate(false);
    }
  }, [formData]);

   useEffect(() => {
    const initialTab: Tab = {
      id: 1,
      name: 'Project 1', // You can customize the naming convention
      fieldValues: {},
    };
    setTabs([initialTab]);
    setActiveTabId(1);
  }, []); // The empty dependency array ensures this runs only once

  // Function to add a new, empty tab
  const handleAddTab = async () => {

    //need to check user filled all the required information for current tab
    if (!await isValidateForTabs()) {
      CommonService.Toast.fire({
        title: "Please complete all required fields before continuing.",
        icon: "error",
      });
      return ;
    }

    const newTab: Tab = {
      id: nextTabId,
      name: `Project ${nextTabId}`,
      fieldValues: {},
    };
    setTabs([...tabs, newTab]);
    setActiveTabId(nextTabId); // Make the new tab active
    setNextTabId(nextTabId + 1); // Increment the ID for the next one
  };

  const handleChangeTab = async (tabId:any) => {

    // user click current opened tab then do nothing
    if(tabId == activeTabId) {
      return;
    }
    // before switching the tab need to check all required field are filled or not
    if(!await isValidateForTabs()) {
      CommonService.Toast.fire({
        title: "Please complete all required fields before continuing.",
        icon: "error",
      });
      return ;
    }
    setActiveTabId(tabId)
  }

  // Find the full object for the currently active tab
  const getActiveTab = tabs.find(tab => tab.id === activeTabId);

  // Function to remove a tab by its ID
  const handleRemoveTab = (tabIdToRemove: number) => {

    // Prevent removing the last remaining tab
    if (tabs.length <= 1) return;

    // remove related inventories for this tab
    setFinalSelectedInventoriesWithBarrelsForTabs(prev => {
      const updated = { ...prev };
      delete updated[tabIdToRemove];
      return updated;
    });

    // Remove related form data
    setFormDataForTabs(prev => {
      const updated = { ...prev };
      delete updated[tabIdToRemove];
      return updated;
    });


    const newTabs = tabs.filter(tab => tab.id !== tabIdToRemove);
    setTabs(newTabs);

    // If the active tab was the one removed, switch the active tab to the first one in the list
    if (activeTabId === tabIdToRemove) {
      setActiveTabId(newTabs[0]?.id || null);
    }
  };

  const [
    finalSelectedInventoriesWithBarrels,
    setFinalSelectedInventoriesWithBarrels,
  ] = useState([
    // Initial empty structure, or you can start with an empty array
    // { lotId: null, productName: "", barrelNumbers: [] }
  ]);

  const [finalSelectedSourceToDestinationInventories, setFinalSelectedSelectedSourceToDestinationInventories] = useState([]);

  const [barrelSource, setBarrelSource] = useState('Manual Barrel Selection');
  const [isShowCarrierMessage, setShowCarrierMessage] = useState(false);
  const [transferRequests, setTransferRequests] = useState<any[]>([]);
  const [groupedRequests, setGroupedRequests] = useState<any>({});
  const [selectedType, setSelectedType] = useState<string | null>(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isShowMashBillMessage, setShowMashBillMessage] = useState(false);
  const [isShowShipFromAddressMessage, setShipFromAddressMessage] = useState(false);
  const [isShowShipToAddressMessage, setShipToAddressMessage] = useState(false);

  const requestTypes = [
    { key: "Offer Request", label: "Offer Request" },
    { key: "Order Request", label: "Order Request" },
    { key: "Ownership Transfer", label: "Ownership Transfer" },
    { key: "Private Sale", label: "Private Sale" },
    { key: "Blending Request", label: "Blending Request"},
    { key: "Bottling Request", label: "Bottling Request"},
    //{ key: "Dumping Request", label: "Dumping Request"}
  ];


  const handleClose = () => {
    setValidationsList([]);
    setFile(null);
    setIsValidated(false);
    // Clear file from form data.
    const uploadFileField = fields.find(f => f.dataType === Constant.FIELD_TYPES.UPLOAD_FILE);
    if (uploadFileField) {
      setFormData((prev) => ({
        ...prev,
        [uploadFileField.serviceTypeServiceFieldId]: null,
      }));
      setFormDataForInventoryUpload((prev) => ({
        ...prev,
        [uploadFileField.serviceTypeServiceFieldId]: null,
      }));
    }
  };

  const getRequestDetailsById = (id: any): string | null => {

    if (!id || !Array.isArray(transferRequests)) {
      return null;
    }
    const request = transferRequests.find((req) => req.requestId === id);
    return request ? `${request.requestType} ${request.requestNumber} - ${request.totalBarrels} Barrels` : null;
  };

  const handleViewRequest = (id:any) => {
    if (!id || !Array.isArray(transferRequests)) {
      return null;
    }
    const request = transferRequests.find((req) => req.requestId === id);

    showRequestDetails(request?.requestType, request?.requestId);
  }


  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleSingleButtonClick = () => {
    if (singleFileInputRef.current) {
      singleFileInputRef.current.click();
    }
  };

  const getCarrierNameById = (id: any, list: any) => {
    if (!id || !list) return "";
    const carrier = list.find((c) => c.id === id || c.name === id);
    if (carrier) {
      return carrier.name || "";
    }
  };

  const getMashBillNameById = (name: any, list: any) => {
    if (!name || !list) return "";
    const mashBill = list.find((c) => c.name === name);
    return mashBill && mashBill.name ? mashBill.name : "";
  };

  const getShipFromAddressNameById = (id: any, list: any) => {
    if (!id || !list) return "";
    const shipFromAddress = list.find((c) => c.id === id || c.facilityName === id);
    if (shipFromAddress) {
      return shipFromAddress.facilityName || "";
    }
  };

  const getShipToAddressNameById = (id: any, list: any) => {
    if (!id || !list) return "";
    const shipToAddress = list.find((c) => c.id === id || c.facilityName === id);
    if (shipToAddress) {
      return shipToAddress.facilityName || "";
    }
  };
  
  useEffect(() => {
    if (selectedCompany && !isEditMode) {
      // Clear the entire LocationState by resetting it to undefined on company change
      setState(undefined);
      const searchBarField = fields.find(
        (field) => field.dataType === Constant.FIELD_TYPES.ADD_CONTAINER || field.dataType === Constant.FIELD_TYPES.SOURCE_CONTAINER
      );
      if (searchBarField) {
        handleSearchInventory('', searchBarField.serviceTypeServiceFieldId);
      }
    }
  }, [selectedCompany]);

  const selectAllBarrelsForLots = async (lots: any[], allLotDetails: any) => {
    for (const lot of lots) {
      const lotdetails = allLotDetails.find((inv: any) => inv.lotNo === lot);
      if (!lotdetails) continue;

      setSearchSelectedInventory(lotdetails);

      // Set flag true to trigger useEffect
      setShouldCallSelectAll(true);

      // Wait until the effect runs (React schedules state update)
      await new Promise((resolve) => setTimeout(resolve, 20));
    }
    handleDoneSelection();
  };

  useEffect(() => {
    if (shouldCallSelectAll && searchSelectedInventory) {
      handleSelectAllBarrels();
      setShouldCallSelectAll(false); // reset so it won't call on other updates
    }
  }, [searchSelectedInventory, shouldCallSelectAll]);

  const fetchEditExistingCompanies = async () => {
    try {
      const response = await Service.fetchCompaniesList();
      const companyId = selectedCompany ? selectedCompany : (CommonService.isUser() ? CommonService.getCompanyId() : '');
      const existingCompanies = response.data.filter(
        (company) => company.id === companyId
      );
      let selectedCompanyName = null;
      if(isEditMode){
        const selectedCompany = existingCompanies.find(company => company.id === companyId);
        if(selectedCompany !== undefined) {
          selectedCompanyName = selectedCompany.companyName;
          setSelectedCompanyName(selectedCompanyName);
        }
      }
      return { selectedCompanyName };
    } catch (error) {
      console.error("Error fetching companies:", error);
    }
  };


  //this method will call only when admin or user will edit the service request
  const  fetchCustomerServiceRequestForEditing = async (carrierList?:any, facilityList?:any, mashBillList?:any) => {
    try {

      setEditMode(true);
                                                    
      //call api and get all the details of customer service request 
      const response = await SupportApiService.getCustomerServiceRequestForEditing(id);

      //fetch the doc details
      // await fetchCustomerServiceRequestDocsForEditing();

      setOriginRequestData(response.data);
      setOriginalSelectedInventoryBarrels(structuredClone(response.data.finalSelectedInventoriesWithBarrels));

      //create object of selected inventory container 
      
      const selectedInventory = {
        selectedInventoryBarrels: response.data.finalSelectedInventoriesWithBarrels,
      }

      setOriginalSelectedInventoryBarrels(selectedInventory.selectedInventoryBarrels);

      //set the service details
      setSelectedService(response?.data?.selectedServiceId);
      setSelectedServiceName(response?.data?.serviceName);

      //now call the api which load all the dynamic field for service 
      setServiceFieldLoading(true);
      const fieldResponse = await Service.getFieldByServiceType(response?.data?.selectedServiceId);

      if(response?.data?.serviceName == Constant.CustomerService.LOGISTIC && response?.data?.barrelSource == Constant.BarrelSource.SHIP_BY_SELECTING_REQUEST) {
        fetchAllTransferRequests(response?.data?.selectedCompanyId);
      }

      // exclude the fee_type_dropdown and commission_fee because this is not editable and set fields
      let filteredFields = fieldResponse.data.filter(
        (field) =>
          field.dataType !== Constant.FIELD_TYPES.FEE_TYPE_DROPDOWN &&
          field.dataType !== Constant.FIELD_TYPES.COMMISSION_FEE
      );

      setBarrelSource(response?.data?.barrelSource);

      if(response?.data?.serviceName == Constant.CustomerService.LOGISTIC) {
        if (
          response?.data?.barrelSource === Constant.BarrelSource.SHIP_BY_SELECTING_BARRELS
        ) {
          filteredFields = filteredFields.filter(
            (field) => field.dataType !== Constant.FIELD_TYPES.TRANSFER_REQUEST_DROPDOWN
          );
        } else if (
          response?.data?.barrelSource === Constant.BarrelSource.SHIP_BY_SELECTING_REQUEST 
        ) {
          filteredFields = filteredFields.filter(
            (field) => field.dataType !== Constant.FIELD_TYPES.ADD_CONTAINER && field.dataType !== Constant.FIELD_TYPES.SOURCE_CONTAINER
          );
        } else {
          filteredFields = filteredFields.filter(
            (field) =>
              field.dataType !== Constant.FIELD_TYPES.TRANSFER_REQUEST_DROPDOWN &&
              field.dataType !== Constant.FIELD_TYPES.ADD_CONTAINER &&
              field.dataType !== Constant.FIELD_TYPES.SOURCE_CONTAINER
          );
        }
      }

      setFields(filteredFields);

      // if Service name is "Sample Request" and roleName is 'USER' then exclude 'Requesting Organization' field
      if (response?.data?.serviceName == Constant.CustomerService.SAMPLE_REQUEST && response?.data?.roleName !== Constant.Role.SUPER_ADMIN) {
        filteredFields = filteredFields.filter(
          (field) => field.fieldName !== Constant.Field.REQUESTING_ORGANIZATION
        );
      }

      setFields(filteredFields);
      
      //fill all the details
      setSelectedCompany(response?.data?.selectedCompanyId);
      setSelectedUser(response?.data?.selectedUserId);
      setRequestDescription(response?.data?.comment);
      setIsDoneButtonClicked(true);
      setFinalSelectedInventoriesWithBarrels(response?.data?.finalSelectedInventoriesWithBarrels);
      setAdminSelectService(CommonService.isAdmin()? true : false);

      if (response?.data?.finalSelectedInventoriesWithBarrels?.length > 0) {
        const prefilledDestinations = response.data.finalSelectedInventoriesWithBarrels.flatMap(inv =>
          inv.barrelNumbers?.flatMap(barrel => {
            // If this barrel has destination inventories
            return barrel.finalSelectedDestinationInventoriesRequest?.map(destInv => ({
              ...destInv,
              destinationBarrelNumberResponse: destInv.destinationBarrelNumberResponse.map(b => ({
                ...b,
                sourceBarrelId: barrel.barrelId,
                sourceBarrelNumber: barrel.barrelNumber,
              })),
            })) || [];
          }) || []
        );

        setSearchedSourceToDestinationInventory(prefilledDestinations);
        setFinalSelectedSelectedSourceToDestinationInventories(prefilledDestinations);
        setSearchSelectedSourceToDestinationInventory(prefilledDestinations[0]);
      }

      //now fetch all the existing companies
      await fetchExistingCompanies(response?.data?.selectedCompanyId);

      if(response?.data?.serviceName == Constant.CustomerService.PRIVATE_SELL || response?.data?.serviceName == Constant.CustomerService.SELL_REQUEST) {
        setSelectedMashBill(response?.data?.finalSelectedInventoriesWithBarrels[0]?.mashBill);
        setSelectedDsp(response?.data?.finalSelectedInventoriesWithBarrels[0]?.dsp);
      }

      if(response?.data?.serviceName == Constant.CustomerService.OWNERSHIP_TRANSFER) {
        setSelectedBarrelInventoryId(response?.data?.finalSelectedInventoriesWithBarrels[0]?.inventoryId);
      }

      if(response?.data?.serviceName == Constant.CustomerService.CUSTOM_SAMPLE_REQUEST) {
        setSelectedTitle(response?.data?.title);
      }
      

      // Initialize form data with default values
      const initialData = {};
      const initialError = {};


      //set all the dynamic field data
      response?.data?.dynamicFields?.forEach((field) => {
        //add logic for 'owner name' enable or disable
        if(field.fieldName === 'Does the company own the uploaded inventory?' && field.value === 'true') {
          setIsDisabled(true);
        }
        initialData[field.id] = (field.value == 'true' ? true : (field.value == 'false' ? false : field.value ))
      });

      setFormData(initialData);
      setErrors(initialError);
      setServiceFieldLoading(false);

      //if the service name is ownership transfer then we need to find the new companyId and call the api which fetch user of this company
      if(response?.data?.serviceName == Constant.CustomerService.OWNERSHIP_TRANSFER) {
        fieldResponse?.data?.forEach(async (field) => {
          if(field?.dataType == Constant.FIELD_TYPES.COMPANY_DROPDOWN) {
            await fetchUsersByCompany(initialData[field?.serviceTypeServiceFieldId]);
          }
          // else if(field?.fieldName == 'Current Company') {
          //   await fetchUsersByCurrentCompany(initialData[field?.serviceTypeServiceFieldId]);
          // }
        })
      }

      if (response?.data?.serviceName === Constant.CustomerService.PRIVATE_SELL) {
        for (const field of fieldResponse?.data || []) {
          if (field?.fieldName === 'Private Buyer Company') {
            setCompanyInputValue(initialData[field?.serviceTypeServiceFieldId]);
            await fetchAllActiveAndInactiveCompanies(initialData[field?.serviceTypeServiceFieldId]);
          } else if (field?.fieldName === 'Private Buyer User') {
            setUserInputValue(initialData[field?.serviceTypeServiceFieldId]);
          }
        }
      }

      if (response?.data?.serviceName === Constant.CustomerService.LOGISTIC) {
          for (const field of fieldResponse?.data || []) {
            if (field?.fieldName?.toLowerCase().trim() == "carrier") {
              setCarrierInputValue(getCarrierNameById(initialData[field?.serviceTypeServiceFieldId], carrierList));
            }

            if (field?.fieldName?.trim() == "Logistic from Facility") {
              setShipFromAddressInputValue(getShipFromAddressNameById(initialData[field?.serviceTypeServiceFieldId], facilityList));
            }

            if (field?.fieldName?.trim() == "Logistic to Facility") {
              setShipToAddressInputValue(getShipToAddressNameById(initialData[field?.serviceTypeServiceFieldId], facilityList));
            }
          }
        }

      if (response?.data?.serviceName === Constant.CustomerService.WANTED_TO_BUY) {
        for (const field of fieldResponse?.data || []) {
          if (field?.fieldName?.trim() === "Mash Bill") {
            setMashBillInputValue(getMashBillNameById(initialData[field?.serviceTypeServiceFieldId], mashBillList));
          }
        }
      }

      //if the service name is Barrel Owner Assignment then we need to find the owner id and call the api which fetch owners of this exiting owners
      if(response?.data?.serviceName == Constant.CustomerService.BARREL_OWNER_ASSIGNMENT || response?.data?.serviceName == Constant.CustomerService.BULK_INVENTORY_UPLOAD) {
        response?.data?.dynamicFields.forEach(async (field) => {
          if(field?.fieldName == "Barrel Owner" || field?.fieldName == "Owner Name") {
            await fetchOwnersByCompanyId(response?.data?.selectedCompanyId);
          }
        })
      }
    } catch(error) {
      setServiceFieldLoading(false);
      console.log("error occurred while api calling ");

    }
  }

  useEffect(() => {
    fields.forEach((field) => {
      if (field.dataType === Constant.FIELD_TYPES.LOGISTIC_TYPE_DROPDOWN) {
        setFormData((prev) => ({
          ...prev,
          [field.serviceTypeServiceFieldId]:
            prev[field.serviceTypeServiceFieldId] ?? "Inbound",
        }));
      }
    });
  }, [fields]);

  const handleCarrierSelect = (carrier, serviceTypeServiceFieldId) => {

    setErrors((prev) => ({ ...prev, [serviceTypeServiceFieldId]: "" }));

    setCarrierInputValue(carrier.name); // show name in input
    setSelectedCarrierId(carrier.id); // keep id for form
    setShowCarrierDropdown(false);

    // update form data with selected id
    setFormData((prevFormData) => ({
      ...prevFormData,
      [serviceTypeServiceFieldId]: carrier.id,
    }));
  };

  const handleCarrierChange = (e:any, serviceTypeServiceFieldId) => {

    setErrors((prev) => ({ ...prev, [serviceTypeServiceFieldId]: "" }));
    const value = e.target.value;
    setCarrierInputValue(value);
    setSelectedCarrierId(null); // reset since it's free typing
    setShowCarrierDropdown(true);

  };

  const handleShipFromAddressChange = (e:any, serviceTypeServiceFieldId) => {

    setErrors((prev) => ({ ...prev, [serviceTypeServiceFieldId]: "" }));
    const value = e.target.value;
    setShipFromAddressInputValue(value);
    setShowShipFromAddressDropdown(true);

    clearAutoFilledFields("from");
    setFormData((prevFormData) => ({
      ...prevFormData,
      [serviceTypeServiceFieldId]: "",
    }));
  };

  const handleShipFromAddressSelect = (shipFromAddress, serviceTypeServiceFieldId) => {

    setErrors((prev) => ({ ...prev, [serviceTypeServiceFieldId]: "" }));
    setShipFromAddressInputValue(shipFromAddress.facilityName); // show facilityName in input
    setShowShipFromAddressDropdown(false);

    // update form data with selected id
    setFormData((prevFormData) => ({
      ...prevFormData,
      [serviceTypeServiceFieldId]: shipFromAddress.id,
    }));

    autoFillContactFields(shipFromAddress, "from");
  };

  const handleShipToAddressChange = (e:any, serviceTypeServiceFieldId) => {

    setErrors((prev) => ({ ...prev, [serviceTypeServiceFieldId]: "" }));
    const value = e.target.value;
    setShipToAddressInputValue(value);
    setShowShipToAddressDropdown(true);
    
    clearAutoFilledFields("to");
    setFormData((prevFormData) => ({
      ...prevFormData,
      [serviceTypeServiceFieldId]: "",
    }));
  };

  const handleShipToAddressSelect = (shipToAddress, serviceTypeServiceFieldId) => {

    setErrors((prev) => ({ ...prev, [serviceTypeServiceFieldId]: "" }));
    setShipToAddressInputValue(shipToAddress.facilityName); // show facilityName in input
    setShowShipToAddressDropdown(false);

    // update form data with selected id
    setFormData((prevFormData) => ({
      ...prevFormData,
      [serviceTypeServiceFieldId]: shipToAddress.id,
    }));

    autoFillContactFields(shipToAddress, "to");
  };
useEffect(() => {
    // Replace 'MASH_BILL_FIELD_ID' with your actual dynamic ID logic if necessary
    // This ensures the form starts with the template as its value
    if (!mashBillInputValue) {
        setMashBillInputValue(PREFILL_TEMPLATE);
    }
}, []);

const getFilteredMashBillValue = (value: string) => {
        if (!value) return "";
        return value
          .split(",")
          .map((v) => v.trim())
          .filter((part) => {
            const match = part.match(/([\d.]+)\s*%/);
            if (!match) return false;
            return parseFloat(match[1]) > 0;
          })
          .join(", ");
    };
const handleMashBillChange = (e, serviceTypeServiceFieldId) => {
  const value = e.target.value;
        setErrors((prev) => ({ ...prev, [serviceTypeServiceFieldId]: "" }));
        
        // Show full value in input for user editing
        setMashBillInputValue(value);

        // Save ONLY non-zero values to form data
        const filteredValue = getFilteredMashBillValue(value);
        setFormData((prevFormData) => ({
            ...prevFormData,
            [serviceTypeServiceFieldId]: filteredValue, // FIXED: removed .name as it is a string
        }));

        // Dropdown logic
        if (value !== PREFILL_TEMPLATE && value.trim().length > 0) {
          setShowMashBillDropdown(true);
        } else {
          setShowMashBillDropdown(false);
        }
      };

  const handleMashBillSelect = (mashBill, serviceTypeServiceFieldId) => {
    setErrors((prev) => ({ ...prev, [serviceTypeServiceFieldId]: "" }));
    setMashBillInputValue(mashBill.name);
    setShowMashBillDropdown(false);
    
    // update form data with selected id
    setFormData((prevFormData) => ({
      ...prevFormData,
      [serviceTypeServiceFieldId]: mashBill.name,
    }));
  };

  const fetchAllTransferRequests = async (companyId: any) => {
    try {
      const response = await SupportApiService.getAllTransferRequest(companyId);
      const requests = response.data || [];
      setTransferRequests(requests);

      const grouped = requests.reduce((acc: any, req: any) => {
        if (!acc[req.requestType]) acc[req.requestType] = [];
        acc[req.requestType].push(req);
        return acc;
      }, {});
      setGroupedRequests(grouped);
    } catch (error) {
      console.log("error occurred while api calling " + error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        await fetchAllServices();

        const carriers = await fetchCarrierList();
        const mashBills = await fetchMashBillList(); 
        const facilitys = await fetchFacilityList();
        if (id) {
          await fetchCustomerServiceRequestForEditing(carriers, facilitys, mashBills);
        }
      } catch (error) {
        console.error(" Error while fetching data:", error);
      }
    };

    fetchData();
  }, [id]);

  const fetchAllServices = async () => {
    try {
      setIsRequestLoading(true);
      const response = await Service.getAllServiceType();
      if (CommonService.isUser()) {
        response.data = response.data.filter(
          (service) => {
              // Exclude "Private Sale"
              if (service.serviceName === Constant.CustomerService.PRIVATE_SELL) return false;
              if ((service.serviceName === Constant.CustomerService.BARREL_REPAIR_REQUEST || service.serviceName === Constant.CustomerService.DUMPING_REQUEST) && !id) return false;
              return true;
          }
        );
        response.data = response.data.filter((service) => {
          if (service.serviceName === Constant.CustomerService.PRIVATE_SELL) return false;        // always hide
          if (!id && service.serviceName === Constant.CustomerService.CUSTOM_SAMPLE_REQUEST) return false; // hide on create
          return true;
        });
      }

      setServices(response.data);
      if(state?.data != undefined){
        const serviceId = response.data.find((s: any) => s.serviceName === state?.data)?.id
        setSelectedService(serviceId);
        setSelectedServiceName(state?.data);
        handleServiceChange(serviceId,state?.data);
      }
    } catch (error) {
      console.log("Error occurred while API calling:", error);
    } finally {
      setIsRequestLoading(false);
    }
  };

  const inventoryUploadService = services.find(
    (ser) => ser.serviceName === Constant.CustomerService.BULK_INVENTORY_UPLOAD
  );

  const fetchFieldsForInventoryUpload = async () => {
     setServiceFieldLoading(true);
     setOwnerDropdownDisabled(true);
     const response = await Service.getFieldByServiceType(inventoryUploadService?.id);
     setFieldsForUploadInventory(response.data);
     setFormDataForInventoryUpload({});
     setErrorsForInventoryUpload({});
  }


  const fetchFieldsByServiceType = async (serviceTypeId, serviceTypeName, barrelSourceType?:any, requestId?:any) => {
    try {
      setServiceFieldLoading(true);
      const response = await Service.getFieldByServiceType(serviceTypeId);
    
      let filteredFields = response.data;

      if(serviceTypeName == Constant.CustomerService.LOGISTIC) {
        const sourceToUse = barrelSourceType !== undefined ? barrelSourceType : barrelSource;

        if (
          sourceToUse === Constant.BarrelSource.SHIP_BY_SELECTING_BARRELS
        ) {
          filteredFields = filteredFields.filter(
            (field) => field.dataType !== Constant.FIELD_TYPES.TRANSFER_REQUEST_DROPDOWN
          );
        } else if (
          sourceToUse === Constant.BarrelSource.SHIP_BY_SELECTING_REQUEST 
        ) {
          filteredFields = filteredFields.filter(
            (field) => field.dataType !== Constant.FIELD_TYPES.ADD_CONTAINER && field.dataType !== Constant.FIELD_TYPES.SOURCE_CONTAINER
          );
        } else {
          filteredFields = filteredFields.filter(
            (field) =>
              field.dataType !== Constant.FIELD_TYPES.TRANSFER_REQUEST_DROPDOWN &&
              field.dataType !== Constant.FIELD_TYPES.ADD_CONTAINER &&
              field.dataType !== Constant.FIELD_TYPES.SOURCE_CONTAINER
          );

          await fetchFieldsForInventoryUpload();
        }
      }

      setFields(filteredFields);

      /*if(serviceTypeName == Constant.CustomerService.LIQUID_TRANSFER) {
        const childServiceTypeResponse = await Service.getServiceTypeById(serviceTypeId);
        setChildServices(childServiceTypeResponse.data)
        if(state?.data != undefined){
          const serviceId = response.data.find((s: any) => s.serviceName === state?.data)?.id
          setSelectedChildService(serviceId);
          setSelectedChildServiceName(state?.data);
        }
      }

      if (serviceTypeName === Constant.CustomerService.LIQUID_TRANSFER) {
        const childServiceTypeResponse = await Service.getServiceTypeById(serviceTypeId);
        setChildServices(childServiceTypeResponse.data);

        // If coming from edit/state
        if (state?.data !== undefined) {

          // CASE 1: state.data = "Logistic"
          // CASE 2: state.data = ["Logistic", "Transfer In"]

          const selectedNames = Array.isArray(state.data)
            ? state.data                // multiple names
            : [state.data];             // convert single → array

          const selectedIds = selectedNames
            .map(name => {
              const service = childServiceTypeResponse.data.find(
                (s) => s.serviceName === name
              );
              return service?.id;
            })
            .filter(Boolean); // remove undefined

          // Set MULTIPLE VALUES
          setSelectedChildServices(selectedIds);
          setSelectedChildServiceNames(selectedNames);

          // Compatibility (legacy variables)
          //if (selectedIds.length > 0) {
            //setSelectedChildService(selectedIds[0]);     // keep for old logic
            //setSelectedChildServiceName(selectedNames[0]);
          //}
        }
      }*/

      // Initialize form data with default values
      const initialData = {};
      const initialError = {};

      response.data.forEach((field) => {
        if (
          field.dataType === Constant.FIELD_TYPES.CURRENT_COMPANY ||
          field.dataType === Constant.FIELD_TYPES.CURRENT_USER ||
          field.dataType == Constant.FIELD_TYPES.TRANSFER_REQUEST_DROPDOWN ||
          field.dataType === Constant.FIELD_TYPES.DATE
        ) {
          initialData[field.serviceTypeServiceFieldId] =
            field.dataType === Constant.FIELD_TYPES.CURRENT_COMPANY
              ? (CommonService.isUser() ? CommonService.getCompanyId() : '' )
              : field.dataType === Constant.FIELD_TYPES.CURRENT_USER
              ? (CommonService.isUser() ? CommonService.getUserId() : '' )
              : field.dataType === Constant.FIELD_TYPES.TRANSFER_REQUEST_DROPDOWN
              ? (requestId ? requestId : '' )
              : field.dataType === Constant.FIELD_TYPES.DATE
              ? (serviceTypeName === Constant.CustomerService.OWNERSHIP_TRANSFER 
              ? new Date().toISOString().split("T")[0] : "")
              : "";
        }
      });
      
      setFormData(initialData);
      setErrors(initialError);
      fetchExistingCompanies(CommonService.isUser() ? CommonService.getCompanyId() : '');

      if(serviceTypeName === Constant.CustomerService.PRIVATE_SELL)
        fetchAllActiveAndInactiveCompanies('');

      if(CommonService.isUser() ) {
         setSelectedCompany(CommonService.getCompanyId());
      }
        
      // if service name is Barrel owner Assignment and current user role is USER then fetch owners of selected company
      if((serviceTypeName === Constant.CustomerService.BARREL_OWNER_ASSIGNMENT || serviceTypeName === Constant.CustomerService.BULK_INVENTORY_UPLOAD) && CommonService.isUser())
        fetchOwnersByCompanyId(CommonService.getCompanyId());
    } catch (error) {
      console.log("Error occurred while API calling:", error);
    } finally {
      setServiceFieldLoading(false);
    }
  };

  const fetchExistingCompanies = async (companyId) => {
    try {
      setLoadingCompanies(true); // start loading
      const response = await Service.fetchCompaniesList();
      // const companyId = selectedCompany ? selectedCompany : (CommonService.isUser() ? CommonService.getCompanyId() : '');

      setFilteredCompaniesList(response?.data);
      //exclude this company from the list

      
      const existingCompanies = response.data.filter(
        (company) => company.id !== companyId
      );
      setCompaniesList(existingCompanies);
      if(companyId != '')
        fetchUsersByCurrentCompany(companyId);

      // while redirect from dashboard sell request tab
      if(state?.companyId != undefined)
        handleUserCompanyChange(state?.companyId);
    } catch (error) {
      console.error("Error fetching companies:", error);
    } finally {
      setLoadingCompanies(false); // stop loading after try/catch
    }
  };


  const fetchCarrierList = async () => {
    try {
      const response = await SupportApiService.getCarrierList();
      setCarrierList(response?.data);
      return response?.data; // ⬅️ return it for immediate usage

    } catch(error) {
      console.log("error occurred while api calling " + error);
    }
  }

  const fetchMashBillList = async () => {
    try {
      const response = await SupportApiService.getMashBillList();
      setMashBillList(response?.data);
      return response?.data;

    } catch (error) {
      console.log("Error while loading mash bills", error);
    }
  };

  const fetchFacilityList = async () => {
    try {
      const response = await SupportApiService.getFacilityList();
      setShipFromAddressList(response?.data);
      setShipToAddressList(response?.data);
      return response?.data; // ⬅️ return it for immediate usage

    } catch(error) {
      console.log("error occurred while api calling " + error);
    }
  }


  const fetchAllActiveAndInactiveCompanies = async (companyName: string) => {
    try {
      const response = await Service.getAllActiveAndInactiveCompanies();
      const companyId = selectedCompany ? selectedCompany : (CommonService.isUser() ? CommonService.getCompanyId() : '');
      setActiveInactiveCompaniesList(response?.data);
      //exclude selected company from the list
      const existingCompanies = response.data.filter(
        (company) => company.id !== companyId
      );
      setFilteredActiveInactiveCompaniesList(existingCompanies);
    } catch (error) {
      console.error("Error fetching companies:", error);
    }
  };

  const fetchUsersByCompany = async (companyId: any) => {

    try {
      const response = await Service.fetchUsersList(companyId);
      setUsersList(response.data);
    } catch (error) {
      console.error("Error fetching companies:", error);
    }
  };

  const fetchOwnersByCompanyId = async (companyId:any) => {
    try {
        const response = await Service.fetchOwnerList(companyId);
        setOwnerList(response.data);
      } catch (error) {
        console.error("Error fetching owners:", error);
      }
  }

  const fetchUsersByCurrentCompany = async (companyId) => {

    try {
      const response = await Service.fetchUsersList(
        companyId
      );
      setCurrentCompaniesUserList(response.data);
    } catch (error) {
      console.error("Error fetching companies:", error);
    }
  };

  const handleServiceChange = (serviceId, serviceName,requestId?:any) => {
 
    if(!requestId) {
       setSelectedCompany('');
    }
     
    setEditMode(false);
    if(serviceName === 'Bulk Inventory Upload'){
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }

    if(id) return ;
    setSelectedServiceName(serviceName);
    setSelectedService(serviceId);
    if (serviceId) {
      setFormData((formData) => ({ ...formData, serviceId: serviceId }));
      setFormDataForInventoryUpload({});
      setRequestDescription("");
      setFile(null);
      setFiles([]);
      setSelectedCompanyError("");
      setSearchedInventories([]);
      setSelectedMashBill('');
      setSelectedDsp('');
      setBarrelSource(requestId ? 'Logistic from Existing Request' : 'Manual Barrel Selection');
      setFinalSelectedInventoriesWithBarrels([]);
      setFinalSelectedSelectedSourceToDestinationInventories([]);
      setSearchTerm('');
      setBarrelSearchTerm('');
      setIsInventoryNotFound(false);
      setMashBillInputValue('');
      setFinalSelectedInventoriesWithBarrelsForTabs([]);
      setAdminSelectService(true);
      setShowCompanyDropdown(false);
      setFormDataForTabs({});
      setCommentForTabs({});
      setSelectedCompanies({});
      setTitleError('');
      setSelectedTitle('');
      setTabFiles({});
      setSelectedCompanyErrors({});
      setErrorsForTabs({});
      setShowUserDropdown(false);
      fetchFieldsByServiceType(serviceId, serviceName, requestId ? 'Logistic from Existing Request' : 'Manual Barrel Selection', requestId);
      //set this serviceId into the formData
      if (serviceId) {
        setFormData((formData) => ({ ...formData, serviceId: serviceId }));
      }
      
    } else {
      setFields([]);
      setFormData({});
      setSelectedCompany('');
    }
  };

  const fetchBarrelDestinationList = async (value: any, serviceTypeServiceFieldId: any, tabId? : any) => {
    
    setSearchSelectedInventory(null);
    setErrors((prev) => ({ ...prev, [serviceTypeServiceFieldId]: "" }));
    setErrorsForTabs((prev) => ({
      ...prev,
      [activeTabId]: {
        ...(prev[activeTabId] || {}),
        [serviceTypeServiceFieldId]: "",
      },
    }));

    setSearchTerm(value);

    if(tabId && !selectedCompanies[tabId]) {
        setSelectedCompanyErrors((prev) => ({
        ...prev,
        [tabId]: "Please select company"
      }));
      return;
    }

    if(!tabId && !selectedCompany) {
      setSelectedCompanyError("Please select company");
      setSearchedSourceToDestinationInventory([])
      setSearchSelectedSourceToDestinationInventory(null);
      return ;
     } 

      setIsDestination(false);
      //now create the request object for searching inventory
      const liquidTransferInventorySearchRequestForCustomerService = {
        companyId: tabId ? selectedCompanies[tabId] : selectedCompany,
        query: value?.trim(),
        serviceName: selectedServiceName,
        mashBill: selectedMashBill,
        dsp: selectedDsp,
        inventoryId: selectedBarrelInventoryId,
        customerServiceRequestId: id? id: null,
        isEditMode: isEditMode,
        isSearchingForSellRequest: selectedServiceName == Constant.CustomerService.SELL_REQUEST
      };

      //now call the api which fetched matching inventories
      try {
        const response = await InventoryApiService.searchInventoryForDestination(liquidTransferInventorySearchRequestForCustomerService);
        setSearchedSourceToDestinationInventory(response?.data);
        setSearchSelectedSourceToDestinationInventory(response?.data[0]);

        setIsInventoryNotFound(response?.data?.length > 0 ? false : true);
        setIsDestination(true);

        if (state?.lots?.length) {
          // Process all lots if any exist in LocationState
          selectAllBarrelsForLots(state.lots, response?.data);
        }
      } catch (error) {
        console.log("error while calling the api");
        setIsDestination(false);
      }
  };

  const handleCompanyChange = (value: any, serviceTypeServiceFieldId: any, tabId?:any) => {

    setErrors((prev) => ({ ...prev, [serviceTypeServiceFieldId]: "" }));

    setErrorsForTabs((prev) => ({
      ...prev,
      [tabId]: {
        ...(prev[tabId] || {}), // keep other fields intact
        [serviceTypeServiceFieldId]: "", // clear this specific field error
      },
    }));

    const companyId = value;

    if (tabId) {
      // ✅ if tabId exists → save against tabId logic
      setFormDataForTabs  ((prevFormData) => ({
        ...prevFormData,
        [tabId]: {
          ...(prevFormData[tabId] || {}),
          [serviceTypeServiceFieldId]: value,
        },
      }));
    } else {
      // ✅ existing logic
      setFormData((prevFormData) => ({
        ...prevFormData,
        [serviceTypeServiceFieldId]: value,
      }));
    }

    setFormData((prevFormData) => ({
      ...prevFormData,
      [serviceTypeServiceFieldId]: value,
    }));

    setUsersList([]);

    if(companyId) {
       fetchUsersByCompany(companyId);
    }
  };

  const handleUserCompanyChange = async (value: any) => {
    if (id) return;
    setSelectedCompanyError("");
    const companyId = value;

    //find selected companyName and set
    const selectedCompany = companiesList.find(company => company.id === companyId);
    if(selectedCompany !== undefined) {
      setSelectedCompanyName(selectedCompany.companyName);
    }
    
    //if admin change the company reset the all the inventory details
    setSearchedInventories([]);
    setSearchSelectedInventory(null);
    setFinalSelectedInventoriesWithBarrels([]);
    setSelectedMashBill('');
    setIsInventoryNotFound(false);
    setSelectedDsp('');
    setSearchedSourceToDestinationInventory([]);
    setSearchSelectedSourceToDestinationInventory(null);
    setFinalSelectedSelectedSourceToDestinationInventories([]);

    if(companyId) {
      setSelectedCompany(companyId);
      const existingCompanies = filteredCompaniesList.filter(
        (company) => company.id !== companyId
      );
      setCompaniesList(existingCompanies);

      const existingActiveInactiveCompanies = activeInactiveCompaniesList.filter(
        (company) => company.id !== companyId
      );
      setFilteredActiveInactiveCompaniesList(existingActiveInactiveCompanies);

        const formDataFieldTypes = new Set([
          Constant.FIELD_TYPES.COMPANY_DROPDOWN,
          Constant.FIELD_TYPES.PRIVATE_BUYER_COMPANY,
          Constant.FIELD_TYPES.RADIO,
          Constant.FIELD_TYPES.TEXT,
          Constant.FIELD_TYPES.PRICE,
          Constant.FIELD_TYPES.DATE,
          Constant.FIELD_TYPES.RICH_TEXT,
          Constant.FIELD_TYPES.COMMISSION_FEE,
          Constant.FIELD_TYPES.FEE_TYPE_DROPDOWN,
          Constant.FIELD_TYPES.NUMBER,
          Constant.FIELD_TYPES.SIZE_DROPDOWN,
          Constant.FIELD_TYPES.OWNER_NAME_DROPDOWN,
          Constant.FIELD_TYPES.OWNER_DROPDOWN,
          Constant.FIELD_TYPES.CONTACT_NUMBER,
          Constant.FIELD_TYPES.CARRIER,
          Constant.FIELD_TYPES.TRANSFER_REQUEST_DROPDOWN,
          Constant.FIELD_TYPES.EMAIL,
          Constant.FIELD_TYPES.UPLOAD_FILE, // formData reset in addition to setFile(null)
          Constant.FIELD_TYPES.AGE_START,
          Constant.FIELD_TYPES.AGE_END, 
          Constant.FIELD_TYPES.PROOFING_MIN,
          Constant.FIELD_TYPES.PROOFIND_MAX,
          Constant.FIELD_TYPES.MASH_BILL,
          Constant.FIELD_TYPES.SHIP_FROM_ADDRESS,
          Constant.FIELD_TYPES.SHIP_TO_ADDRESS,
          Constant.FIELD_TYPES.SHIP_FROM_DSP,
          Constant.FIELD_TYPES.SHIP_TO_DSP,
          Constant.FIELD_TYPES.SHIP_FROM_CONTACT,
          Constant.FIELD_TYPES.SHIP_TO_CONTACT,
          Constant.FIELD_TYPES.SHIP_FROM_FACILITY,
          Constant.FIELD_TYPES.SHIP_TO_FACILITY,
        ]);

      fields.forEach((field) => {
        const id = field.serviceTypeServiceFieldId;

        if (formDataFieldTypes.has(field.dataType)) {
          // Do not blank date fields for Ownership Transfer, to preserve existing date
          if (field.dataType === Constant.FIELD_TYPES.DATE && selectedServiceName === Constant.CustomerService.OWNERSHIP_TRANSFER) {
            // preserve existing date —
          } else {
            formData[id] = '';
          }
          errors[id] = '';
        }


        // Handle special cases
        switch (field.dataType) {
          case Constant.FIELD_TYPES.PRIVATE_BUYER_COMPANY:
            errors[id] = '';
            break;

          case Constant.FIELD_TYPES.CARRIER:
            setCarrierInputValue('')
            errors[id] = ''
            break;

          case Constant.FIELD_TYPES.UPLOAD_DOC:
            setFiles(null);
            break;

          case Constant.FIELD_TYPES.UPLOAD_FILE:
            setFile(null);
            break;

          case Constant.FIELD_TYPES.COMMENT:
            setRequestDescription("");
            break;

          case Constant.FIELD_TYPES.ADD_CONTAINER:
          case Constant.FIELD_TYPES.ADD_INVENTORY:
            setSearchTerm("");
            break;

          case Constant.FIELD_TYPES.SOURCE_CONTAINER:
            setSearchTerm("");
            break;

          case Constant.FIELD_TYPES.MASH_BILL:
            setMashBillInputValue(PREFILL_TEMPLATE)
            errors[id] = ''
            break;

          case Constant.FIELD_TYPES.SHIP_FROM_FACILITY:
            setShipFromAddressInputValue('')
            errors[id] = ''
            break;

          case Constant.FIELD_TYPES.SHIP_TO_FACILITY:
            setShipToAddressInputValue('')
            errors[id] = ''
            break;

          default:
            break; // already handled in formDataFieldTypes
        }
      });

      if(selectedServiceName == Constant.CustomerService.LOGISTIC && barrelSource == Constant.BarrelSource.SHIP_BY_UPLOAD_INVENTORY) {

        fieldsForUploadInventory.forEach((field) => {
          if (formDataFieldTypes.has(field.dataType)) {
            formDataForInventoryUpload[field.serviceTypeServiceFieldId] = '';
            errorsForInventoryUpload[field.serviceTypeServiceFieldId] = '';
          } else if (field?.dataType == Constant.FIELD_TYPES.UPLOAD_DOC) {
            setFiles(null);
          } else if (field?.dataType == Constant.FIELD_TYPES.UPLOAD_FILE) {
            setFile(null);
          }           
        })
      }

      if (selectedServiceName == Constant.CustomerService.OWNERSHIP_TRANSFER) {
        fetchUsersByCurrentCompany(companyId);
      } else if (selectedServiceName == Constant.CustomerService.BULK_INVENTORY_UPLOAD || selectedServiceName == Constant.CustomerService.LOGISTIC) {
        fetchUsersByCompany(companyId); 
        fetchOwnersByCompanyId(companyId);
        fetchAllTransferRequests(companyId);
      } else if (selectedServiceName == Constant.CustomerService.BARREL_OWNER_ASSIGNMENT) {
        fetchOwnersByCompanyId(companyId);
      } 
    }
  };

  const autoFillContactFields = (facilityList: any, type: "from" | "to") => {
    const updatedFormData = { ...formData };

    fields.forEach((field: any) => {

      if (type === "from") {
        if (field.fieldName === "Logistic from Facility") {
           updatedFormData[field.serviceTypeServiceFieldId] = facilityList.id;
        }

        if (field.fieldName === "Logistic from Contact") {
          updatedFormData[field.serviceTypeServiceFieldId] =  facilityList.facilityContact;
        }

        if (field.fieldName === "Logistic from Address") {
          updatedFormData[field.serviceTypeServiceFieldId] = facilityList.facilityAddress;
        }

        if (field.fieldName === "Logistic from Contact Phone") {
          const cleanNumber = facilityList.facilityContactPhone?.replace(/\D/g, "") || "";
          updatedFormData[field.serviceTypeServiceFieldId] = cleanNumber;
        }

        if (field.fieldName === "Logistic from Contact Email") {
          updatedFormData[field.serviceTypeServiceFieldId] = facilityList.facilityContactEmail;
        }

        if (field.fieldName === "Logistic from DSP") {
          updatedFormData[field.serviceTypeServiceFieldId] = facilityList.facilityDsp;
        }
      }

      if (type === "to") {

        if (field.fieldName === "Logistic to Facility") {
          updatedFormData[field.serviceTypeServiceFieldId] = facilityList.id;
        }

        if (field.fieldName === "Logistic to Contact") {
          updatedFormData[field.serviceTypeServiceFieldId] =  facilityList.facilityContact;
        }

        if (field.fieldName === "Logistic to Address") {
          updatedFormData[field.serviceTypeServiceFieldId] = facilityList.facilityAddress;
        }

        if (field.fieldName === "Logistic to Contact Phone") {
          const cleanNumber = facilityList.facilityContactPhone?.replace(/\D/g, "") || "";
          updatedFormData[field.serviceTypeServiceFieldId] = cleanNumber;
        }

        if (field.fieldName === "Logistic to Contact Email") {
          updatedFormData[field.serviceTypeServiceFieldId] = facilityList.facilityContactEmail;
        }

        if (field.fieldName === "Logistic to DSP") {
          updatedFormData[field.serviceTypeServiceFieldId] = facilityList.facilityDsp;
        }
      }
    });

    setFormData(updatedFormData);
    setShouldValidate(true);
  };

   const clearAutoFilledFields = (type: "from" | "to") => {

    setFormData((prevFormData) => {
      const updatedFormData = { ...prevFormData };

      fields.forEach((field: any) => {

        if (type === "from") {
          if (
            field.fieldName === "Logistic from Address" ||
            field.fieldName === "Logistic from Contact" ||
            field.fieldName === "Logistic from Contact Phone" ||
            field.fieldName === "Logistic from Contact Email" ||
            field.fieldName === "Logistic from DSP"
          ) {
            updatedFormData[field.serviceTypeServiceFieldId] = "";
          }
        }

        if (type === "to") {
          if (
            field.fieldName === "Logistic to Address" ||
            field.fieldName === "Logistic to Contact" ||
            field.fieldName === "Logistic to Contact Phone" ||
            field.fieldName === "Logistic to Contact Email" ||
            field.fieldName === "Logistic to DSP"
          ) {
            updatedFormData[field.serviceTypeServiceFieldId] = "";
          }
        }

      });
      return updatedFormData;
    });
  };

  const handleUserCompanyChangeForTabs = (value: any, tabId: any) => {

    // Clear error if selecting a value
    if (value) {
      setSelectedCompanyErrors((prev) => ({
        ...prev,
        [tabId]: "",
      }));
    }

    setSelectedCompanies((prev) => ({
      ...prev,
      [tabId]: value || "", // store empty if null
    }));

    // now need update all the field if the company change
    setSearchedInventories([]);
    setSearchSelectedInventory(null);
    setSearchTerm('');
    setSearch('');

    setSearchedSourceToDestinationInventory([]);
    setSearchSelectedSourceToDestinationInventory(null);
    setSearchTerm('');

    // ✅ Clear formData for this tab
    setFormDataForTabs((prev) => {
      const updated = { ...prev };
      delete updated[tabId];
      return updated;
    });

    setFinalSelectedInventoriesWithBarrelsForTabs((prev) => {
      const updated = { ...prev };
      delete updated[tabId];
      return updated;
    });

    setTabFiles((prev) => {
      const updatedFiles = { ...prev };
      updatedFiles[tabId] = []; // clear all docs for this tab
      return updatedFiles;
    });

  };


  const handleUserChange = (value: any, serviceTypeServiceFieldId: any) => {
    setErrors((prev) => ({ ...prev, [serviceTypeServiceFieldId]: "" }));
    const userId = value;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [serviceTypeServiceFieldId]: value,
    }));
  };

  const handleCurrentUserChange = (
    value: any,
    serviceTypeServiceFieldId: any
  ) => {
    setErrors((prev) => ({ ...prev, [serviceTypeServiceFieldId]: "" }));
    // const userId = value;
    // setSelectedCurrentUser(userId);
    setFormData((prevFormData) => ({
      ...prevFormData,
      [serviceTypeServiceFieldId]: value == 'Current user' ? '': value
    }));
  };

  const handleOptionClick = (optionFor: string, selectedOptionId:any, selectedOptionName: string, serviceTypeServiceFieldId: any) => {    
    setErrors((prev) => ({ ...prev, [serviceTypeServiceFieldId]: "" }));
    setFormData((prevFormData) => ({
      ...prevFormData,
      [serviceTypeServiceFieldId]: selectedOptionName,
    }));
    if(optionFor === 'COMPANY'){
        setCompanyInputValue(selectedOptionName);  // Set selected option in the input
        setShowCompanyDropdown(false); // Close the dropdown after selection
        // fetchUsersByCompany(selectedOptionId);// fetch users of selected company
        setFormData((prevFormData) => ({
          ...prevFormData,
          privateBuyerOrgId: selectedOptionId, //selectedCompanyId,
        }));
        setFormData(({ privateBuyerUserId, ...rest }) => rest);  // remove userid from formdata
        // reset private buyer user data when company is changed
        // fields.forEach((field) => {
        //   if(field.fieldName == 'Private Buyer User') {
        //     formData[field.serviceTypeServiceFieldId] = '';
        //   }
        // });
    }else{
        setUserInputValue(selectedOptionName);  // Set selected option in the input
        setShowUserDropdown(false); // Close the dropdown after selection
        setFormData((prevFormData) => ({
          ...prevFormData,
          privateBuyerUserId: selectedOptionId, //selectedUserId,
        }));
    }
  };

  const handlePopupConfirm = async () => {
    setShowPopup(false);
    // User confirmed, proceed with the submission
    await processSubmit();
    setPendingSubmitData(null);
  };

  const redirectToDashboard = async () => {
    if(CommonService.isUser()) {
      history.push('/user/my-warehouse');
    } else {
      history.push(`/master/company-dashboard/${selectedCompany}`);
    }
  }

  const handlePopupCancel = () => {
    setShowPopup(false);
    setPendingSubmitData(null);
    setShowSellRequestEditValidationPopup(false);

    // User cancelled, do nothing
  };

  const handleOptionChange = (optionFor: string, value, serviceTypeServiceFieldId) => {
    setErrors((prev) => ({ ...prev, [serviceTypeServiceFieldId]: "" }));
    setFormData((prevFormData) => ({
      ...prevFormData,
      [serviceTypeServiceFieldId]: value,
    }));
    if(optionFor === 'COMPANY'){
      setCompanyInputValue(value); // Set selected option in the input
      setShowCompanyDropdown(value !== ''); // Close the dropdown after selection
      setUsersList([]);
      //on change company remove selected company id
      setFormData((prevFormData) => {
        const { privateBuyerOrgId, privateBuyerUserId, ...rest } = prevFormData;
        return rest; // returning the rest of the object after removing 'privateBuyerOrgId' and 'privateBuyerUserId'
      });
      // reset private buyer user data when company is changed
      // fields.forEach((field) => {
      //   if(field.fieldName == 'Private Buyer User') {
      //     formData[field.serviceTypeServiceFieldId] = '';
      //   }
      // });
    }else{
      setUserInputValue(value); // Set selected option in the input
      setShowUserDropdown(value !== '');  // Close the dropdown after selection
      setFormData(({ privateBuyerUserId, ...rest }) => rest); //on change company remove selected user id
    }
  };

  const addCompanyAndUserForPrivateSell = async () => {

    setIsLoading(true);
    for (const field of fields) {
      if (field.fieldName === 'Private Buyer Company') {
        // Check if the company needs to be added
        if (formData?.privateBuyerOrgId === undefined) {
          const sanitizedValue = formData[field.serviceTypeServiceFieldId].replace(/[^a-zA-Z0-9]/g, "");
          const email = `${sanitizedValue}@yopmail.com`.toLowerCase(); 

          const requestData = {
            companyEmail: email,
            isActive: true,
            isDelete: false,
            companyName: formData[field.serviceTypeServiceFieldId]
          };
          try {
            // Save company and get the savedCompanyId
            const response = await Service.addCompany(requestData);
            return response.data;
          } catch (error) {
            console.error("Error saving company:", error);
            return; // Exit if the company save fails
          }
        } else {
          return formData?.privateBuyerOrgId;
        }
      }
    }
    setIsLoading(false);
  };

  const checkAndAddNewCarrier = async() => {
    setIsLoading(true);

     for (const field of fields) {
        if (field.fieldName === 'Carrier') {
          
          if(formData[field?.serviceTypeServiceFieldId]) {
            return formData[field?.serviceTypeServiceFieldId];
          }

          if (!carrierInputValue || !carrierInputValue.trim()) {
            setIsLoading(false);
            return null;
          }

          // If typed value matches an existing carrier (case-insensitive), use it directly
          const normalizedInput = carrierInputValue?.trim()?.toLowerCase();
          const existingCarrier = carrierList.find(
            (c: any) => c.name?.trim()?.toLowerCase() === normalizedInput
          );
          if (existingCarrier) {
            return existingCarrier.id;
          }

              const requestData = {
                  name: carrierInputValue
              };

              try {
                const response = await SupportApiService.addCarrier(requestData);
                return response?.data?.id;
              } catch(error) {
                console.log("error occurred while adding new carrier " + error);
          }
        }
     }
     setIsLoading(false);
     return null;
  }

  const checkAndAddNewMashBill = async () => {
    setIsLoading(true);

    try {
        for (const field of fields) {
          if (field.fieldName === "Mash Bill") {

            const res = validateMashbill(mashBillInputValue);
            if (!res.valid) {
              setIsLoading(false);
              return { error: res.error };
            }

            const fieldId = field.serviceTypeServiceFieldId;
            const selectedId = formData[fieldId];

            // only reuse existing ID if text EXACTLY matches dropdown option
            if (selectedId && filteredMashBillOptions.some(m => m.name === selectedId && m.name === mashBillInputValue)) {
              setIsLoading(false);
              return selectedId;
            }

            // otherwise create new mashbill
            const requestData = { name: mashBillInputValue };
            const response = await SupportApiService.addMashBill(requestData);
            setIsLoading(false);
            return response?.data?.id;
          } 
        }
      } catch (e) {
      console.error("error occurred while adding new mash bill", e);
      setIsLoading(false);
      return { error: "Failed to add mashbill" };
    }
    setIsLoading(false);
    return null;
  };

  const checkAndAddNewShipFromFacility = async () => {
  setIsLoading(true);

  let facilityData: any = {
    facilityName: shipFromAddressInputValue
  };

  for (const field of fields) {

    if (field.fieldName === "Logistic from Facility") {
      if (formData[field.serviceTypeServiceFieldId]) {
        setIsLoading(false);
        return formData[field.serviceTypeServiceFieldId];
      }
    }

    if (field.fieldName === "Logistic from Address") {
      facilityData.facilityAddress = formData[field.serviceTypeServiceFieldId];
    }

    if (field.fieldName === "Logistic from Contact") {
      facilityData.facilityContact = formData[field.serviceTypeServiceFieldId];
    }

    if (field.fieldName === "Logistic from Contact Phone") {
      facilityData.facilityContactPhone = formData[field.serviceTypeServiceFieldId];
    }

    if (field.fieldName === "Logistic from Contact Email") {
      facilityData.facilityContactEmail = formData[field.serviceTypeServiceFieldId];
    }

    if (field.fieldName === "Logistic from DSP") {
      facilityData.facilityDsp = formData[field.serviceTypeServiceFieldId];
    }
  }

  if (!facilityData.facilityName?.trim()) {
    setIsLoading(false);
    return null;
  }

  try {
    const response = await SupportApiService.addFacility(facilityData);
    return response?.data?.id;
  } catch (error) {
    console.log("error occurred while adding new ship from facility " + error);
  }

  setIsLoading(false);
};

const checkAndAddNewShipToFacility = async () => {
  setIsLoading(true);

  let facilityData: any = {
    facilityName: shipToAddressInputValue
  };

  for (const field of fields) {

    if (field.fieldName === "Logistic to Facility") {
      if (formData[field.serviceTypeServiceFieldId]) {
        setIsLoading(false);
        return formData[field.serviceTypeServiceFieldId];
      }
    }

    if (field.fieldName === "Logistic to Address") {
      facilityData.facilityAddress = formData[field.serviceTypeServiceFieldId];
    }

    if (field.fieldName === "Logistic to Contact") {
      facilityData.facilityContact = formData[field.serviceTypeServiceFieldId];
    }

    if (field.fieldName === "Logistic to Contact Phone") {
      facilityData.facilityContactPhone = formData[field.serviceTypeServiceFieldId];
    }

    if (field.fieldName === "Logistic to Contact Email") {
      facilityData.facilityContactEmail = formData[field.serviceTypeServiceFieldId];
    }

    if (field.fieldName === "Logistic to DSP") {
      facilityData.facilityDsp = formData[field.serviceTypeServiceFieldId];
    }
  }

  if (!facilityData.facilityName?.trim()) {
    setIsLoading(false);
    return null;
  }

  try {
    const response = await SupportApiService.addFacility(facilityData);
    return response?.data?.id;
  } catch (error) {
    console.log("error occurred while adding new ship to facility " + error);
  }

  setIsLoading(false);
};


  const handleRequestDescriptionChange = (
    value: any,
    serviceTypeServiceFieldId: any
  ) => {
    setErrors((prev) => ({ ...prev, [serviceTypeServiceFieldId]: "" }));
    setRequestDescription(value);
  };


  const handleRequestDescriptionChangeForTabs = (
    value: any,
    serviceTypeServiceFieldId: any,
    tabId: any
  ) => {
    // clear error for that field on that tab
    setErrors((prev) => {
      const tabErrors = prev[tabId] || {};
      return {
        ...prev,
        [tabId]: { ...tabErrors, [serviceTypeServiceFieldId]: "" },
      };
    });

    // set request description for that tab
    setCommentForTabs((prev) => ({
      ...prev,
      [tabId]: value,
    }));
  };

  const handleSellRequestFeeChange = (
    value: any,
    serviceTypeServiceFieldId: any
  ) => {
    setErrors((prev) => ({ ...prev, [serviceTypeServiceFieldId]: "" }));
    setSellRequestFee(value);
  };

  // const handleSellRequestFeeTypeChange = (
  //   value: any,
  //   serviceTypeServiceFieldId: any
  // ) => {
  //   setErrors((prev) => ({ ...prev, [serviceTypeServiceFieldId]: "" }));
  //   setSellRequestFeeType(value);
  // };

  const handleInventoryChange = (
    value: any,
    serviceTypeServiceFieldId: any
  ) => {
    setErrors((prev) => ({ ...prev, [serviceTypeServiceFieldId]: "" }));

    const inventoryId = value;
    setSelectedInventory(inventoryId);
  };

  const handleCkeditorContentChange = (value: string, serviceTypeServiceFieldId: string) => {
    const cleanedValue = value.trim() === "<p>&nbsp;</p>" ? "" : value;
  
    setErrors((prev) => ({ ...prev, [serviceTypeServiceFieldId]: "" }));
  
    setFormData((prevFormData) => ({
      ...prevFormData,
      [serviceTypeServiceFieldId]: cleanedValue,
    }));
  };
  
  const handleFieldChange = (value, serviceTypeServiceFieldId) => {
    setErrors((prev) => ({ ...prev, [serviceTypeServiceFieldId]: "" }));

    let processedValue = value;
    const field = fields.find((item) => item.fieldName === 'Owner Name');
    const radioValue = fields.find((item) => item.serviceTypeServiceFieldId === serviceTypeServiceFieldId);

    //owner name not greater then 500 length
    if(field !== undefined){
      if(processedValue.trim().length > 500){
        setOwnerNameError("Owner Name can't greater then 500 characters.");
        return;
      } else {
        setOwnerNameError(""); // Clear error if within limit
      }
    }

    if (isEditMode && originalRequestData?.dynamicFields?.length > 0) {
      
      const restrictedFields = ["Add Re-Containerization?", "Add Logistic Request?","Add Blending?"];
      const originalField = originalRequestData.dynamicFields.find((f) => f.id === serviceTypeServiceFieldId);

      if (originalField && restrictedFields.includes(originalField.fieldName)) {
        const originalVal = originalField.value === "true" ? true : originalField.value === "false" ? false : originalField.value;
        const newVal = value === "yes" ? true : value === "no" ? false : value;

        if (originalVal !== newVal) {
          setErrors((prev) => ({
            ...prev,
            [serviceTypeServiceFieldId]: "Please handle this request manually.",
          }));

          setFormData((prev) => ({
            ...prev,
            [serviceTypeServiceFieldId]: originalVal,
          }));
        }
      }
    }

    // Convert "yes"/"no" to true/false
    if (value === "yes") {
        processedValue = true;
        if(radioValue.fieldName === 'Does the company own the uploaded inventory?'){
            setIsDisabled(true);
            if(isEditMode) {
              fetchEditExistingCompanies().then(({ selectedCompanyName }) => {
                setFormData((prevFormData) => ({
                  ...prevFormData,
                  [field?.serviceTypeServiceFieldId]: CommonService.isUser()
                    ? CommonService.getCompanyName()
                    : selectedCompanyName || "",
                }));
              }).catch((error) => {
                console.error("Error fetching companies:", error);
              });
            } else {
              setFormData((prevFormData) => ({
                ...prevFormData,
                [field?.serviceTypeServiceFieldId]: CommonService.isUser() ? CommonService.getCompanyName() : selectedCompanyName
              }));
            } 
          setErrors((prev) => ({ ...prev, [field?.serviceTypeServiceFieldId]: "" })); 
        } 
      } else if (value === "no") {
        processedValue = false;
        if(radioValue.fieldName === 'Does the company own the uploaded inventory?'){
          setIsDisabled(false);
          setFormData((prevFormData) => ({
            ...prevFormData,
            [field?.serviceTypeServiceFieldId]: ''
          })); 
        } 
    }

    // FIX: prevent boolean from showing in TEXT input
    if (radioValue?.dataType === Constant.FIELD_TYPES.TEXT &&typeof processedValue === "boolean") {
      processedValue = processedValue ? "yes" : "no";
    }

    setFormData((prevFormData) => ({
      ...prevFormData,
      [serviceTypeServiceFieldId]: processedValue,
    }));
  };

  const handleInventoryUploadFieldChange = (value: any, serviceTypeServiceFieldId: string) => {
    // clear error for the current field
    setErrorsForInventoryUpload((prev) => ({
      ...prev,
      [serviceTypeServiceFieldId]: "",
    }));

    let processedValue = value;
    const field = fieldsForUploadInventory.find((item) => item.fieldName === "Owner Name");
    const radioValue = fieldsForUploadInventory.find(
      (item) => item.serviceTypeServiceFieldId === serviceTypeServiceFieldId
    );

    // owner name not greater than 500 chars
    if (field !== undefined) {
      if (processedValue.trim().length > 500) {
        setOwnerNameError("Owner Name can't be greater than 500 characters.");
        return;
      } else {
        setOwnerNameError(""); // clear error if within limit
      }
    }

    // convert yes/no → boolean
    if (value === "yes") {
      processedValue = true;

      if (radioValue?.fieldName === "Does the company own the uploaded inventory?") {
        setOwnerDropdownDisabled(true);
          setFormDataForInventoryUpload((prev) => ({
            ...prev,
            [field?.serviceTypeServiceFieldId as string]: CommonService.isUser()
              ? CommonService.getCompanyName()
              : selectedCompanyName,
          }));
    
        setErrorsForInventoryUpload((prev) => ({
          ...prev,
          [field?.serviceTypeServiceFieldId as string]: "",
        }));
      }
    } else if (value === "no") {
      processedValue = false;

      if (radioValue?.fieldName === "Does the company own the uploaded inventory?") {
        setOwnerDropdownDisabled(false);

        setFormDataForInventoryUpload((prev) => ({
          ...prev,
          [field?.serviceTypeServiceFieldId as string]: "",
        }));
      }
    }

    // update field data
    setFormDataForInventoryUpload((prev) => ({
      ...prev,
      [serviceTypeServiceFieldId]: processedValue,
    }));
  };


  const isValidInventoryUploadFields = () => {
    let isValid = true;

    const newErrors: Record<string, string> = {};

    fieldsForUploadInventory.forEach((field) => {
      if (field.mandatory) {
       
        if (field.dataType === Constant.FIELD_TYPES.RADIO) {
          if (formDataForInventoryUpload[field.serviceTypeServiceFieldId] === "" || formDataForInventoryUpload[field.serviceTypeServiceFieldId] === undefined) { 
              newErrors[field.serviceTypeServiceFieldId] = "This field is required";
              isValid = false;
          } else {
              delete newErrors[field.serviceTypeServiceFieldId]; // Remove validation if valid
          }
        } else if (field.dataType === Constant.FIELD_TYPES.UPLOAD_FILE) {
          if (!formDataForInventoryUpload[field.serviceTypeServiceFieldId] || formDataForInventoryUpload[field.serviceTypeServiceFieldId]?.length === 0) {
            newErrors[field.serviceTypeServiceFieldId] = "Please upload csv or xlsx file.";
            isValid = false;
          }
        }
       
        // check if for other dynamic fields
        else if (!formDataForInventoryUpload[field.serviceTypeServiceFieldId]) {
          newErrors[field.serviceTypeServiceFieldId] = "error";
          isValid = false;
        }

      }
    });

    setErrorsForInventoryUpload(newErrors);
    return isValid;
  };

  const handleFieldChangeForTabs = (value: any, serviceTypeServiceFieldId: any, tabId: any) => {

    setErrorsForTabs((prev) => ({
      ...prev,
      [tabId]: {
        ...(prev[tabId] || {}), // keep other fields intact
        [serviceTypeServiceFieldId]: "", // clear this specific field error
      },
    }));
    
    setFormDataForTabs((prev) => ({
      ...prev,
      [tabId]: {
        ...prev[tabId],
        [serviceTypeServiceFieldId]: value,
      },
    }));
  };

  const isValidateForTabs = () => {
    let isValid = true;

    const newErrors: Record<string, Record<string, string>> = {};

    fields.forEach((field) => {
      if (field.mandatory) {
        // first check if the data type is add_inventory or ADD_CONTAINER
        if (
          field.dataType === Constant.FIELD_TYPES.ADD_INVENTORY ||
          field.dataType === Constant.FIELD_TYPES.ADD_CONTAINER ||
          field.dataType === Constant.FIELD_TYPES.SOURCE_CONTAINER
        ) { 
          if (!finalSelectedInventoriesWithBarrelForTabs[activeTabId] || finalSelectedInventoriesWithBarrelForTabs[activeTabId]?.length <= 0) {
            newErrors[activeTabId] = newErrors[activeTabId] || {};
            newErrors[activeTabId][field.serviceTypeServiceFieldId] = "error";
            isValid = false;
          }
        } else if (
          !formDataForTabs[activeTabId] ||
          !formDataForTabs[activeTabId][field.serviceTypeServiceFieldId]
        ) {
          newErrors[activeTabId] = newErrors[activeTabId] || {};
          newErrors[activeTabId][field.serviceTypeServiceFieldId] = "error";
          isValid = false;
        } 
      }
    });

    if (CommonService.isAdmin() && !selectedCompanies[activeTabId]) {
      setSelectedCompanyErrors((prev) => ({
        ...prev,
        [activeTabId]: "Please select company",
      }));
      isValid = false;
    }

    if (!selectedTitle || selectedTitle.length == 0) {
      setTitleError("error");
      isValid = false;
    }

    setErrorsForTabs(newErrors);
    return isValid;
  };


  const ALIASES = { 
    corn: "corn", c: "corn",
    rye: "rye", r: "rye",
    wheat: "wheat", w: "wheat",
    char: "char", ch: "char",
    maltedbarley: "malted barley", "malted barley": "malted barley", m: "malted barley"
  };

  function validateMashbill(input) {
    if (!input || String(input).trim().length === 0) {
      return { valid: false, error: "Mashbill cannot be empty" };
    }

    let clean = String(input)
      .toLowerCase()
      .replace(/,/g, " ")
      .replace(/%/g, "")
      .trim();

    // REMOVE any leading words (e.g. "Ethimex")
    clean = clean.replace(/^[a-z\s]+(?=\d)/i, "").trim();

    // Detect shortcut: 70/18/0/12
    if (/^[\d.]+\s*\/\s*[\d.]+\s*\/\s*[\d.]+\s*\/\s*[\d.]+$/.test(clean)) {
      const parts = clean.split("/").map(n => parseFloat(n.trim()));
      const total = parts.reduce((a, b) => a + b, 0);
      const roundedTotal = Math.round(total * 100) / 100;
      // if (roundedTotal !== 100) {
      //   return { valid: false, error: `Total must be 100 but got ${roundedTotal}` };
      // }

      return { valid: true };
    }

    // ---- original parsing logic here ----
    const tokens = clean.split(/\s+/);
    let total = 0;

    for (let i = 0; i < tokens.length; ) {
      const num = parseFloat(tokens[i]);
      if (isNaN(num)) {
        return { valid: false, error: `Invalid format near: "${tokens[i]}"` };
      }
      i++;

      const grainParts = [];
      while (i < tokens.length && isNaN(parseFloat(tokens[i]))) {
        grainParts.push(tokens[i]);
        i++;
      }

      if (grainParts.length === 0) {
        return { valid: false, error: `Missing ingredient after ${num}` };
      }

      const grainKey = grainParts.join("").replace(/\s+/g, "");
      // if (!ALIASES[grainKey]) {
      //   return { valid: false, error: `Please Valid format of Mash Bill` };
      // }
      if (grainKey.length < 2) { 
        return { valid: false, error: `Invalid ingredient name: "${grainKey}"` };
      }

      total += num;
    }
    // const finalTotal = Math.round(total * 100) / 100;

    // if (total !== 100) {
    //   return { valid: false, error: `Total must be 100 but got ${finalTotal}` };
    // }

    return { valid: true };
  }

  const isValidate = async () => {
    let isValid = true;

    const newErrors: Record<string, string> = {};

    fields.forEach((field) => {
      if (field.mandatory) {
        // Relax validations for Logistics requests only during initial creation, only validating creation fields
        const isLogisticCreationField = selectedServiceName === Constant.CustomerService.LOGISTIC 
        && (originalRequestData?.status === Constant.CustomerServiceRequestStatus.PENDING_REVIEW || !id) && (
          field.dataType === Constant.FIELD_TYPES.ADD_INVENTORY ||
          field.dataType === Constant.FIELD_TYPES.ADD_CONTAINER ||
          field.dataType === Constant.FIELD_TYPES.SOURCE_CONTAINER ||
          field.dataType === Constant.FIELD_TYPES.LOGISTIC_TYPE_DROPDOWN ||
          field.dataType === Constant.FIELD_TYPES.DATE ||
          field.dataType === Constant.FIELD_TYPES.UPLOAD_FILE
        );

        if ((!id || originalRequestData?.status === Constant.CustomerServiceRequestStatus.PENDING_REVIEW) && selectedServiceName === Constant.CustomerService.LOGISTIC && !isLogisticCreationField) {
          return;
        }

        //first check if the data type is add_inventory or price
        //if (field.dataType === Constant.FIELD_TYPES.ADD_INVENTORY || field.dataType === Constant.FIELD_TYPES.ADD_CONTAINER || field.dataType === Constant.FIELD_TYPES.SOURCE_CONTAINER ||  errors[field.serviceTypeServiceFieldId]) {
        if (field.dataType === Constant.FIELD_TYPES.ADD_INVENTORY || field.dataType === Constant.FIELD_TYPES.ADD_CONTAINER || field.dataType === Constant.FIELD_TYPES.SOURCE_CONTAINER) {
          if (((field.dataType === Constant.FIELD_TYPES.ADD_INVENTORY || field.dataType === Constant.FIELD_TYPES.ADD_CONTAINER || field.dataType === Constant.FIELD_TYPES.SOURCE_CONTAINER) &&
              (finalSelectedInventoriesWithBarrels?.length <= 0 ||
              !finalSelectedInventoriesWithBarrels.some(inventory => 
                inventory.barrelNumbers.some(barrel => barrel.isBarrelSold !== true)
          )))) {
            newErrors[field.serviceTypeServiceFieldId] = "error"
            isValid = false;
          }

        } else if (field.dataType === Constant.FIELD_TYPES.RADIO) {
          if (formData[field.serviceTypeServiceFieldId] === "" || formData[field.serviceTypeServiceFieldId] === undefined) { 
              newErrors[field.serviceTypeServiceFieldId] = "This field is required";
              isValid = false;
          } else {
              delete newErrors[field.serviceTypeServiceFieldId]; // Remove validation if valid
          }
        } else if (field.dataType === Constant.FIELD_TYPES.UPLOAD_FILE) {
          if (!formData[field.serviceTypeServiceFieldId] || formData[field.serviceTypeServiceFieldId]?.length === 0) {
            newErrors[field.serviceTypeServiceFieldId] = "Please upload csv or xlsx file.";
            isValid = false;
          }
        } else if (field.dataType === Constant.FIELD_TYPES.UPLOAD_DOC) {
          if ((selectedServiceName == Constant.CustomerService.BARREL_HEAD_PAINTING || selectedServiceName == Constant.CustomerService.TASTING || selectedServiceName == Constant.CustomerService.BARREL_REPAIR_REQUEST) && !id && (!files || files?.length == 0)) {
            newErrors[field.serviceTypeServiceFieldId] = "This field is required";
            isValid = false;
          }
        } else if(field.dataType == Constant.FIELD_TYPES.CONTACT_NUMBER) {
          if(formData[field.serviceTypeServiceFieldId]?.trim()?.length != 10) {
            newErrors[field.serviceTypeServiceFieldId] = errors[field.serviceTypeServiceFieldId] ? errors[field.serviceTypeServiceFieldId]: "This field is required";
            isValid = false; 
          }
        }

        else if(field.dataType == Constant.FIELD_TYPES.CARRIER) {
          if(!carrierInputValue || carrierInputValue?.trim()?.length < 1) {
            newErrors[field.serviceTypeServiceFieldId] = errors[field.serviceTypeServiceFieldId] ? errors[field.serviceTypeServiceFieldId]: "This field is required";
            isValid = false; 
          }
        }

        else if (field.dataType === Constant.FIELD_TYPES.MASH_BILL) {
          // 1. empty check
          if (!mashBillInputValue || mashBillInputValue.trim().length < 1) {
            newErrors[field.serviceTypeServiceFieldId] = "This field is required";
            isValid = false;
            return;  // stop here
          }

          // 2. validation check
          const res = validateMashbill(mashBillInputValue);
          if (!res.valid) {
            newErrors[field.serviceTypeServiceFieldId] = res.error;
            isValid = false;
         }
        }           
 
        else if(field.dataType == Constant.FIELD_TYPES.SHIP_FROM_FACILITY) {
          if(!shipFromAddressInputValue || shipFromAddressInputValue?.trim()?.length < 1) {
            newErrors[field.serviceTypeServiceFieldId] = errors[field.serviceTypeServiceFieldId] ? errors[field.serviceTypeServiceFieldId]: "This field is required";
            isValid = false; 
          }
        }

        else if(field.dataType == Constant.FIELD_TYPES.SHIP_TO_FACILITY) {
          if(!shipToAddressInputValue || shipToAddressInputValue?.trim()?.length < 1) {
            newErrors[field.serviceTypeServiceFieldId] = errors[field.serviceTypeServiceFieldId] ? errors[field.serviceTypeServiceFieldId]: "This field is required";
            isValid = false; 
          }
        }

        else if(field.fieldName == Constant.Field.RECEIVING_COMPANY) {
          const sanitize = (str: string) =>str.toLowerCase().replace(/[^a-zA-Z0-9]/gi, "");

          if(!formData[field.serviceTypeServiceFieldId]){
              newErrors[field.serviceTypeServiceFieldId] = "error";
              isValid = false;
          } else if(sanitize(formData[field.serviceTypeServiceFieldId]) == sanitize(getCompanyNameById(selectedCompany))){
              setReceivingCompanyError("Receiving company not same as origin company");
              isValid = false;
          } else {
              setReceivingCompanyError("");
          }
        }

        else if(field.dataType == Constant.FIELD_TYPES.EMAIL) {
          if(!validateEmail(formData[field.serviceTypeServiceFieldId])) {
            newErrors[field.serviceTypeServiceFieldId] = errors[field.serviceTypeServiceFieldId] ? errors[field.serviceTypeServiceFieldId]: "This field is required";
            isValid = false; 
          }
        }

        /*else if(field.dataType == Constant.FIELD_TYPES.LOGISTIC_TYPE_DROPDOWN) {
          if(formData[field.serviceTypeServiceFieldId]?.trim()?.length != 10) {
            newErrors[field.serviceTypeServiceFieldId] = errors[field.serviceTypeServiceFieldId] ? errors[field.serviceTypeServiceFieldId]: "This field is required";
            isValid = false; 
          }
        }*/

        else if(field.dataType == Constant.FIELD_TYPES.LOGISTIC_TYPE_DROPDOWN) {
          if(!formData[field.serviceTypeServiceFieldId]) {
            newErrors[field.serviceTypeServiceFieldId] = "This field is required";
            isValid = false; 
          }
        }

        // check if for other dynamic fields
        else if (!formData[field.serviceTypeServiceFieldId]) {
          newErrors[field.serviceTypeServiceFieldId] = "error";
          isValid = false;
        }

        else if(field.dataType == Constant.FIELD_TYPES.PRIVATE_BUYER_COMPANY) {
          if(!validatePrivateBuyerDetail(formData[field.serviceTypeServiceFieldId])){
            newErrors[field.serviceTypeServiceFieldId] = "Please enter valid detail";
            isValid = false; 
          }else if(formData['privateBuyerOrgId'] === selectedCompany) {
            newErrors[field.serviceTypeServiceFieldId] = "The buyer's company is not the same as the owner's company.";
            isValid = false; 
          }else if(!formData[field.serviceTypeServiceFieldId]){
            newErrors[field.serviceTypeServiceFieldId] = "error";
            isValid = false;
          }else if(showCompanyDropdown && filteredCompanyOptions.length > 0){
            newErrors[field.serviceTypeServiceFieldId] = `Please select an option`;
            isValid = false;
          }
        } 

        /*else if(field.dataType == Constant.FIELD_TYPES.PRIVATE_BUYER_USER) {
          if(!validatePrivateBuyerDetail(formData[field.serviceTypeServiceFieldId])){
            newErrors[field.serviceTypeServiceFieldId] = "Please enter valid detail";
            isValid = false; 
          }else if(showUserDropdown && filteredUserOptions.length > 0){
            newErrors[field.serviceTypeServiceFieldId] = `Please select an option`;
            isValid = false;
          }
        }*/

      }
    });

    if(CommonService.isAdmin() && !selectedCompany) {
      setSelectedCompanyError("Please select company");
      isValid = false;
    }

    if(selectedServiceName == Constant.CustomerService.LOGISTIC && barrelSource == Constant.BarrelSource.SHIP_BY_UPLOAD_INVENTORY) {
      if(!await isValidInventoryUploadFields()) {
        isValid = false;
      }
    }

    if(id && selectedServiceName == Constant.CustomerService.CUSTOM_SAMPLE_REQUEST && (!selectedTitle || selectedTitle?.trim()?.length <= 0)) {
      setTitleError("This field is required");
      isValid = false;
    }

    if (hasBarrelValidationError) {
      isValid = false;
    }

    if (openPopupForBarrelId !== null) {
      return false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const updateUploadedInventoryStatus = async (currentStatus:any) => {

    //before updating the status need to submit ship request
    const id = await processSubmit();
    const updatedStatus = { ...currentStatus, shipBarrelsRequestId: id };

    try {
      // Call the long-running API
      const statusResponse =
        await SupportApiService.updateCustomerServiceRequestStatus(
          updatedStatus
        );

      // Show success message after the API call completes
      CommonService.Toast.fire({
        title: "Your request is being processed. This may take a few moments.",
        icon: "success",
      });

      //if everything is good then redirect to listing page
      history.push(`/${CommonService.isAdmin() ? 'master' : 'user'}/customer-service`);
    } catch (error) {
      // Handle any errors that occur during the API call
      CommonService.Toast.fire({
        title:
          "An error occurred while processing your request. Please try again later.",
        icon: "error",
      });
    } 
  }

  const handleTitleChange = (e:any) => {
    setTitleError('');
    setSelectedTitle(e.target.value);
  }

  const handleRequestWithTabs = async (e) => {
    e.preventDefault();

    if (await isValidateForTabs()) {

      setIsLoading(true);

      const requestsPayload = Object.keys(formDataForTabs).map((tabId) => {
        const tabFormData = formDataForTabs[tabId] || {};

        const dynamicFields = Object.keys(tabFormData)
          .filter((key) => key !== "undefined" && key !== "")
          .map((key) => {
            const field = fields.find(
              (f) => f.serviceTypeServiceFieldId === key
            );
            if (field) {
              return {
                id: key,
                fieldName: field.fieldName,
                value: tabFormData[key],
              };
            }
            return null;
          })
          .filter(Boolean);

        return {
          tempId: tabId,
          dynamicFields,
          selectedCompanyId: selectedCompanies[tabId] || null,
          selectedUserId: CommonService.getUserId(),
          selectedServiceId: selectedService,
          customerServiceRequestId: id ? id : null,
          comment: commentForTabs?.[tabId] || "",
          ownerName: ownerName,
          finalSelectedInventoriesWithBarrels:
          finalSelectedInventoriesWithBarrelForTabs[tabId] || [],
          tempPath: "",
          selectedTitle: selectedTitle
        };
      });

      // Build FormData
      const formData = new FormData();

      // add JSON requests payload
      // Fix 1: Ensure the Blob's type is explicitly 'application/json' and part name matches backend
      formData.append(
        "requests", // This name MUST match @RequestPart("requests")
        new Blob([JSON.stringify(requestsPayload)], { type: "application/json" })
      );

      // add files per tab (keyed by files_<tabId>)
      Object.keys(tabFiles).forEach((tabId) => {
        const filesForTab = tabFiles[tabId] || [];
        filesForTab.forEach((file) => {
          // Fix 2: Ensure the file part name matches backend expectation (e.g., files_123, files_456)
          formData.append(`files_${tabId}`, file);
        });
      });

      try {
        const response = await SupportApiService.saveCustomSampleRequest(formData);
        setIsLoading(false);
        CommonService.Toast.fire({
            title: `Request Submitted Successfully`,
            icon: "success",
        });
       
        const linkPrefix = CommonService.isAdmin() ? "/master" : "/user";
        history.push(`${linkPrefix}/customer-service`);
    
      } catch(error) {
        console.log("error occurred while api calling "+ error);
        setIsLoading(false);
      }
    }
  };

  const getDescriptionValue = async () => {
    const descriptionField = fields.find(field => field.fieldName == 'Description');
    return formData[descriptionField.serviceTypeServiceFieldId];
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!(await isValidate())) return;

    // Handle conflicting container check
    if (selectedServiceName === Constant.CustomerService.BARREL_OWNER_ASSIGNMENT) {
      const hasConflictingBarrels = await checkForConflictingBarrels();
      if (hasConflictingBarrels) {
        setPendingSubmitData(e);
        setShowPopup(true);
        return;
      }
    }

    // Handle creation of dependent service requests
    let shipmentStatus = false;
    const isNewRequest = !id;
    const isBlendingOrBottlingOrDumping =
      selectedServiceName === Constant.CustomerService.BLENDING_REQUEST ||
      selectedServiceName === Constant.CustomerService.BOTTLING_REQUEST ||
      selectedServiceName === Constant.CustomerService.DUMPING_REQUEST;

    if (isNewRequest && isBlendingOrBottlingOrDumping) {
      const addReBarrelingField = fields.find(
        (f) => f?.fieldName === "Add Re-Containerization?"
      );
      const addShipmentField = fields.find(
        (f) => f?.fieldName === "Add Logistic Request?"
      );
      const addBlendingField = fields.find(
        (f) => f?.fieldName === "Add Blending?"
      );

      if (formData[addShipmentField?.serviceTypeServiceFieldId] === true) {
        shipmentStatus = true;
        setCreateShipment(true);
      }

      // Helper for creating service requests like Re-Barreling or Blending
      const createServiceRequest = async (serviceName) => {
        const service = services.find((s) => s.serviceName === serviceName);

        if (!service) return;

        try {
          const response = await Service.getFieldByServiceType(service.id);
          const filteredFields = response.data.filter(
            (f) =>
              f.dataType !== Constant.FIELD_TYPES.COMMENT &&
              f.dataType !== Constant.FIELD_TYPES.ADD_CONTAINER &&
              f.dataType !== Constant.FIELD_TYPES.SOURCE_CONTAINER
          );

          const dynamicFields = await Promise.all(
            filteredFields.map(async (field) => ({
              id: field.serviceTypeServiceFieldId,
              fieldName: field.fieldName,
              value:
                field.fieldName === "Description"
                  ? await getDescriptionValue()
                  : false,
            }))
          );

          const requestData = {
            dynamicFields,
            selectedCompanyId: selectedCompany,
            selectedUserId: CommonService.getUserId(),
            selectedInventoryId: selectedInventory,
            selectedServiceId: service.id,              
            customerServiceRequestId: null,
            comment: requestDescription,
            barrelSource: null,
            price,
            quantity,
            ownerName,
            selectedTitle: null,
            finalSelectedInventoriesWithBarrels,
            finalSelectedSourceToDestinationInventories,
            tempPath: "",
          };

          const formPayload = new FormData();
          formPayload.append(
            "param",
            new Blob([JSON.stringify(requestData)], {
              type: "application/json",
            })
          );

          setIsLoading(true);
          await Service.saveCustomerSupportRequest(formPayload);
        } catch (error) {
          console.error(`Error creating ${serviceName} request:`, error);
        } finally {
          setIsLoading(false);
        }
      };

      // Conditionally create sub-requests
      /*if (formData[addReBarrelingField?.serviceTypeServiceFieldId] === true) {
        await createServiceRequest("Re-Barreling");
      }
      if (formData[addBlendingField?.serviceTypeServiceFieldId] === true) {
        await createServiceRequest("Blending Request");
      }*/

      // Sub-requests for Blending Request
      if (
        selectedServiceName === Constant.CustomerService.BLENDING_REQUEST &&
        formData[addReBarrelingField?.serviceTypeServiceFieldId] === true) {
        await createServiceRequest("Re-Containerization");
      }

      // Sub-requests for Bottling Request
      if (
        selectedServiceName === Constant.CustomerService.BOTTLING_REQUEST &&
        formData[addBlendingField?.serviceTypeServiceFieldId] === true) {
        await createServiceRequest("Blending Request");
      }

      // Sub-requests for Dumping Request
      if (selectedServiceName === Constant.CustomerService.DUMPING_REQUEST) {
        if (formData[addBlendingField?.serviceTypeServiceFieldId] === true) {
          await createServiceRequest("Blending Request");
        }
        if (formData[addReBarrelingField?.serviceTypeServiceFieldId] === true) {
          await createServiceRequest("Re-Containerization");
        }
      }
    }

     // Final process (Inventory upload or normal submit)
    const isShipmentUpload =
      selectedServiceName === Constant.CustomerService.LOGISTIC &&
      barrelSource === Constant.BarrelSource.SHIP_BY_UPLOAD_INVENTORY;

    await (isShipmentUpload
      ? processInventoryUpload()
      : processSubmit(shipmentStatus));
  };

  const processSubmit = async (shipmentStatus?:any) => {
    let companyId;
    let carrierId;
    let mashBillId;
    let shipFromFacilityId;
    let shipToFacilityId;

    if(selectedServiceName == Constant.CustomerService.PRIVATE_SELL){
        companyId = await addCompanyAndUserForPrivateSell();
        if (!companyId) {
          console.error("Company creation or retri,eval failed");
          return;
        }
    }

    if(selectedServiceName == Constant.CustomerService.LOGISTIC) {
      carrierId = await checkAndAddNewCarrier();
      shipFromFacilityId = await checkAndAddNewShipFromFacility();
      shipToFacilityId = await checkAndAddNewShipToFacility();
    }

    if (selectedServiceName == Constant.CustomerService.WANTED_TO_BUY) {
      const mashBillId = await checkAndAddNewMashBill();
      if(!mashBillId) {
        console.error("Error while adding new carrier")
        return;
      }
    }

    const dynamicFields = Object.keys(formData)
        .filter(key => key !== 'undefined' && key !== '')  // Remove undefined or empty keys
        .map((key) => {
          const field = fields.find(f => f.serviceTypeServiceFieldId === key);

          if (field && field.fieldName == 'Private Buyer Company') {
            return {
              id: key,
              fieldName: field.fieldName,  // Get fieldName from fields array
              value: companyId
            };
          } else if (field && field.fieldName == 'Carrier') {

            return {
              id: key,
              fieldName: field.fieldName,
              value: carrierId
            }
          } else if (field && field.fieldName == 'Mash Bill') {
            return {
              id: key,
              fieldName: field.fieldName,
              value: getFilteredMashBillValue(mashBillInputValue)
            };
          } else if (field && field.fieldName == 'Logistic from Facility') {

            return {
              id: key,
              fieldName: field.fieldName,
              value: shipFromFacilityId
            }
          } else if (field && field.fieldName == 'Logistic to Facility') {

            return {
              id: key,
              fieldName: field.fieldName,
              value: shipToFacilityId
            }
          } else if (field) {
            return {
              id: key,
              fieldName: field.fieldName,  // Get fieldName from fields array
              value: formData[key]
            };
          }
          return null; // Explicitly return null for unmatched fields
        })
        .filter(Boolean);

      // Add Carrier if it's missing this is only for Logistic service
      if(selectedServiceName === Constant.CustomerService.LOGISTIC) {
        if (!dynamicFields.some(df => df.fieldName === 'Carrier')) {
          const carrierField = fields.find(f => f.fieldName === 'Carrier');
          if (carrierField) {
            dynamicFields.push({
              id: carrierField.serviceTypeServiceFieldId,
              fieldName: carrierField.fieldName,
              value: carrierId
            });
          }
        }

        if (!dynamicFields.some(df => df.fieldName === 'Logistic from Facility')) {
          const shipFromField = fields.find(f => f.fieldName === 'Logistic from Facility');
          if (shipFromField) {
            dynamicFields.push({
              id: shipFromField.serviceTypeServiceFieldId,
              fieldName: shipFromField.fieldName,
              value: shipFromFacilityId
            });
          }
        }

         if (!dynamicFields.some(df => df.fieldName === 'Logistic to Facility')) {
          const shipToField = fields.find(f => f.fieldName === 'Logistic to Facility');
          if (shipToField) {
            dynamicFields.push({
              id: shipToField.serviceTypeServiceFieldId,
              fieldName: shipToField.fieldName,
              value: shipToFacilityId
            });
          }
        }
      }

      // Prepare the object to send
      /*const requestData = {
        dynamicFields,
        selectedCompanyId: selectedCompany,
        selectedUserId: CommonService.getUserId(),
        selectedInventoryId: selectedInventory,
        selectedServiceId: selectedServiceName === Constant.CustomerService.LIQUID_TRANSFER ? selectedChildService : selectedService,
        parentServiceTypeIds: selectedServiceName === Constant.CustomerService.LIQUID_TRANSFER ? selectedService : [],
        customerServiceRequestId : id ? id : null,
        comment: requestDescription,
        barrelSource: selectedServiceName == Constant.CustomerService.LOGISTIC ? barrelSource : null,
        price: price,
        quantity: quantity,
        ownerName: ownerName,
        selectedTitle: (id && selectedServiceName == Constant.CustomerService.CUSTOM_SAMPLE_REQUEST) ? selectedTitle : null,
        finalSelectedInventoriesWithBarrels,
        tempPath:'',
      };*/

      let destinationCompanyId;
      //for ownership transfer request need to extract company Id
      if(selectedServiceName == Constant.CustomerService.OWNERSHIP_TRANSFER && CommonService.isAdmin()) {
        const newCompanyField = dynamicFields.find(
            (f) => f.fieldName === "New Company"
        );
        destinationCompanyId = newCompanyField?.value;
      } 

      const requestData = {
        dynamicFields,
        selectedCompanyId: selectedCompany,
        destinationCompanyId: destinationCompanyId,
        selectedUserId: CommonService.getUserId(),
        selectedInventoryId: selectedInventory,
        selectedServiceId: selectedService,
        customerServiceRequestId: id || null,
        comment: requestDescription,
        barrelSource: selectedServiceName === Constant.CustomerService.LOGISTIC ? barrelSource : null,
        price,
        quantity,
        ownerName,
        selectedTitle: (id && selectedServiceName == Constant.CustomerService.CUSTOM_SAMPLE_REQUEST) ? selectedTitle : null,
        finalSelectedInventoriesWithBarrels: finalSelectedInventoriesWithBarrels,
        tempPath: "",
      };

      const serviceRequestData = new FormData();
      
      if (selectedServiceName != Constant.CustomerService.LOGISTIC && files) {
        Array.from(files).forEach((file) => {
          serviceRequestData.append("file[]", file);
        });
      }
      
      if (selectedServiceName != Constant.CustomerService.LOGISTIC && file) {
        serviceRequestData.append("file", file);
      }

      serviceRequestData.append(
        "param",
        new Blob([JSON.stringify(requestData)], {
          type: "application/json",
        })
      );

      // Log the form data to the console
      setIsLoading(true);
      setValidationsList([]);


      if (id && selectedServiceName === Constant.CustomerService.SELL_REQUEST) {
        const normalizeFields = (fields) =>
          fields
            ?.filter(
              (field) =>
                field.fieldName !== "Fee Type" &&
                field.fieldName !== "Commission Fee"
            ).map((field) => ({
              ...field,
              value: String(field.value)?.trim(),
            }));

        const extractComparableData = (data) =>
        data?.map((inv) => ({
          lotNo: inv.lotNo,
          productName: inv.productName,
          barrelNumbers: inv.barrelNumbers
            .map((barrel) => ({
              barrelId: barrel.barrelId,
            }))
            .sort((a, b) => a.barrelId.localeCompare(b.barrelId)),
        }))
        .sort((a, b) => a.lotNo.localeCompare(b.lotNo)); // Optional: sort inventory list too

        const normalizedOriginalFields = normalizeFields(originalRequestData.dynamicFields);
        const normalizedCurrentFields = normalizeFields(requestData.dynamicFields);

        const isDataUnchanged =
          (JSON.stringify(normalizedOriginalFields) === JSON.stringify(normalizedCurrentFields)) && (JSON.stringify(extractComparableData(requestData?.finalSelectedInventoriesWithBarrels)) === JSON.stringify(extractComparableData(originalSelectedInventoryBarrels))) && (JSON.stringify(requestData?.comment) === JSON.stringify(originalRequestData?.comment));

        if (isDataUnchanged) {
          CommonService.Toast.fire({
            title: "No changes detected. Nothing to update.",
            icon: "warning",
          });
          setIsLoading(false);
          return;
        } 
      }

    try {
        const response = await Service.saveCustomerSupportRequest(
          serviceRequestData
        );
        const id = response.data;
          
        if (CommonService.isAdmin() && isAdminSelectService && selectedServiceName === 'Bulk Inventory Upload' && isEditMode === false) {

          const currentStatus = {
            customerServiceRequestId: id,
            serviceName: "Bulk Inventory Upload",
            reason: "",
            status: "UPLOADED",
            spendHourOnRequest: null,
            companyId: selectedCompany,
            userId: CommonService.getUserId(),
            dynamicFields: dynamicFields || [],
          };
        
          try {
            // Call the long-running API
            const statusResponse = await SupportApiService.updateCustomerServiceRequestStatus(currentStatus);
          
            // Show success message after the API call completes
            CommonService.Toast.fire({
              title: "Your Container is being uploaded and will be available shortly.",
              icon: "success",
            });

            const linkPrefix = CommonService.isAdmin() ? "/master" : "/user";
            history.push(`${linkPrefix}/customer-service`);

          } catch (error) {
            // Handle any errors that occur during the API call
            CommonService.Toast.fire({
              title: "An error occurred while uploading your Container. Please try again later.",
              icon: "error",
            });
          }
          return id;
        } else {
          // Show the general success message only if the admin condition is not met
          CommonService.Toast.fire({
            title: `Request ${requestData.customerServiceRequestId ? "Updated" : "Submitted"} Successfully`,
            icon: "success",
          });
        }
        
        setIsLoading(false);

        //if(response.data == true){
        if(response.data != null && response.data != undefined ) {
          if(!shipmentStatus || (selectedServiceName != Constant.CustomerService.BLENDING_REQUEST && selectedServiceName != Constant.CustomerService.BOTTLING_REQUEST && selectedServiceName != Constant.CustomerService.DUMPING_REQUEST)) {
            const linkPrefix = CommonService.isAdmin() ? "/master" : "/user";
            history.push(`${linkPrefix}/customer-service`);
          } else {
            const shipBarrelData = services.find(
              (s) => s.serviceName == "Logistic"
            );
            await fetchAllTransferRequests(selectedCompany);
            handleServiceChange(shipBarrelData.id, shipBarrelData.serviceName, id)
          }
        } 

        return id;
      } catch (error) {
        setIsLoading(false);

        if (error.response) {
        // The backend error message should be inside error.response.data.message

        const errorMessage =
          error?.response?.data?.errorMessage || "Failed to upload CSV";

        // Show the error in a toaster
        if (error?.response?.data?.data != null && errorMessage.includes("Error occurred while validating")) {
          CommonService.Toast.fire({
            title: "Please Upload a valid file",
            icon: "error",
          });

          setValidationsList(error?.response?.data?.data);
          setIsValidated(true);
        } else if (errorMessage.includes("Invalid Csv File")) {
          CommonService.Toast.fire({
            title: "Please Upload a valid CSV file",
            icon: "error",
          });
        } else if (errorMessage.includes("Excel file")) {
          CommonService.Toast.fire({
            title: "Please Upload a valid excel file",
            icon: "error",
          });
        } else if (errorMessage.includes("UNSUPPORTED_MEDIA_TYPE")) {
          CommonService.Toast.fire({
            title: "Please select a valid inventory file format either CSV or Excel (XLSX). You can add non-CSV or non-Excel files as supporting documents.",
            icon: "error",
          });
        } else if(errorMessage.includes("PENDING_REQUESTS") || errorMessage.includes("REQUEST_CANCELLED") || errorMessage.includes("ALREADY_SOLD")) {
            setSellRequestEditValidationType(errorMessage);
            setShowSellRequestEditValidationPopup(true);
        }
        else {
          CommonService.Toast.fire({
            title: errorMessage,
            icon: "error",
          });
        }
      } else {
        // Handle errors without a response (e.g., file locked, network issues)
        console.error("Error without response:", error.message);
      
        if (error.message.includes("Failed to fetch")) {
          CommonService.Toast.fire({
            title: "Network error occurred. Please check your internet connection and try again.",
            icon: "error",
          });
        } else if (error.message.includes("File is locked")) {
          CommonService.Toast.fire({
            title: "Please close the file in Excel or any other program before uploading.",
            icon: "error",
          });
        } else if (error.message.includes("Cannot read properties of null")) {
          CommonService.Toast.fire({
            title: "Invalid file reference. Please select the file again and submit.",
            icon: "error",
          });
        } else {
          CommonService.Toast.fire({
            title: "Unexpected error occurred. Please try again.",
            icon: "error",
          });
        }
      }
      }
  }

  const processInventoryUpload = async () => {
   
      const dynamicFields = Object.keys(formDataForInventoryUpload)
        .filter(key => key !== 'undefined' && key !== '')  // Remove undefined or empty keys
        .map((key) => {
          const field = fieldsForUploadInventory.find(f => f.serviceTypeServiceFieldId === key);

         if (field) {
            return {
              id: key,
              fieldName: field.fieldName,  // Get fieldName from fields array
              value: formDataForInventoryUpload[key]
            };
          }
          return null; // Explicitly return null for unmatched fields
        })
        .filter(Boolean);


      // Prepare the object to send
      const requestData = {
        dynamicFields,
        selectedCompanyId: selectedCompany,
        selectedUserId: CommonService.getUserId(),
        selectedInventoryId: selectedInventory,
        selectedServiceId: inventoryUploadService.id,
        customerServiceRequestId : null,
        barrelSource: null,
        comment: "",
        price: price,
        quantity: quantity,
        ownerName: ownerName,
        finalSelectedInventoriesWithBarrels,
        tempPath:'',
      };

      const serviceRequestData = new FormData();
      if (files) {
        Array.from(files).forEach((file) => {
          serviceRequestData.append("file[]", file);
        });
      }
      
      if (file) {
        serviceRequestData.append("file", file);
      }

      serviceRequestData.append(
        "param",
        new Blob([JSON.stringify(requestData)], {
          type: "application/json",
        })
      );

      // Log the form data to the console
      setIsLoading(true);
      setValidationsList([]);

    try {
        const response = await Service.saveCustomerSupportRequest(serviceRequestData);
        const id = response.data;

          const currentStatus = {
            customerServiceRequestId: id,
            serviceName: "Bulk Inventory Upload",
            reason: "",
            status: "UPLOADED",
            spendHourOnRequest: null,
            companyId: selectedCompany,
            userId: CommonService.getUserId(),
            dynamicFields: dynamicFields || [],
          };

          await updateUploadedInventoryStatus(currentStatus);
        
      } catch (error) {
        setIsLoading(false);

        if (error.response) {
        // The backend error message should be inside error.response.data.message

        const errorMessage =
          error?.response?.data?.errorMessage || "Failed to upload CSV";

        // Show the error in a toaster
        if (error?.response?.data?.data != null && errorMessage.includes("Error occurred while validating")) {
          CommonService.Toast.fire({
            title: "Please Upload a valid file",
            icon: "error",
          });

          setValidationsList(error?.response?.data?.data);
          setIsValidated(true);
        } else if (errorMessage.includes("Invalid Csv File")) {
          CommonService.Toast.fire({
            title: "Please Upload a valid CSV file",
            icon: "error",
          });
        } else if (errorMessage.includes("Excel file")) {
          CommonService.Toast.fire({
            title: "Please Upload a valid excel file",
            icon: "error",
          });
        } else if (errorMessage.includes("UNSUPPORTED_MEDIA_TYPE")) {
          CommonService.Toast.fire({
            title: "Please select a valid inventory file format either CSV or Excel (XLSX). You can add non-CSV or non-Excel files as supporting documents.",
            icon: "error",
          });
        } else if(errorMessage.includes("PENDING_REQUESTS") || errorMessage.includes("REQUEST_CANCELLED") || errorMessage.includes("ALREADY_SOLD")) {
            setSellRequestEditValidationType(errorMessage);
            setShowSellRequestEditValidationPopup(true);
        }
        else {
          CommonService.Toast.fire({
            title: errorMessage,
            icon: "error",
          });
        }
      } else {
        // Handle errors without a response (e.g., file locked, network issues)
        console.error("Error without response:", error.message);
      
        if (error.message.includes("Failed to fetch")) {
          CommonService.Toast.fire({
            title: "Network error occurred. Please check your internet connection and try again.",
            icon: "error",
          });
        } else if (error.message.includes("File is locked")) {
          CommonService.Toast.fire({
            title: "Please close the file in Excel or any other program before uploading.",
            icon: "error",
          });
        } else if (error.message.includes("Cannot read properties of null")) {
          CommonService.Toast.fire({
            title: "Invalid file reference. Please select the file again and submit.",
            icon: "error",
          });
        } else {
          CommonService.Toast.fire({
            title: "Unexpected error occurred. Please try again.",
            icon: "error",
          });
        }
      }
    }
  }

  const checkForConflictingBarrels = async () => {
    // 1. Extract all barrelIds from finalSelectedInventoriesWithBarrels
    const barrelIds = finalSelectedInventoriesWithBarrels
      .flatMap((inventory) => inventory.barrelNumbers || [])
      .map((barrel) => barrel.barrelId)
      .filter(Boolean); // remove null/undefined

    if (barrelIds.length === 0) return false;

    try {
      // 2. Call your API to get conflict count
      const response = await InventoryApiService.fetchBarrelOwnerConflictCount(
        barrelIds
      );
      setConflictCount(response.data);

      if (response.data > 0) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error("Error checking for conflicting container:", error);
      return false;
    }
  };


  const handleQuantityChange = (
    quantity: any,
    serviceTypeServiceFieldId: any
  ) => {
    setErrors((prev) => ({ ...prev, [serviceTypeServiceFieldId]: "" }));

    const value = Number(quantity);
    setQuantity(value);
  };

  const handlePriceChange = (price: any, serviceTypeServiceFieldId: any) => {
    setErrors((prev) => ({ ...prev, [serviceTypeServiceFieldId]: "" }));

    const value = Number(price);
    setPrice(value);
  };

  const handleNumberOnBlur = (value: any, serviceTypeServiceFieldId: any) => {
    const numValue = Number(value);
    if (numValue <= 0 || !value) {
      setErrors((prev) => ({ ...prev, [serviceTypeServiceFieldId]: "error" }));
    }
  };

  const handleNumberOnBlurForTabs = (value: any, serviceTypeServiceFieldId: any, tabId:any) => {
    const numValue = Number(value);
    if (numValue <= 0 || !value) {
      setErrors((prev) => ({ ...prev, [serviceTypeServiceFieldId]: "error" }));
    }
  };

  const handleSellRequestFeeOnBlur = (value: any, serviceTypeServiceFieldId: any) => {
    const numValue = Number(value);
    if (numValue < 0 || !value) {
      setErrors((prev) => ({ ...prev, [serviceTypeServiceFieldId]: "error" }));
    }
  };

  const handleFieldBlur = (value: any, serviceTypeServiceFieldId: any) => {
    if (!value || value == null || value?.trim() == "") {
      setErrors((prev) => ({ ...prev, [serviceTypeServiceFieldId]: "error" }));
    }
  };

   const handleDateBlur = (value: any, serviceTypeServiceFieldId: any) => {

    const today = new Date(CommonService.getTodayInTimeZone());
    const selectedDate = new Date(value);
    today.setHours(0, 0, 0, 0);
    selectedDate.setHours(0, 0, 0, 0);

    const newErrors = { ...errors };

    if (!value || value == null || value?.trim() == "") {
      newErrors[serviceTypeServiceFieldId] = "This field is required";
    } else if (selectedDate < today) {
      newErrors[serviceTypeServiceFieldId] = selectedServiceName == Constant.CustomerService.OWNERSHIP_TRANSFER ? "Ownership transfer date cannot be in the past.": "Date cannot be in the past";
    } else {
      delete newErrors[serviceTypeServiceFieldId];
    }

    setErrors(newErrors);
  };

  const handleEmailBlur = (value: any, serviceTypeServiceFieldId: any) => {
    if (!value || value == null || value?.trim() == "") {
      setErrors((prev) => ({ ...prev, [serviceTypeServiceFieldId]: "This field is required" }));
    }

    else if(!validateEmail(value?.trim())) {
      setErrors((prev) => ({ ...prev, [serviceTypeServiceFieldId]: "Please enter valid email" }));
    }
  }

  const handleContactBlur = (value: any, serviceTypeServiceFieldId: any) => {
    if (!value || value == null || value?.trim() == "") {
      setErrors((prev) => ({ ...prev, [serviceTypeServiceFieldId]: "This field is required" }));
    }

    else if(value?.trim()?.length != 10) {
      setErrors((prev) => ({ ...prev, [serviceTypeServiceFieldId]: "Please enter valid contact number" }));
    }
  }

  const handleCompanyBlur = (serviceTypeServiceFieldId: any, tabId?: any) => {
    let value;

    if (tabId) {
      value = formData[tabId]?.[serviceTypeServiceFieldId];
    } else {
      value = formData[serviceTypeServiceFieldId];
    }

    if (!value) {
      setErrors((prev) => ({
        ...prev,
        [serviceTypeServiceFieldId]: "error",
      }));
    }
  };

  const handleInventoryBlur = (serviceTypeServiceFieldId: any) => {
    if (!selectedInventory) {
      setErrors((prev) => ({ ...prev, [serviceTypeServiceFieldId]: "error" }));
    }
  };

  const handleUserBlur = (serviceTypeServiceFieldId: any) => {
    if (!formData[serviceTypeServiceFieldId]) {
      setErrors((prev) => ({ ...prev, [serviceTypeServiceFieldId]: "error" }));
    }
  };

  const handleSellRequestFeeTypeBlur = (serviceTypeServiceFieldId: any) => {
    if (!sellRequestFeeType || sellRequestFeeType.length == 0) {
      setErrors((prev) => ({ ...prev, [serviceTypeServiceFieldId]: "error" }));
    }
  };

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      color: state.data.value === 'add_owner' ? '#496673' : provided.color,
      borderTop: state.data.value === 'add_owner' ? '1px solid #ccc' : 'none',
      paddingTop: state.data.value === 'add_owner' ? '10px' : provided.paddingTop,
      paddingInline: '5px',
      cursor: state.data.value === 'add_owner' ? 'pointer' : 'default',
    }),
  };

  // Main owner options
  const ownerOptions = ownerList.map((owner) => {
    const label = owner.email
      ? `${owner.ownerName} (${owner.email})`
      : owner.ownerName;

    return {
      label,
      value: owner.ownerName,
    };
  });

  // Conditionally append "Add New Owner" option if user is of type 'User'
  const options = CommonService.isUser()
    ? [
        ...ownerOptions,
        {
          value: 'add_owner',
          label: 'Add New Owner',
        },
      ]
    : ownerOptions;

  const formatOptionLabel = ({ value, label }) => {
    if (value === "add_owner") {
      return (
        <div style={{ display: "flex", alignItems: "center" }}>
          <AddOutlinedIcon style={{ marginRight: "5px" }} />
          {label}
        </div>
      );
    }
    return label;
  };

  const handleSearchInventory = async (
    value: any,
    serviceTypeServiceFieldId: any,
    tabId? : any
  ) => {
    // handleFieldChange(value,serviceTypeServiceFieldId);
    setSearchSelectedInventory(null);
    setErrors((prev) => ({ ...prev, [serviceTypeServiceFieldId]: "" }));
    setErrorsForTabs((prev) => ({
      ...prev,
      [activeTabId]: {
        ...(prev[activeTabId] || {}), // keep other fields intact
        [serviceTypeServiceFieldId]: "", // clear this specific field error
      },
    }));

    setSearchTerm(value);

    if(tabId && !selectedCompanies[tabId]) {
        setSelectedCompanyErrors((prev) => ({
        ...prev,
        [tabId]: "Please select company"
      }));
      return;
    }

    if(!tabId && !selectedCompany) {
      setSelectedCompanyError("Please select company");
      setSearchedInventories([]);
      setSearchSelectedInventory(null);
      return ;
     } 

      setIsSearch(true);
      setIsDestination(false);

      //now create the request object for searching inventory
      const inventorySearchRequestForCustomerService = {
        companyId: tabId ? selectedCompanies[tabId] : selectedCompany,
        query: value?.trim(),
        serviceName: selectedServiceName,
        mashBill: selectedMashBill,
        dsp: selectedDsp,
        inventoryId: selectedBarrelInventoryId,
        customerServiceRequestId: id? id: null,
        isEditMode: isEditMode,
        isSearchingForSellRequest: selectedServiceName == Constant.CustomerService.SELL_REQUEST
      };

      //now call the api which fetched matching inventories
      try {
        const response = await InventoryApiService.searchInventory(inventorySearchRequestForCustomerService);
        setSearchedInventories(response?.data);
        setSearchSelectedInventory(response?.data[0]);

        setIsInventoryNotFound(response?.data?.length > 0 ? false : true);
        setIsSearch(false);
        setIsDestination(true);

        if (state?.lots?.length) {
          // Process all lots if any exist in LocationState
          selectAllBarrelsForLots(state.lots, response?.data);
        }
      } catch (error) {
        console.log("error while calling the api");
        setIsSearch(false);
        setIsDestination(true);
      }
  };

  const validateEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePrivateBuyerDetail = (value: string): boolean => {
    const alphaNumericRegex = /[a-zA-Z]/;
    return alphaNumericRegex.test(value);
  };

  
  const filteredBarrelNumbers = searchSelectedInventory
    ? searchSelectedInventory.barrelNumbers
        .filter((barrel) =>
          barrel?.barrelNumber?.toLowerCase().includes(barrelSearchTerm?.toLowerCase())
        )
        .filter((barrel) =>
          managedByWhitedogFilter === 'managed' ? barrel.isManagedByWhitedog === true : true
        )
    : [];

  const filteredSearchedInventories = searchedInventories.map(inventory => {
    if (managedByWhitedogFilter === 'all') return inventory;
    
    // Don't modify barrelNumbers here - just check if this lot HAS any managed barrels
    const hasManagedBarrels = inventory.barrelNumbers.some(
      barrel => barrel.isManagedByWhitedog === true
    );
    
    if (!hasManagedBarrels) return null; // hide lot entirely
    
    return inventory; // ← return FULL inventory, not filtered one
  }).filter(Boolean);

  // Filter barrel numbers based on search term
  const filteredDestinationBarrelNumbers = searchSelectedSourceToDestinationInventory
    ? searchSelectedSourceToDestinationInventory.destinationBarrelNumberResponse.filter((barrel) =>
        barrel?.barrelNumber?.toLowerCase()
          .includes(destinationBarrelSearchTerm?.toLowerCase())
      )
    : [];

   const handleSelectAllBarrels = async () => {
     const { lotNo, title, mashBill, dsp, inventoryId, ownerName, producer, description, containerType } =
       searchSelectedInventory;

     // Filter container that are not sold
     const readyToSellBarrelsInSource = filteredBarrelNumbers.filter(
       (barrel) => barrel.isBarrelSold !== true
     );

     // Get unsold container already selected in finalSelectedInventoriesWithBarrels
     const selectedUnsoldBarrels =
       finalSelectedInventoriesWithBarrels
         .find((inv) => inv.lotNo === lotNo)
         ?.barrelNumbers?.filter((barrel) => barrel.isBarrelSold !== true) ||
       [];

     const isAllSelected =selectedUnsoldBarrels.length === readyToSellBarrelsInSource.length;

     if (isAllSelected) {

       setSelectedBarrels([]);

       let newInventoryList = [];

       await setFinalSelectedInventoriesWithBarrels((prev) => {
         const updated = prev
           .map((inventory) => {
             if (inventory.lotNo === lotNo) {
               const soldBarrels = inventory.barrelNumbers.filter(
                 (barrel) => barrel.isBarrelSold === true
               );

               if (soldBarrels.length === 0) {
                 return null;
               }

               return {
                 ...inventory,
                 barrelNumbers: soldBarrels,
               };
             }

             return inventory;
           })
           .filter(Boolean);

         newInventoryList = updated; // capture updated value for use outside
         return updated;
       });

       if (
         selectedServiceName === "Private Sale" ||
         selectedServiceName === "Sell Request" ||
         selectedServiceName === "Ownership Transfer"
       ) {
         resetAttributesIfEmpty(newInventoryList.length);
       }
     } else {
       // ✅ Only include unsold container
       const selectedBarrelsForCurrentLot = filteredBarrelNumbers
         .filter((barrel) => barrel.isBarrelSold !== true)
         .map((barrel) => ({
           barrelNumber: barrel.barrelNumber,
           barrelId: barrel.barrelId,
           row: barrel.row,
           depth: barrel.depth,
           height: barrel.height,
           proof: barrel?.proof,
           proofGallons: barrel?.proofGallons,
           volume: barrel?.volume,
           containerType: barrel?.containerType
         }));

       // ✅ Only set unsold container as selected
       const unsoldBarrels = filteredBarrelNumbers.filter(
         (barrel) => barrel.isBarrelSold !== true
       );
       setSelectedBarrels(unsoldBarrels);

       setFinalSelectedInventoriesWithBarrels((prev) => {

         const updatedInventories = prev
           .map((inventory) => {
             if (inventory.lotNo === lotNo) {
               const soldBarrels = inventory.barrelNumbers.filter(
                 (barrel) => barrel.isBarrelSold === true
               );
               return soldBarrels.length > 0
                 ? { ...inventory, barrelNumbers: soldBarrels }
                 : null;
             }
             return inventory;
           })
           .filter(Boolean);

         // Combine with the unsold container
         const mergedInventory = updatedInventories.find(
           (inv) => inv.lotNo === lotNo
         );
         if (mergedInventory) {
           // Lot already exists, merge new Container
           mergedInventory.barrelNumbers = [
             ...mergedInventory.barrelNumbers,
             ...selectedBarrelsForCurrentLot,
           ];
         } else {
           // Lot doesn't exist, push new one
           updatedInventories.push({
             lotNo: lotNo,
             productName: title,
             mashBill: mashBill,
             dsp: dsp,
             producer: producer,
             description: description,
             barrelNumbers: selectedBarrelsForCurrentLot,
             containerType: containerType,
           });
         }

         // Set attributes if empty
         if (
           (selectedDsp === "" || selectedBarrelInventoryId === "") &&
           (selectedServiceName === "Private Sale" ||
             selectedServiceName === "Sell Request" ||
             selectedServiceName === "Ownership Transfer")
         ) {
           updateAttributesIfEmpty(dsp, mashBill, inventoryId);
         }

         setOwnerName(ownerName);

         return [...updatedInventories];
       });
     }
   };

  const handleRandomSelection = (value: any) => {
    setDesiredQuantity(value);

    if (debounceTimeout) {
      clearTimeout(debounceTimeout); // Clear any existing debounce timeout
    }

    const timeoutId = setTimeout(() => {
      // Exit if the input is empty
      if (!value || value.trim().length === 0) {
        // Clear selections if the input is cleared
        setSelectedBarrels([]);

        setFinalSelectedInventoriesWithBarrels(
          (prev) =>
            prev
              .map((inv) => {
                if (inv.lotNo === searchSelectedInventory.lotNo) {
                  // Keep only sold Container
                  const soldBarrels = inv.barrelNumbers.filter(
                    (barrel) => barrel.isBarrelSold === true
                  );

                  // If there are any sold Container, keep the lot with only sold ones
                  if (soldBarrels.length > 0) {
                    return {
                      ...inv,
                      barrelNumbers: soldBarrels,
                    };
                  }

                  // Otherwise, remove the lot
                  return null;
                }

                // Keep other lots unchanged
                return inv;
              })
              .filter(Boolean) // Remove null entries
        );

        return;
      }

      const quantity = parseInt(value, 10);
      const { lotNo, title, mashBill, dsp, inventoryId, ownerName, producer, description, containerType } =
        searchSelectedInventory;

      // Filter Container that are available to be selected (not sold)
      const readyToSellBarrels = filteredBarrelNumbers.filter(
        (barrel) => barrel.isBarrelSold !== true
      );

      if (quantity > 0 && quantity <= readyToSellBarrels.length) {

        // Shuffle the list of available Container and take the desired quantity
        const randomBarrels = [...readyToSellBarrels]
          .sort(() => 0.5 - Math.random()) // Shuffle the array
          .slice(0, quantity) // Take the first 'quantity' items
          .map((barrel) => ({
            barrelNumber: barrel.barrelNumber,
            barrelId: barrel.barrelId,
            row: barrel.row,
            depth: barrel.depth,
            height: barrel.height,
            proof: barrel?.proof,
            proofGallons: barrel?.proofGallons,
            volume: barrel?.volume,
            containerType: barrel?.containerType
          }));

        // Update the UI to show the current random selection
        setSelectedBarrels(randomBarrels);

        // --- STATE UPDATE LOGIC REFACTORED TO MATCH THE REFERENCE ---
        setFinalSelectedInventoriesWithBarrels((prev) => {
          // Find any container from this lot in the previous state that are already sold
          const existingSoldBarrels =
            prev
              .find((inv) => inv.lotNo === lotNo)
              ?.barrelNumbers?.filter(
                (barrel) => barrel.isBarrelSold === true
              ) || [];

          // Create the new combined list of container for this lot
          const updatedBarrelList = [...existingSoldBarrels, ...randomBarrels];

          // Remove the old entry for this lot from the previous state
          const otherInventories = prev.filter((inv) => inv.lotNo !== lotNo);

          // Set attributes if they haven't been set yet for relevant services
          if (
            (selectedDsp === "" || selectedBarrelInventoryId === "") &&
            (selectedServiceName === "Private Sale" ||
              selectedServiceName === "Sell Request" ||
              selectedServiceName === "Ownership Transfer")
          ) {
            updateAttributesIfEmpty(dsp, mashBill, inventoryId);
          }
          setOwnerName(ownerName);

          // Return the other inventories plus the newly updated inventory for this lot
          return [
            ...otherInventories,
            {
              lotNo: lotNo,
              productName: title,
              mashBill: mashBill,
              dsp: dsp,
              producer: producer,
              description: description,
              barrelNumbers: updatedBarrelList,
              containerType: containerType,
            },
          ];
        });
      } else {
        CommonService.Toast.fire({
          title: `Please enter a number between 1 and ${readyToSellBarrels.length}`,
          icon: "error",
        });
      }
    }, 500); // 500ms debounce delay

    setDebounceTimeout(timeoutId); // Save the new debounce timeout
  };

  const formatVolume = (value) => {
    if (!Number.isFinite(value)) return 0;
    return parseFloat(value.toFixed(2));
  };

  const roundToPrecision = (num, decimals = 2) => {
    return Math.round(num * Math.pow(10, decimals)) / Math.pow(10, decimals);
  };

  // ---------------- HANDLE DONE ----------------
  const handleDone = () => {
    const updatedErrors: Record<string, boolean> = {};
    let hasError = false;

    // 1 Validate volumes
    finalSelectedSourceToDestinationInventories.forEach(inv => {
      inv.destinationBarrelNumberResponse.forEach(b => {
        const value =
          barrelVolumes?.[b.sourceBarrelId]?.[b.barrelId];

        if (value === undefined || value === "" || Number(value) <= 0) {
          updatedErrors[b.barrelId] = true;
          hasError = true;
        }
      });
    });

    // 2 Capacity validation (THIS WAS MISSING)
    const hasCapacityError = Object.values(barrelCapacityErrors).some(Boolean);

    // 3 Still call handleSelectDestinationBarrel (KEEP AS IS)
    finalSelectedSourceToDestinationInventories.forEach(inv => {
      inv.destinationBarrelNumberResponse.forEach(b => {
        handleSelectDestinationBarrel(
          b.barrelNumber,
          b.sourceBarrelId,
          b.sourceBarrelNumber
        );
      });
    });

    // 4 If error → keep popup open
    if (hasError || hasCapacityError) {
      setBarrelErrors(updatedErrors);
      setHasBarrelValidationError(true); 
      return;
    }

    // 5 No error → close popup
    setBarrelErrors({});
    setHasBarrelValidationError(false);
    setOpenPopupForBarrelId(null);
  };


  // ---------------- HANDLE UN-SELECT DESTINATION BARREL ----------------
  const handleUnselectDestinationBarrel = (destinationBarrelId, sourceBarrelId) => {
    // 1 Remove from selected destination inventories
    setFinalSelectedSelectedSourceToDestinationInventories(prev => {
      const copy = structuredClone(prev);

      copy.forEach(inv => {
        inv.destinationBarrelNumberResponse =
          inv.destinationBarrelNumberResponse?.filter(
            b =>
              !(
                b.barrelId === destinationBarrelId &&
                b.sourceBarrelId === sourceBarrelId
              )
          );
      });

      // Remove empty inventory groups
      return copy.filter(
        inv => inv.destinationBarrelNumberResponse?.length > 0
      );
    });

    // 2 Remove from source container mapping
    setFinalSelectedInventoriesWithBarrels(prev => {
      const sourceCopy = structuredClone(prev);

      return sourceCopy.map(inv => ({
        ...inv,
        barrelNumbers: inv.barrelNumbers.map(barrel => {
          if (barrel.barrelId !== sourceBarrelId) return barrel;

          return {
            ...barrel,
            finalSelectedDestinationInventoriesRequest:
              barrel.finalSelectedDestinationInventoriesRequest
                ?.map(destInv => ({
                  ...destInv,
                  destinationBarrelNumberResponse:
                    destInv.destinationBarrelNumberResponse.filter(
                      b => b.barrelId !== destinationBarrelId
                    )
                }))
                .filter(d => d.destinationBarrelNumberResponse.length > 0)
          };
        })
      }));
    });

    // 3 Reset input value
    setBarrelVolumes(prev => {
      const copy = { ...prev };
      if (copy[sourceBarrelId]) {
        delete copy[sourceBarrelId][destinationBarrelId];
      }
      return copy;
    });

    // 4 Clear validation error
    setBarrelErrors(prev => {
      const copy = { ...prev };
      delete copy[destinationBarrelId];
      return copy;
    });
  };

  // ---------------- HANDLE SELECT DESTINATION CONTAINER ----------------
  const handleSelectDestinationBarrel = (barrelNumber, sourceBarrelId, sourceBarrelNumber) => {
    if (!searchedSourceToDestinationInventory) {
      CommonService.Toast.fire({
        title: "Please select an inventory first",
        icon: "error",
      });
      return;
    }

    // Flatten all container with their lot info
    const allDestinationBarrels = searchedSourceToDestinationInventory
      .flatMap(inv => inv.destinationBarrelNumberResponse.map(barrel => ({
        ...barrel, lotNo: inv.lotNo, productName: inv.title, mashBill: inv.mashBill, dsp: inv.dsp, producer: inv.producer,
        description: inv.description, fillDate: inv.fillDate, inventoryId: inv.inventoryId
      }))
      );

    // Find the container that matches the clicked barrel number
    const selectedBarrel = allDestinationBarrels.find(b => b.barrelNumber === barrelNumber);

    if (!selectedBarrel) {
      CommonService.Toast.fire({
        title: "Destination Container not found",
        icon: "error",
      });
      return;
    }

    const { barrelId, row, depth, height, proof, containerType, volume, lotNo, productName, mashBill, dsp, producer, description, fillDate, inventoryId } = selectedBarrel;

    setFinalSelectedSelectedSourceToDestinationInventories(prev => {
      const copy = structuredClone(prev);

      // Prevent selecting this barrel if already selected by another source barrel
      const isAlreadySelectedByOtherSource = copy.some(inv =>
        inv.sourceBarrelId !== sourceBarrelId &&
        inv.destinationBarrelNumberResponse?.some(b => b.barrelId === barrelId)
      );

      if (isAlreadySelectedByOtherSource) {
        CommonService.Toast.fire({
          title: `This container is already selected for another source container`,
          icon: "warning",
        });
        return copy; // Do not add again
      }

      // Find existing inventory
      const invIndex = copy.findIndex(inv => inv.lotNo === lotNo && inv.sourceBarrelId === sourceBarrelId);

      const rawVolume = barrelVolumes?.[sourceBarrelId]?.[barrelId];

      const destinationBarrelPayload = {
        barrelId,
        barrelNumber,
        row,
        depth,
        height,
        proof,
        sourceBarrelId,
        sourceBarrelNumber,
        containerType,
        volume,
        distributedVolume: rawVolume !== undefined && rawVolume !== "" ? parseFloat(rawVolume) : undefined,
        mashBill,
        dsp,
        producer,
        description,
        fillDate,
      };

      if (invIndex !== -1) {
        const inv = copy[invIndex];
        // Check if barrel already exists
        const existingIndex = inv.destinationBarrelNumberResponse.findIndex(b => b.barrelId === barrelId);
        if (existingIndex !== -1) {
          // Update existing barrel volume
          inv.destinationBarrelNumberResponse[existingIndex] = {
            ...inv.destinationBarrelNumberResponse[existingIndex],
            ...destinationBarrelPayload
          };
        } else {
          inv.destinationBarrelNumberResponse.push(destinationBarrelPayload);
        }
      } else {
        copy.push({
          lotNo,
          productName,
          mashBill,
          dsp,
          producer,
          description,
          fillDate,
          inventoryId,
          sourceBarrelId,
          destinationBarrelNumberResponse: [destinationBarrelPayload],
        });
      }

       const distributedVolumes = copy
      .flatMap(inv => inv.destinationBarrelNumberResponse || [])
      .filter(b => b.sourceBarrelId === sourceBarrelId)
      .reduce((sum, b) => {
        const inputValue = barrelVolumes[b.sourceBarrelId]?.[b.barrelId];
        const volumeToUse = (parseFloat(inputValue) || 0) + (parseFloat(b.volume) || 0);
        return sum + (isNaN(volumeToUse) ? 0 : volumeToUse);
      }, 0);

      // Update source container with correct parent info
      setFinalSelectedInventoriesWithBarrels(prevSource => {
        const sourceCopy = structuredClone(prevSource);
        return sourceCopy.map(srcInventory => ({
          ...srcInventory,
          barrelNumbers: srcInventory.barrelNumbers.map(srcBarrel => {
            if (srcBarrel.barrelId !== sourceBarrelId || srcBarrel.barrelNumber !== sourceBarrelNumber) return srcBarrel;
            const availableVolumes = (formatVolume(srcBarrel.volume) || 0) - distributedVolumes;

            return {
              ...srcBarrel,
              availableVolume: availableVolumes, 
              finalSelectedDestinationInventoriesRequest: copy
                .map(destInv => {
                  const filteredDest = destInv.destinationBarrelNumberResponse
                  .filter(b => b.sourceBarrelId === sourceBarrelId) 
                  .map(b => ({ ...b })); 

                  if (filteredDest.length === 0) return null;

                  return {
                    lotNo: destInv.lotNo,
                    productName: destInv.productName,
                    mashBill: destInv.mashBill,
                    dsp: destInv.dsp,
                    producer: destInv.producer,
                    description: destInv.description,
                    inventoryId: destInv.inventoryId,
                    fillDate: destInv.fillDate,
                    destinationBarrelNumberResponse: filteredDest
                  };
                })
                .filter(Boolean)
            };
          })
        }));
      });

      return copy;
    });
  };

  const handleSelectBarrel = (barrelNumber) => {

    // Check if an inventory is selected
    if (!searchSelectedInventory) {
      CommonService.Toast.fire({
        title: "Please select an inventory first",
        icon: "error",
      });
      return;
    }
  
    const { lotNo, title, mashBill, dsp, inventoryId, ownerName, fillDate, producer, description, } =
      searchSelectedInventory;
  
    // Find the selected barrel details
    const selectedBarrel = filteredBarrelNumbers.find(
      (barrel) => barrel.barrelNumber === barrelNumber
    );
  
    if (!selectedBarrel) {
      CommonService.Toast.fire({
        title: "Selected container not found in the current inventory",
        icon: "error",
      });
      return;
    }
  
    const { barrelId, row, depth, height, proof, proofGallons, volume, containerType } = selectedBarrel;
  
    // Find the selected inventory in the final selected inventories
    const existingInventoryIndex = finalSelectedInventoriesWithBarrels.findIndex(
      (inv) => inv.lotNo === lotNo
    );  
  
    if (existingInventoryIndex !== -1) {
      // Inventory already exists, update the selected container
      setFinalSelectedInventoriesWithBarrels((prev) => {
        const updatedInventories = structuredClone(prev);
        const existingInventory = updatedInventories[existingInventoryIndex];
  
        // Check if the container is already selected
        const isBarrelSelected = existingInventory.barrelNumbers.some(
          (barrel) => barrel.barrelNumber === barrelNumber
        );
  
        if (isBarrelSelected) {
          // container is already selected, remove it
          existingInventory.barrelNumbers = existingInventory.barrelNumbers.filter(
            (barrel) => barrel.barrelNumber !== barrelNumber
          );

          // Clean up blending destination selections & volumes for this removed barrel
          setFinalSelectedSelectedSourceToDestinationInventories((prev: any[]) =>
              prev.filter((inv) => inv.sourceBarrelId !== barrelId)
          );
          setBarrelVolumes((prev: any) => {
              const newVols = { ...prev };
              delete newVols[barrelId];
              return newVols;
          });
  
          // If no container are left after removal, remove the entire inventory entry
          if (existingInventory.barrelNumbers.length === 0) {
            if (
              selectedServiceName === Constant.CustomerService.PRIVATE_SELL ||
              selectedServiceName === Constant.CustomerService.SELL_REQUEST ||
              selectedServiceName === Constant.CustomerService.OWNERSHIP_TRANSFER
            ) {
              resetAttributesIfEmpty(finalSelectedInventoriesWithBarrels.length - 1);
            }
            updatedInventories.splice(existingInventoryIndex, 1);
          }
        } else {
          // Barrel is not selected, add it
          existingInventory.barrelNumbers.push({
            barrelNumber,
            barrelId,
            row,
            depth,
            height,
            proof,
            proofGallons,
            volume,
            containerType,
          });
  
          // If the inventory attributes are empty, update them for certain services
          if (
            (selectedDsp === "" || selectedBarrelInventoryId === "") &&
            (selectedServiceName === Constant.CustomerService.PRIVATE_SELL ||
              selectedServiceName === Constant.CustomerService.SELL_REQUEST ||
              selectedServiceName === Constant.CustomerService.OWNERSHIP_TRANSFER)
          ) {
            updateAttributesIfEmpty(dsp, mashBill, inventoryId);
          }
          setOwnerName(ownerName);
        }
  
        return updatedInventories;
      });
    } else {
      // Inventory does not exist, create a new one
      const newInventorySelection = {
        lotNo: lotNo,
        productName: title,
        mashBill: mashBill,
        fillDate: fillDate,
        dsp: dsp,
        producer: producer,
        description: description,
        barrelNumbers: [
          {
            barrelNumber,
            barrelId,
            row,
            depth,
            height,
            proof,
            proofGallons,
            volume,
            containerType,
          },
        ],
      };
  
      setFinalSelectedInventoriesWithBarrels((prev) => [
        ...prev,
        newInventorySelection,
      ]);

      // If the inventory attributes are empty, update them for certain services
      if (
        (selectedDsp === "" || selectedBarrelInventoryId === "") &&
        (selectedServiceName === Constant.CustomerService.PRIVATE_SELL ||
          selectedServiceName === Constant.CustomerService.SELL_REQUEST ||
          selectedServiceName === Constant.CustomerService.OWNERSHIP_TRANSFER)
      ) {
        updateAttributesIfEmpty(dsp, mashBill, inventoryId);
      }

      setOwnerName(ownerName);
    }
  };
  

  const handleSelectBarrelForTabs = (barrelNumber: string, tabId: string, serviceTypeServiceFieldId:any) => {
    if (!searchSelectedInventory) {
      CommonService.Toast.fire({
        title: "Please select an inventory first",
        icon: "error",
      });
      return;
    }

    setErrorsForTabs((prev) => ({
      ...prev,
      [tabId]: {
        ...(prev[tabId] || {}), // keep other fields intact
        [serviceTypeServiceFieldId]: "", // clear this specific field error
      },
    }));

    const { lotNo, title, mashBill, dsp, inventoryId, ownerName, fillDate, producer, description } =
      searchSelectedInventory;

    const selectedBarrel = filteredBarrelNumbers.find(
      (barrel) => barrel.barrelNumber === barrelNumber
    );

    if (!selectedBarrel) {
      CommonService.Toast.fire({
        title: "Selected container not found in the current inventory",
        icon: "error",
      });
      return;
    }

    const { barrelId, row, depth, height, proof, proofGallons, volume, containerType } = selectedBarrel;

    setFinalSelectedInventoriesWithBarrelsForTabs((prev) => {
      // Copy previous state
      const updated = { ...prev };
      const currentTabInventories = updated[tabId] ? structuredClone(updated[tabId]) : [];

      // Find inventory for this lotNo under the current tab
      const existingInventoryIndex = currentTabInventories.findIndex(
        (inv) => inv.lotNo === lotNo
      );

      if (existingInventoryIndex !== -1) {
        // Update existing inventory
        const existingInventory = currentTabInventories[existingInventoryIndex];

        const isBarrelSelected = existingInventory.barrelNumbers.some(
          (barrel) => barrel.barrelNumber === barrelNumber
        );

        if (isBarrelSelected) {
          // Remove barrel
          existingInventory.barrelNumbers = existingInventory.barrelNumbers.filter(
            (barrel) => barrel.barrelNumber !== barrelNumber
          );

          // Clean up blending destination selections & volumes for this removed barrel
          setFinalSelectedSelectedSourceToDestinationInventories((prev: any[]) =>
              prev.filter((inv) => inv.sourceBarrelId !== barrelId)
          );
          setBarrelVolumes((prev: any) => {
              const newVols = { ...prev };
              delete newVols[barrelId];
              return newVols;
          });

          // Remove inventory if no container left
          if (existingInventory.barrelNumbers.length === 0) {
            currentTabInventories.splice(existingInventoryIndex, 1);
          }
        } else {
          // Add new barrel
          existingInventory.barrelNumbers.push({
            barrelNumber,
            barrelId,
            row,
            depth,
            height,
            proof,
            proofGallons,
            volume,
            containerType
          });
          setOwnerName(ownerName);
        }
      } else {
        // Add new inventory for this tab
        const newInventorySelection = {
          lotNo,
          productName: title,
          mashBill,
          fillDate: fillDate,
          dsp,
          producer,
          description,
          barrelNumbers: [
            {
              barrelNumber,
              barrelId,
              row,
              depth,
              height,
              proof,
              proofGallons,
              volume,
              containerType
            },
          ],
        };

        currentTabInventories.push(newInventorySelection);

        setOwnerName(ownerName);
      }

      updated[tabId] = currentTabInventories;
      return updated;
    });
  };


  const handleRandomSelectionForTabs = (value: any, tabId: string, serviceTypeServiceFieldId:any) => {
    setDesiredQuantity(value);

    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }

    setErrorsForTabs((prev) => ({
      ...prev,
      [tabId]: {
        ...(prev[tabId] || {}), // keep other fields intact
        [serviceTypeServiceFieldId]: "", // clear this specific field error
      },
    }));

    const timeoutId = setTimeout(() => {
      // Exit if the input is empty
      if (!value || value.trim().length === 0) {
        setSelectedBarrels([]);

        setFinalSelectedInventoriesWithBarrelsForTabs((prev) => {
          const updated = { ...prev };
          const currentTabInventories = updated[tabId]
            ? structuredClone(updated[tabId])
            : [];

          updated[tabId] = currentTabInventories
            .map((inv) => {
              if (inv.lotNo === searchSelectedInventory.lotNo) {
                const soldBarrels = inv.barrelNumbers.filter(
                  (barrel) => barrel.isBarrelSold === true
                );
                if (soldBarrels.length > 0) {
                  return { ...inv, barrelNumbers: soldBarrels };
                }
                return null; // remove lot if no container left
              }
              return inv;
            })
            .filter(Boolean);

          return updated;
        });

        return;
      }

      const quantity = parseInt(value, 10);
      const { lotNo, title, mashBill, dsp, inventoryId, ownerName, fillDate, producer, description, containerType } =
        searchSelectedInventory;

      // Available container (not sold)
      const readyToSellBarrels = filteredBarrelNumbers.filter(
        (barrel) => barrel.isBarrelSold !== true
      );

      if (quantity > 0 && quantity <= readyToSellBarrels.length) {
        // Pick random container
        const randomBarrels = [...readyToSellBarrels]
          .sort(() => 0.5 - Math.random())
          .slice(0, quantity)
          .map((barrel) => ({
            barrelNumber: barrel.barrelNumber,
            barrelId: barrel.barrelId,
            row: barrel.row,
            depth: barrel.depth,
            height: barrel.height,
            proof: barrel?.proof,
            proofGallons: barrel?.proofGallons,
            volume: barrel?.volume,
            containerType: barrel?.containerType
          }));

        setSelectedBarrels(randomBarrels);

        setFinalSelectedInventoriesWithBarrelsForTabs((prev) => {
          const updated = { ...prev };
          const currentTabInventories = updated[tabId]
            ? structuredClone(updated[tabId])
            : [];

          const existingLot = currentTabInventories.find(
            (inv) => inv.lotNo === lotNo
          );

          const existingSoldBarrels =
            existingLot?.barrelNumbers?.filter(
              (barrel) => barrel.isBarrelSold === true
            ) || [];

          const updatedBarrelList = [...existingSoldBarrels, ...randomBarrels];

          const otherInventories = currentTabInventories.filter(
            (inv) => inv.lotNo !== lotNo
          );

          setOwnerName(ownerName);

          updated[tabId] = [
            ...otherInventories,
            {
              lotNo,
              productName: title,
              barrelNumbers: updatedBarrelList,
              mashBill,
              fillDate: fillDate,
              dsp,
              producer,
              description,
              containerType,
            },
          ];

          return updated;
        });
      } else {
        CommonService.Toast.fire({
          title: `Please enter a number between 1 and ${readyToSellBarrels.length}`,
          icon: "error",
        });
      }
    }, 500);

    setDebounceTimeout(timeoutId);
  };


  const handleSelectAllBarrelsForTabs = async (tabId: string, serviceTypeServiceFieldId:any) => {
    const { lotNo, title, mashBill, dsp, inventoryId, ownerName, fillDate, producer, description, containerType } =
      searchSelectedInventory;

    setErrorsForTabs((prev) => ({
      ...prev,
      [tabId]: {
        ...(prev[tabId] || {}), // keep other fields intact
        [serviceTypeServiceFieldId]: "", // clear this specific field error
      },
    }));

    // Filter container that are not sold
    const readyToSellBarrelsInSource = filteredBarrelNumbers.filter(
      (barrel) => barrel.isBarrelSold !== true
    );

    setFinalSelectedInventoriesWithBarrelsForTabs((prev) => {
      const updated = { ...prev };
      let currentTabInventories = updated[tabId]
        ? structuredClone(updated[tabId])
        : [];

      // Already selected unsold container for this lot
      const selectedUnsoldBarrels =
        currentTabInventories
          .find((inv) => inv.lotNo === lotNo)
          ?.barrelNumbers?.filter((barrel) => barrel.isBarrelSold !== true) || [];

      const isAllSelected =
        selectedUnsoldBarrels.length === readyToSellBarrelsInSource.length;

      if (isAllSelected) {
        setSelectedBarrels([]);

        const newInventoryList = currentTabInventories
          .map((inventory) => {
            if (inventory.lotNo === lotNo) {
              const soldBarrels = inventory.barrelNumbers.filter(
                (barrel) => barrel.isBarrelSold === true
              );
              return soldBarrels.length > 0
                ? { ...inventory, barrelNumbers: soldBarrels }
                : null;
            }
            return inventory;
          })
          .filter(Boolean);

        updated[tabId] = newInventoryList;

        return updated;
      } else {
        // Select all unsold container
        const selectedBarrelsForCurrentLot = filteredBarrelNumbers
          .filter((barrel) => barrel.isBarrelSold !== true)
          .map((barrel) => ({
            barrelNumber: barrel.barrelNumber,
            barrelId: barrel.barrelId,
            row: barrel.row,
            depth: barrel.depth,
            height: barrel.height,
            proof: barrel?.proof,
            proofGallons: barrel?.proofGallons,
            volume: barrel?.volume,
            containerType: barrel?.containerType
          }));

        setSelectedBarrels(selectedBarrelsForCurrentLot);

        let updatedInventories = currentTabInventories
          .map((inventory) => {
            if (inventory.lotNo === lotNo) {
              const soldBarrels = inventory.barrelNumbers.filter(
                (barrel) => barrel.isBarrelSold === true
              );
              return soldBarrels.length > 0
                ? { ...inventory, barrelNumbers: soldBarrels }
                : null;
            }
            return inventory;
          })
          .filter(Boolean);

        // Merge unsold container with existing lot or create new one
        const existingLot = updatedInventories.find((inv) => inv.lotNo === lotNo);
        if (existingLot) {
          existingLot.barrelNumbers = [
            ...existingLot.barrelNumbers,
            ...selectedBarrelsForCurrentLot,
          ];
        } else {
          updatedInventories.push({
            lotNo: lotNo,
            productName: title,
            mashBill: mashBill,
            fillDate: fillDate,
            dsp: dsp,
            producer: producer,
            description: description,
            barrelNumbers: selectedBarrelsForCurrentLot,
            containerType: containerType,
          });
        }

        setOwnerName(ownerName);

        updated[tabId] = [...updatedInventories];
        return updated;
      }
    });
  };



  //update inventory attributes like dsp, mash bill and batch id
  const updateAttributesIfEmpty = (dsp, mashBill,inventoryId) => {

    if(selectedServiceName == Constant.CustomerService.PRIVATE_SELL || selectedServiceName == Constant.CustomerService.SELL_REQUEST) {
      setSelectedDsp(dsp);
      setSelectedMashBill(mashBill);
     
    } else if(selectedServiceName == Constant.CustomerService.OWNERSHIP_TRANSFER) {
      setSelectedBarrelInventoryId(inventoryId);

    }
  };

  //update inventory attributes like dsb, mash bill and batch id when user unselect all the container
  const resetAttributesIfEmpty = (length:any) => {


    if(length == 0 && (selectedServiceName == Constant.CustomerService.PRIVATE_SELL || Constant.CustomerService.SELL_REQUEST)) {
      setSelectedDsp('');
      setSelectedMashBill('');
      setOwnerName('')
    }

    else if (length == 0 && selectedServiceName == Constant.CustomerService.OWNERSHIP_TRANSFER) {
      setSelectedBarrelInventoryId(null);
      setOwnerName('');
    }
  }

  // Handle Done button click to add to final selection
  const handleDoneSelection = () => {
    // Reset states
    setManagedByWhitedogFilter('all');
    setSearchSelectedInventory(null);
    setSearchedInventories([]);
    setSelectedBarrels([]);
    setSearchTerm("");
    setBarrelSearchTerm("");
    setDesiredQuantity("");
    setIsDoneButtonClicked(true);
  };

  // Remove an inventory from the final selection
  const handleRemoveInventory = (e:any, lotNo) => {
    
    e.preventDefault();

    // Find the inventory to be removed
    const inventoryToRemove = finalSelectedInventoriesWithBarrels.find(inv => inv.lotNo === lotNo);
    
    if (!inventoryToRemove) return;
    
    // Check container statuses
    const soldBarrels = inventoryToRemove.barrelNumbers.filter(barrel => barrel.isBarrelSold === true);
    const readyToSellBarrels = inventoryToRemove.barrelNumbers.filter(barrel => barrel.isBarrelSold !== true);
    
    // If all container are sold, show alert and don't remove anything
    if (soldBarrels.length === inventoryToRemove.barrelNumbers.length) {
        CommonService.Toast.fire({
            title: "Cannot remove this lot. All container in this lot are already sold.",
            icon: "error",
        });
        return;
    }
    
    // Clean up blending destination selections & volumes for the removed barrels
    const removedBarrelIds = readyToSellBarrels.map((b: any) => b.barrelId);
    
    // Clean up destination barrel selections for removed source barrels
    setFinalSelectedSelectedSourceToDestinationInventories((prev: any[]) =>
        prev.filter((inv) => !removedBarrelIds.includes(inv.sourceBarrelId))
    );
    
    // Clean up barrel volumes for removed source barrels
    setBarrelVolumes((prev: any) => {
        const newVols = { ...prev };
        removedBarrelIds.forEach(id => {
            delete newVols[id];
        });
        return newVols;
    });
    
    // Clean up barrel errors for removed source barrels
    setBarrelErrors((prev: any) => {
        const newErrors = { ...prev };
        removedBarrelIds.forEach(id => {
            delete newErrors[id];
        });
        return newErrors;
    });
    
    // Clean up barrel capacity errors for removed source barrels
    setBarrelCapacityErrors((prev: any) => {
        const newCapacityErrors = { ...prev };
        removedBarrelIds.forEach(id => {
            delete newCapacityErrors[id];
        });
        return newCapacityErrors;
    });

    // If all container are ready to sell (none are sold), remove the whole lot
    if (readyToSellBarrels.length === inventoryToRemove.barrelNumbers.length) {
        const updatedFinalSelectedInventoriesWithBarrels =
            finalSelectedInventoriesWithBarrels.filter((inv) => inv.lotNo !== lotNo);
        setFinalSelectedInventoriesWithBarrels(updatedFinalSelectedInventoriesWithBarrels);
        resetAttributesIfEmpty(finalSelectedInventoriesWithBarrels.length - 1);
        
        // Clear destination barrel search results to force fresh data on next search
        setSearchedSourceToDestinationInventory([]);
        setSearchSelectedSourceToDestinationInventory(null);
        
        return;
    }
    
    // If some container are sold and some are ready to sell, remove only ready to sell container
    if (soldBarrels.length > 0 && readyToSellBarrels.length > 0) {
        const updatedFinalSelectedInventoriesWithBarrels = finalSelectedInventoriesWithBarrels.map(inv => {
            if (inv.lotNo === lotNo) {
                return {
                    ...inv,
                    barrelNumbers: inv.barrelNumbers.filter(barrel => barrel.isBarrelSold === true)
                };
            }
            return inv;
        });
        
        setFinalSelectedInventoriesWithBarrels(updatedFinalSelectedInventoriesWithBarrels);
        
        // Clear destination barrel search results to force fresh data on next search
        setSearchedSourceToDestinationInventory([]);
        setSearchSelectedSourceToDestinationInventory(null);
        
        // Don't call resetAttributesIfEmpty here since we're not removing the whole lot
        return;
    }
  };

  // Utility function to calculate the difference in years and months
  function getDurationFromDate(fillDate) {
    if (!fillDate) return "-";

    const startDate = new Date(fillDate);
    const today = new Date();

    let years = today.getFullYear() - startDate.getFullYear();
    let months = today.getMonth() - startDate.getMonth();
    let days = today.getDate() - startDate.getDate();

    if (days < 0) {
      months--;
      days += new Date(today.getFullYear(), today.getMonth(), 0).getDate();
    }

    if (months < 0) {
      years--;
      months += 12;
    }

    return `${years} years, ${months} months`;
  }

  const handleRemoveInventoryForTabs = (e: any, lotNo: string, tabId: string) => {
    e.preventDefault();

    setFinalSelectedInventoriesWithBarrelsForTabs((prev) => {
      const tabInventories = prev[tabId] || [];

      // Find the inventory to be removed inside this tab
      const inventoryToRemove = tabInventories.find(inv => inv.lotNo === lotNo);
      if (!inventoryToRemove) return prev;

      // Separate sold vs ready-to-sell container
      const soldBarrels = inventoryToRemove.barrelNumbers.filter(barrel => barrel.isBarrelSold === true);
      const readyToSellBarrels = inventoryToRemove.barrelNumbers.filter(barrel => barrel.isBarrelSold !== true);

      let updatedTabInventories;

      // Case 1: All container sold → show error, don’t remove
      if (soldBarrels.length === inventoryToRemove.barrelNumbers.length) {
        CommonService.Toast.fire({
          title: "Cannot remove this lot. All container in this lot are already sold.",
          icon: "error",
        });
        return prev;
      }

      // Clean up blending destination selections & volumes for the removed barrels
      const removedBarrelIds = readyToSellBarrels.map((b: any) => b.barrelId);
      setFinalSelectedSelectedSourceToDestinationInventories((prev: any[]) =>
          prev.filter((inv) => !removedBarrelIds.includes(inv.sourceBarrelId))
      );
      setBarrelVolumes((prev: any) => {
          const newVols = { ...prev };
          removedBarrelIds.forEach(id => {
              delete newVols[id];
          });
          return newVols;
      });
      
      // Clean up barrel errors for removed source barrels
      setBarrelErrors((prev: any) => {
          const newErrors = { ...prev };
          removedBarrelIds.forEach(id => {
              delete newErrors[id];
          });
          return newErrors;
      });
      
      // Clean up barrel capacity errors for removed source barrels
      setBarrelCapacityErrors((prev: any) => {
          const newCapacityErrors = { ...prev };
          removedBarrelIds.forEach(id => {
              delete newCapacityErrors[id];
          });
          return newCapacityErrors;
      });

      // Case 2: All container ready to sell → remove the entire lot
      if (readyToSellBarrels.length === inventoryToRemove.barrelNumbers.length) {
        updatedTabInventories = tabInventories.filter(inv => inv.lotNo !== lotNo);

        // reset if this tab becomes empty
        resetAttributesIfEmpty(updatedTabInventories.length);
        
        // Clear destination barrel search results to force fresh data on next search
        setSearchedSourceToDestinationInventory([]);
        setSearchSelectedSourceToDestinationInventory(null);
      } 
      // Case 3: Some sold, some ready → keep only sold container
      else {
        updatedTabInventories = tabInventories.map(inv => {
          if (inv.lotNo === lotNo) {
            return {
              ...inv,
              barrelNumbers: inv.barrelNumbers.filter(barrel => barrel.isBarrelSold === true),
            };
          }
          return inv;
        });
        
        // Clear destination barrel search results to force fresh data on next search
        setSearchedSourceToDestinationInventory([]);
        setSearchSelectedSourceToDestinationInventory(null);
      }

      return {
        ...prev,
        [tabId]: updatedTabInventories,
      };
    });
  };



  const handleDeleteFile = (indexToDelete: number) => {
    setFiles((prevFiles) =>
      prevFiles.filter((_, index) => index !== indexToDelete)
    );
  };

  const handleSingleDeleteFile = (fieldId) => {
    setFile(null); // Remove the file
    formData[fieldId] = '';
  };

  const handleDeleteDoc = async (id:any) => {
    //call the api and delete this doc
    try {
    const response = await SupportApiService.deleteCustomerServiceRequestDoc(id);
    // fetchCustomerServiceRequestDocsForEditing();
    } catch (error) {
      console.log("error occurred while api calling" + error);
    }
  }

  const handleDeleteSignatureFile = () => {
    setSignatureFile(null);
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>, serviceTypeServiceFieldId:any) => {

    setErrors((prev) => ({ ...prev, [serviceTypeServiceFieldId]: "" }));
    if (event.target.files) {
      // Replace old files with new ones
      const newFiles = Array.from(event.target.files);
      setFiles(newFiles);

      // Clear the input value to allow selecting the same file again
      event.target.value = "";
    }
  };

  const showRequestDetails = (requestType: any, id: any) => {
    let url = "";

    if (requestType === "Order Request") {
      url = `/master/order-detail/${id}`;
    } else if (requestType === "Offer Request") {
      url = `/master/view-offer-request/${id}`;
    } else {
      url = `/master/view-customer-service-request/${id}`;
    }

    // open in new tab
    window.open(url, "_blank", "noopener,noreferrer");
  }
  
  const handleFileChangeForTabs = (e: React.ChangeEvent<HTMLInputElement>, tabId: string) => {
    if (e.target.files) {
      const selectedFiles = Array.from(e.target.files);
      setTabFiles((prev) => ({
        ...prev,
        [tabId]: [...(prev[tabId] || []), ...selectedFiles],
      }));
    }
  };

  const handleDeleteFileForTabs = (index: number, tabId: string) => {
    setTabFiles((prev) => ({
      ...prev,
      [tabId]: prev[tabId].filter((_, i) => i !== index),
    }));
  };

  const handleSingleFileChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    fieldId: string
  ) => {
    setErrors((prev) => ({ ...prev, [fieldId]: "" }));
    setErrorsForInventoryUpload((prev) => ({...prev, [fieldId]: ""}));
  
    if (event.target.files && event.target.files.length > 0) {
      const newFile = event.target.files[0]; // Access the first file
  
      // Allowed file extensions
      const allowedExtensions = [".csv", ".xlsx"];
      const fileName = newFile.name.toLowerCase();
      const isAllowed = allowedExtensions.some((ext) => fileName.endsWith(ext));
  
      if (!isAllowed) {
        // Show error message and reset input
        setErrors((prev) => ({
          ...prev,
          [fieldId]: "Invalid file type. Only .csv and .xlsx files are allowed.",
        }));
        event.target.value = ""; // Reset input field
        return;
      }
  
      // File is valid, set it
      setFile(newFile);
      setFormData((prevData) => ({
        ...prevData,
        [fieldId]: newFile,
      }));

      setFormDataForInventoryUpload((prevData) => ({
        ...prevData,
        [fieldId]: newFile
      }));
  
      // Clear input value to allow selecting the same file again
      event.target.value = "";
    }
  };
  

  const handleSignatureFileChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.files && event.target.files.length > 0) {
      // Replace old files with new ones
      setSignatureFile(event.target.files[0]);

      // Clear the input value to allow selecting the same file again
      event.target.value = "";
    }
  };

  const highlightMatchedForBarrels = (text: string, searchTerm: string) => {
    if (!searchTerm) return text;
  
    const lowerText = text?.toLowerCase();
    const lowerSearchTerm = searchTerm?.toLowerCase();
    const matchIndex = lowerText?.indexOf(lowerSearchTerm);
  
    if (matchIndex === -1) return text;
  
    return (
      <>
        {text?.slice(0, matchIndex)}
        <strong style={{fontWeight:"900"}}>
          {text?.slice(matchIndex, matchIndex + searchTerm.length)}
        </strong>
        {text?.slice(matchIndex + searchTerm.length)}
      </>
    );
  };

  const getButtonLabel = () => {
    if (selectedServiceName === Constant.CustomerService.BULK_INVENTORY_UPLOAD && CommonService.isAdmin()) {
      if (id) {
        return "Update";
      } else if (isLoading) {
        return "Validating";
      } else {
        return "Upload";
      }
    }

    if (selectedServiceName === Constant.CustomerService.OWNERSHIP_TRANSFER && CommonService.isAdmin()) {
      return id ? "Update" : "Transfer";
    }

    if (selectedServiceName === Constant.CustomerService.SELL_REQUEST && CommonService.isAdmin()) {
      return id ? "Update" : "Publish";
    }

    if (selectedServiceName === Constant.CustomerService.PRIVATE_SELL && CommonService.isAdmin()) {
      return id ? "Update" : "Sale";
    }

    if(selectedServiceName === Constant.CustomerService.BARREL_OWNER_ASSIGNMENT) {
      return "Assign"
    }

    return id ? "Update" : "Submit";
  };


  const isInventoryUploadRadioField = (fieldName:any) => {
    if(selectedServiceName == Constant.CustomerService.LOGISTIC && barrelSource == Constant.BarrelSource.SHIP_BY_UPLOAD_INVENTORY && (fieldName == Constant.Field.COMPANY_OWNS_INVENTORY || fieldName == Constant.Field.INVENTORY_AT_THIRD_PARTY)) {
      return true;
    } else {
      return false;
    }
  }

  const handleShowDropdown = (serviceTypeServiceFieldId:any) => {

    if(!showDropdown && !selectedCompany) {
      setSelectedCompanyError("Please select company");
    } else {
      const request = transferRequests.find((req) => req.requestId === serviceTypeServiceFieldId);
      setSelectedType(request?.requestType);
      setShowDropdown(!showDropdown);
    }
  }

 
const getCompanyNameById = (id: string | number) => {
  const company = companyOptions.find((c) => c.value === id);
  return company ? company.label : "";
};

const companyOptions = filteredCompaniesList.map((company) => ({
  value: company.id,
  label: company.companyName,
}));

const filterCompanyOptions = companiesList
  .filter((company) => company.id !== selectedCompanies[activeTabId])
  .map((company) => ({
    value: company.id,
    label: company.companyName,
}));

const mergedCompanyOptions = [...companyOptions, ...filterCompanyOptions,].filter(
  (option, index, self) => index === self.findIndex((o) => o.value === option.value));

  
  const renderField = (field:any, tabId?:any) => {
    // Check if the field is one of the initial fields needed when first creating a logistics request
    const isLogisticCreationField =
      field.dataType === Constant.FIELD_TYPES.ADD_INVENTORY ||
      field.dataType === Constant.FIELD_TYPES.ADD_CONTAINER ||
      field.dataType === Constant.FIELD_TYPES.SOURCE_CONTAINER ||
      field.dataType === Constant.FIELD_TYPES.LOGISTIC_TYPE_DROPDOWN ||
      field.dataType === Constant.FIELD_TYPES.DATE ||
      field.dataType === Constant.FIELD_TYPES.UPLOAD_FILE;

    // Check if we are creating a logistics request and this field is not one of the initial creation fields
    const isNonCreationLogistic = (!id || originalRequestData?.status === Constant.CustomerServiceRequestStatus.PENDING_REVIEW) && selectedServiceName === Constant.CustomerService.LOGISTIC && !isLogisticCreationField;

    const errorsState = errors;

    // Inner helper function to get the JSX layout for this field type
    const getFieldElement = () => {
      const errors = isNonCreationLogistic
        ? { ...errorsState, [field.serviceTypeServiceFieldId]: undefined }
        : errorsState;

      switch (field.dataType) {
      case Constant.FIELD_TYPES.COMPANY_DROPDOWN:
        return (
          <div
            className={`col-lg-4 position-relative ${
              field.fieldName === "Requesting Organization" ? "z-3" : "z-1"
            }`}
          >
            <div className="form__field--wrapper">
              <label htmlFor="service-dropdown" className="form-label">
                {field.fieldName}
                {field.mandatory && (
                  <span className="star-required text-danger">*</span>
                )}
              </label>
              <div className="w-100">
                <Select
                  id="company-dropdown"
                  classNamePrefix="select-dropdown"
                  className={`select-dropdown w-100 multi-select-dropdown ${
                    field.mandatory &&
                    (tabId
                      ? errorsForTabs[tabId]?.[field.serviceTypeServiceFieldId]
                      : errors[field.serviceTypeServiceFieldId])
                      ? "is_invalid"
                      : ""
                  }`}
                  options={mergedCompanyOptions}
                  placeholder="Select Company"
                  value={
                    mergedCompanyOptions.find((option) =>
                      tabId
                        ? option.value === formDataForTabs[tabId]?.[field.serviceTypeServiceFieldId]
                        : option.value === formData[field.serviceTypeServiceFieldId]
                    ) || null
                  }
                  onChange={(selectedOption) =>
                    tabId
                      ? handleCompanyChange(
                          selectedOption?.value,
                          field.serviceTypeServiceFieldId,
                          tabId
                        )
                      : handleCompanyChange(
                          selectedOption?.value,
                          field.serviceTypeServiceFieldId
                        )
                  }
                  components={{
                    DropdownIndicator: () => <ExpandMoreRoundedIcon />,
                    IndicatorSeparator: () => null, // Remove the default separator
                  }}
                  onBlur={() =>
                    tabId
                      ? handleCompanyBlur(field.serviceTypeServiceFieldId, tabId)
                      : handleCompanyBlur(field.serviceTypeServiceFieldId)
                  }
                  isSearchable
                />
              </div>

            
              {field.mandatory &&
                (tabId
                  ? errorsForTabs[tabId]?.[field.serviceTypeServiceFieldId]
                  : errors[field.serviceTypeServiceFieldId]) && (
                  <span className="error-message">This field is required</span>
                )}
                </div>
          </div>
        );
      case Constant.FIELD_TYPES.USER_DROPDOWN:
        return (
          <div className="col-sm-6 col-lg-4">
            <div className="mb-6 form__field--wrapper">
              <label
                htmlFor="service-dropdown"
                className="block mb-2 form-label"
              >
                {field.fieldName}
                {field.mandatory && (
                  <span className="star-required text-danger">*</span>
                )}
              </label>
              <div className="w-100">
                <select
                  id="company-dropdown"
                  value={formData[field.serviceTypeServiceFieldId]}
                  onChange={(e) =>
                    handleUserChange(
                      e.target.value,
                      field.serviceTypeServiceFieldId
                    )
                  }
                  onBlur={() => handleUserBlur(field.serviceTypeServiceFieldId)}
                  className={`select-dropdown w-100 ${
                    field.mandatory && errors[field.serviceTypeServiceFieldId]
                      ? "is_invalid"
                      : ""
                  }`}
                >
                  <option value="">Select User</option>
                  {usersList.map((user) => (
                    <option key={user.userId} value={user.userId}>
                      {user.userName}
                    </option>
                  ))}
                </select>
              </div>

              {field.mandatory && errors[field.serviceTypeServiceFieldId] && (
                <span className="error-message ">Please select a user </span>
              )}
            </div>
          </div>
        );
      case Constant.FIELD_TYPES.SOURCE_CONTAINER:
        return (
           <div className="col-12">
            <div key={field.fieldName} className="form__field--wrapper">
              {/* Field Label */}
              <label className="block mb-2 form-label">
                {field.fieldName}
                {field.mandatory && (
                  <span className="star-required text-danger">*</span>
                )}
              </label>
              <div className="position-relative">
                  <SearchIcon
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: "15px",
                      transform: "translateY(-50%)",
                    }}
                  />
                <input
                  type="text"
                  value={searchTerm}
                  placeholder="Search by Product Name, Lot ID or Container Id"
                  onClick={(e) =>
                  handleSearchInventory(
                      e.currentTarget.value,
                      field.serviceTypeServiceFieldId,
                      tabId
                    )
                  }
                  onChange={(e) =>
                    handleSearchInventory(
                      e.target.value,
                      field.serviceTypeServiceFieldId,
                      tabId
                    )
                  }
                  className={`form-control service-req-input add-inventory ${
                    field.mandatory &&
                    (
                      tabId
                        ? errorsForTabs[tabId]?.[field.serviceTypeServiceFieldId]
                        : errors[field.serviceTypeServiceFieldId]
                    )
                      ? "is_invalid"
                      : ""
                  }`}
                />

                <div className="position-absolute top-100 left-0 right-0 bottom-0 w-100 z-2">
                  {/* {!isSearch && isInventoryNotFound && !errors[field.serviceTypeServiceFieldId] && (<span>No inventory found</span>)} */}
                  {(isSearch || searchedInventories.length > 0 || isInventoryNotFound) && (
                    <div className="serched-inventory-modal row m-0 w-100 bg-white">
                      <div
                        className={`px-0 ${
                          !searchSelectedInventory ? (isInventoryNotFound ? "col-lg-12 d-block" : "col-lg-12 d-none"): "col-lg-3 d-block"
                        }`}
                      >
                        {!isSearch &&
                          isInventoryNotFound &&
                          !errors[field.serviceTypeServiceFieldId] && (
                            <div className="p-2 support-no-record-found">
                              <span>No container found</span>
                            </div>
                          )}

                        {searchedInventories.length > 0 && (
                          <div className="list-wrapper">
                            {filteredSearchedInventories
                              .filter((inventory) => {
                                // Apply filtering logic based on selectedMashBill, selectedDsp, and selectedBatchId
                                const matchMashBill =
                                  !selectedMashBill ||
                                  inventory.mashBill === selectedMashBill;
                                const matchDsp =
                                  !selectedDsp || inventory.dsp === selectedDsp;
                                return matchMashBill && matchDsp;
                              })
                              .map((inventory, index) => (
                                <div
                                  key={index}
                                  className={`list-item-wrapper ${
                                    selectedInventory === inventory ? "" : ""
                                  }`}
                                  onClick={() => {
                                    setDesiredQuantity("");
                                    // Always use original unfiltered inventory so all barrels are available
                                    const originalInv = searchedInventories.find(inv => inv.lotNo === inventory.lotNo);
                                    setSearchSelectedInventory(originalInv || inventory);
                                  }}
                                  style={{
                                    backgroundColor:
                                      searchSelectedInventory != inventory
                                        ? "#f0f0f0"
                                        : "#fff",
                                  }}
                                >
                                  <div className='d-flex justify-content-between gap-1 w-100 align-items-center flex-wrap'>
                                    <div>
                                  <p className="list-inventory-title">
                                    {highlightMatchedForBarrels(
                                      inventory.title,
                                      searchTerm
                                    )}{" "}
                                  </p>
                                    <p className="list-lot-no">
                                      Lot ID : {inventory?.lotNo}
                                    </p>
                                    </div>
                                    
                                    <div className='text-end ms-auto text-nowrap'>

                                    <span className="own-barrels">
                                      {searchedInventories?.find(inv => inv.lotNo === inventory.lotNo && inv.barrelNumbers.length > 0)?.barrelNumbers.length} Owned Container
                                    </span>
                                    <span className='d-block'>
                                       {(tabId
                                  ? finalSelectedInventoriesWithBarrelForTabs[tabId]
                                      ?.find(inv => inv.lotNo === inventory.lotNo && inv.barrelNumbers.length > 0)
                                      ?.barrelNumbers.length > 0
                                  : finalSelectedInventoriesWithBarrels
                                      ?.find(inv => inv.lotNo === inventory.lotNo && inv.barrelNumbers.length > 0)
                                      ?.barrelNumbers.length > 0 ) && (
                                    <span
                                      className="barrel-count"
                                      style={{
                                        backgroundColor:
                                          searchSelectedInventory != inventory
                                            ? "#fff"
                                            : "#f0f0f0",
                                      }}
                                    >
                                       <span className='me-1'>{tabId
                                        ? finalSelectedInventoriesWithBarrelForTabs[tabId]
                                            ?.find(inv => inv.lotNo === inventory.lotNo && inv.barrelNumbers.length > 0)
                                            ?.barrelNumbers.length
                                        : finalSelectedInventoriesWithBarrels
                                            ?.find(inv => inv.lotNo === inventory.lotNo && inv.barrelNumbers.length > 0)
                                            ?.barrelNumbers.length
                                        }
                                        </span>
                                         Selected Container
                                    </span>
                                  )}
                                    </span>
                                    </div>
                                    </div>
                                </div>
                              ))}
                          </div>
                        )}
                      </div>
                      {searchSelectedInventory && (
                        <div className="col-lg-9 px-0">
                          {/* Barrel Numbers Display */}

                          <div className="searched-inventory-modal--right">
                            <div className="right-header d-flex flex-column flex-lg-row align-items-lg-center justify-content-lg-between gap-2">
                              <div className="d-flex border overflow-hidden searched-inventory-modal-floating-action">
                                
                                <button
                                  type="button"
                                  onClick={() => {
                                    setManagedByWhitedogFilter('all');
                                    // setSearchSelectedInventory(null);
                                  }}
                                  className={`px-2 py-1 border-0 filter-btn ${
                                    managedByWhitedogFilter === 'all'
                                      ? 'filter-btn--active'
                                      : 'filter-btn--inactive'
                                  }`}
                                >
                                  All Lot(s)
                                </button>

                                <button
                                  type="button"
                                  onClick={() => {
                                    setManagedByWhitedogFilter('managed');
                                    // setSearchSelectedInventory(null);
                                  }}
                                  className={`px-2 py-1 border-0 filter-btn ${
                                    managedByWhitedogFilter === 'managed'
                                      ? 'filter-btn--active'
                                      : 'filter-btn--inactive'
                                  }`}
                                >
                                  Whitedog Managed
                                </button>

                              </div>   
                              {/* <div> */}
                              {/* Barrel Search and Random Selection */}
                              <div className="search-input-wrapper position-relative">
                                {/* Search Input */}
                                <SearchIcon
                                  sx={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "15px",
                                    transform: "translateY(-50%)",
                                  }}
                                />
                                <input
                                  type="text"
                                  placeholder="Search container id"
                                  value={barrelSearchTerm}
                                  onChange={(e) =>
                                    setBarrelSearchTerm(e.target.value)
                                  }
                                  className="form-control flex-grow"
                                />
                              </div>
                              <div className="d-flex align-items-center gap-md-4 gap-3  ms-auto flex-wrap">
                                {/* Select All Checkbox */}
                                <div className="header-field-wrapper">
                                  <input
                                    type="checkbox"
                                    id="select-all-barrels"
                                    checked={(() => {
                                      if (filteredBarrelNumbers.length === 0) return false;

                                      const filteredBarrelNumberSet = new Set(
                                        filteredBarrelNumbers
                                          .filter((b) => b.isBarrelSold !== true)
                                          .map((b) => b.barrelNumber)
                                      );

                                      const selectedBarrels = tabId
                                        ? finalSelectedInventoriesWithBarrelForTabs[tabId]
                                          ?.find((inv) => inv.lotNo === searchSelectedInventory.lotNo)
                                          ?.barrelNumbers ?? []
                                        : finalSelectedInventoriesWithBarrels
                                          ?.find((inv) => inv.lotNo === searchSelectedInventory.lotNo)
                                          ?.barrelNumbers ?? [];

                                      const selectedFilteredCount = selectedBarrels.filter(
                                        (b) => b.isBarrelSold !== true && filteredBarrelNumberSet.has(b.barrelNumber)
                                      ).length;

                                      return selectedFilteredCount === filteredBarrelNumberSet.size && filteredBarrelNumberSet.size > 0;
                                    })()}
                                    onChange={(e) => tabId ? handleSelectAllBarrelsForTabs(tabId, field.serviceTypeServiceFieldId) : handleSelectAllBarrels()}
                                    className="me-2 form-check-input"
                                  />
                                  <label
                                    htmlFor="select-all-barrels"
                                    className="header-field-label"
                                  >
                                    Select All
                                  </label>
                                </div>
                                <div className="header-field-wrapper d-flex align-items-center gap-2">
                                  <label className="header-field-label text-nowrap">
                                    Selected Quantity:
                                  </label>
                                  <div style={{ width: "70px" }}>
                                    <input
                                      type="number"
                                      // placeholder="Qty"
                                      value={desiredQuantity}
                                      onChange={(e) =>
                                        tabId ? handleRandomSelectionForTabs(e.target.value, tabId, field.serviceTypeServiceFieldId) : handleRandomSelection(e.target.value)
                                      }
                                      className="form-control"
                                      min="1"
                                    />
                                  </div>
                                </div>
                                {/* </div> */}
                              </div>
                            </div>

                            {/* Barrel Numbers List */}
                            {tabId ? (
                              <div className="barrel-list-wrapper ">
                              <div className="d-flex flex-wrap align-items-center gap-2">
                                {filteredBarrelNumbers.map((barrel, index) => (
                                  <div
                                    key={index}
                                    className={`inventery-barrel-wrapper ${
                                      finalSelectedInventoriesWithBarrelForTabs[tabId]?.find(
                                          (inv) =>
                                            inv.lotNo ===
                                            searchSelectedInventory.lotNo
                                        )
                                        ?.barrelNumbers.some(
                                          (selectedBarrel) =>
                                            selectedBarrel.barrelNumber ===
                                            barrel.barrelNumber
                                        )
                                        ? "bg-green-100 border-green-300"
                                        : "bg-gray-50 hover:bg-gray-100"
                                    }`}
                                  >
                                    {/* <div className="d-flex align-items-center gap-2 "> */}

                                    <span
                                      onClick={() =>
                                        handleSelectBarrelForTabs(barrel.barrelNumber, tabId, field.serviceTypeServiceFieldId)
                                      }
                                      className="barrel-number--inner d-flex align-items-center gap-1"
                                      style={{
                                        backgroundColor:
                                          finalSelectedInventoriesWithBarrelForTabs[tabId]?.find(
                                              (inv) =>
                                                inv.lotNo ===
                                                searchSelectedInventory.lotNo
                                            )
                                            ?.barrelNumbers.some(
                                              (selectedBarrel) =>
                                                selectedBarrel.barrelNumber ===
                                                barrel.barrelNumber
                                            )
                                            ? "transparent"
                                            : "#F7F7F7",
                                        borderColor:
                                          finalSelectedInventoriesWithBarrelForTabs[tabId]?.find(
                                              (inv) =>
                                                inv.lotNo ===
                                                searchSelectedInventory.lotNo
                                            )
                                            ?.barrelNumbers.some(
                                              (selectedBarrel) =>
                                                selectedBarrel.barrelNumber ===
                                                barrel.barrelNumber
                                            )
                                            ? "#8F9195"
                                            : "transparent",
                                      }}
                                    >
                                      {finalSelectedInventoriesWithBarrelForTabs[tabId]?.find(
                                          (inv) =>
                                            inv.lotNo ===
                                            searchSelectedInventory.lotNo
                                        )
                                        ?.barrelNumbers.some(
                                          (selectedBarrel) =>
                                            selectedBarrel.barrelNumber ===
                                            barrel.barrelNumber
                                        ) ? (
                                        <DoneIcon />
                                      ) : (
                                        <AddSharpIcon sx={{ mr: 0.5 }} />
                                      )}
                                      <span className="barrel-number">
                                        {highlightMatchedForBarrels(
                                          barrel.barrelNumber,
                                          barrelSearchTerm
                                        )}
                                      </span>
                                    </span>
                                    {/* </div> */}
                                  </div>
                                ))}
                              </div>
                            </div>
                            ) : 
                            (<div className="barrel-list-wrapper ">
                              <div className="d-flex flex-wrap align-items-center gap-2">
                                {filteredBarrelNumbers.map((barrel, index) => (
                                  <div
                                    key={index}
                                    className={`inventery-barrel-wrapper ${
                                      finalSelectedInventoriesWithBarrels
                                        .find(
                                          (inv) =>
                                            inv.lotNo ===
                                            searchSelectedInventory.lotNo
                                        )
                                        ?.barrelNumbers.some(
                                          (selectedBarrel) =>
                                            selectedBarrel.barrelNumber ===
                                            barrel.barrelNumber
                                        )
                                        ? "bg-green-100 border-green-300"
                                        : "bg-gray-50 hover:bg-gray-100"
                                    }`}
                                  >
                                    {/* <div className="d-flex align-items-center gap-2 "> */}

                                    <span
                                      onClick={() =>
                                        handleSelectBarrel(barrel.barrelNumber)
                                      }
                                      className="barrel-number--inner d-flex align-items-center gap-1"
                                      style={{
                                        backgroundColor:
                                          finalSelectedInventoriesWithBarrels
                                            .find(
                                              (inv) =>
                                                inv.lotNo ===
                                                searchSelectedInventory.lotNo
                                            )
                                            ?.barrelNumbers.some(
                                              (selectedBarrel) =>
                                                selectedBarrel.barrelNumber ===
                                                barrel.barrelNumber
                                            )
                                            ? "transparent"
                                            : "#F7F7F7",
                                        borderColor:
                                          finalSelectedInventoriesWithBarrels
                                            .find(
                                              (inv) =>
                                                inv.lotNo ===
                                                searchSelectedInventory.lotNo
                                            )
                                            ?.barrelNumbers.some(
                                              (selectedBarrel) =>
                                                selectedBarrel.barrelNumber ===
                                                barrel.barrelNumber
                                            )
                                            ? "#8F9195"
                                            : "transparent",
                                      }}
                                    >
                                      {finalSelectedInventoriesWithBarrels
                                        .find(
                                          (inv) =>
                                            inv.lotNo ===
                                            searchSelectedInventory.lotNo
                                        )
                                        ?.barrelNumbers.some(
                                          (selectedBarrel) =>
                                            selectedBarrel.barrelNumber ===
                                            barrel.barrelNumber
                                        ) ? (
                                        <DoneIcon />
                                      ) : (
                                        <AddSharpIcon sx={{ mr: 0.5 }} />
                                      )}
                                      <span className="barrel-number">
                                        {highlightMatchedForBarrels(
                                          barrel.barrelNumber,
                                          barrelSearchTerm
                                        )}
                                      </span>
                                    </span>
                                    {/* </div> */}
                                  </div>
                                ))}
                              </div>
                            </div>)}


                            <div className="modal-footer-wrapper">
                              <button
                                onClick={handleDoneSelection}
                                className="done-btn"
                                // disabled={
                                //   !finalSelectedInventoriesWithBarrels.find(
                                //     (inv) =>
                                //       inv.lotId ===
                                //       searchSelectedInventory.lotNo
                                //   )?.barrelNumbers.length
                                // }
                              >
                                <DoneIcon className="me-1" />
                                Done
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                    {isSearch && !isDestination && (  
                      <div className='col-12 px-0'>
                        <div className='d-flex align-items-center justify-content-center loader-wrapper'>
                        <div className='position-relative'>
                          <span className='loader-border'>
                            <svg width="128" height="128" viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M123.754 63.9999C123.754 50.8191 119.396 38.0079 111.358 27.5615C103.32 17.1151 92.0535 9.61938 79.3128 6.24159C66.5721 2.86382 53.0721 3.79381 40.9147 8.88614C28.7572 13.9785 18.6247 22.9478 12.0948 34.3974C5.56485 45.847 3.00364 59.1343 4.8104 72.1907C6.61719 85.247 12.6903 97.3398 22.0841 106.586C31.478 115.832 43.6659 121.713 56.7494 123.312C69.8327 124.911 83.0779 122.14 94.4224 115.429C95.4315 114.832 96.7335 115.166 97.3306 116.175C97.9276 117.185 97.5934 118.487 96.5841 119.084C84.4334 126.272 70.2471 129.24 56.234 127.527C42.2208 125.814 29.1669 119.516 19.1054 109.612C9.04397 99.7094 2.53947 86.7572 0.604239 72.773C-1.33094 58.7888 1.41186 44.557 8.40578 32.2937C15.3998 20.0305 26.2523 10.4233 39.2737 4.96908C52.2951 -0.485167 66.7549 -1.4805 80.4011 2.13733C94.0471 5.75518 106.114 13.7833 114.723 24.972C123.332 36.1609 128 49.8824 128 63.9999C128 65.1725 127.049 66.1231 125.877 66.1231C124.704 66.1231 123.754 65.1725 123.754 63.9999Z" fill="#3A809E"/>
                            </svg>
                          </span>
                          <span className='loader-image'>
                            <img src={LoaderImage} alt='Loader Image'/>
                          </span>
                        </div>  
                        </div>
                      </div>
                    )}
                    </div>
                   )}
                </div>
              </div>
              
              {/* Final Selected Container Display */}
              {isDoneButtonClicked &&
                (finalSelectedInventoriesWithBarrels.length > 0 || finalSelectedInventoriesWithBarrelForTabs[tabId]?.length > 0) && (
                  <div className="selected-inventory-detail-wrapper">
                    {(tabId
                      ? finalSelectedInventoriesWithBarrelForTabs[tabId] || []
                      : finalSelectedInventoriesWithBarrels
                    ).map(
                      (inventory, index) => (
                        <div
                          key={index}
                          className="selected-inventory-detail-inner"
                        >
                          <div className="header-wrapper d-flex flex-column flex-lg-row align-items-lg-center justify-content-lg-between gap-2">
                            <div className="detail-heading">
                              {inventory.productName}{" "}
                              <span className="font-semibold text-gray-800">
                                ({inventory.lotNo})
                              </span>
                              <div className='lot-info-icon-wrapper'>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M10 1.875C8.39303 1.875 6.82214 2.35152 5.486 3.24431C4.14985 4.1371 3.10844 5.40605 2.49348 6.8907C1.87852 8.37535 1.71762 10.009 2.03112 11.5851C2.34463 13.1612 3.11846 14.6089 4.25476 15.7452C5.39106 16.8815 6.8388 17.6554 8.41489 17.9689C9.99099 18.2824 11.6247 18.1215 13.1093 17.5065C14.594 16.8916 15.8629 15.8502 16.7557 14.514C17.6485 13.1779 18.125 11.607 18.125 10C18.1227 7.84581 17.266 5.78051 15.7427 4.25727C14.2195 2.73403 12.1542 1.87727 10 1.875ZM9.6875 5.625C9.87292 5.625 10.0542 5.67998 10.2084 5.783C10.3625 5.88601 10.4827 6.03243 10.5536 6.20373C10.6246 6.37504 10.6432 6.56354 10.607 6.7454C10.5708 6.92725 10.4815 7.0943 10.3504 7.22541C10.2193 7.35652 10.0523 7.44581 9.8704 7.48199C9.68854 7.51816 9.50004 7.49959 9.32874 7.42864C9.15743 7.35768 9.01101 7.23752 8.908 7.08335C8.80499 6.92918 8.75 6.74792 8.75 6.5625C8.75 6.31386 8.84878 6.0754 9.02459 5.89959C9.20041 5.72377 9.43886 5.625 9.6875 5.625ZM10.625 14.375C10.2935 14.375 9.97554 14.2433 9.74112 14.0089C9.5067 13.7745 9.375 13.4565 9.375 13.125V10C9.20924 10 9.05027 9.93415 8.93306 9.81694C8.81585 9.69973 8.75 9.54076 8.75 9.375C8.75 9.20924 8.81585 9.05027 8.93306 8.93306C9.05027 8.81585 9.20924 8.75 9.375 8.75C9.70652 8.75 10.0245 8.8817 10.2589 9.11612C10.4933 9.35054 10.625 9.66848 10.625 10V13.125C10.7908 13.125 10.9497 13.1908 11.0669 13.3081C11.1842 13.4253 11.25 13.5842 11.25 13.75C11.25 13.9158 11.1842 14.0747 11.0669 14.1919C10.9497 14.3092 10.7908 14.375 10.625 14.375Z" fill="#616161"/>
                                </svg>
                                <div className='info-card-wrapper'>
                                  <div className="info-card">
                                    <div className="section">
                                      <div className="label">Age</div>
                                      <div className="value">
                                        {getDurationFromDate(inventory?.fillDate)}
                                      </div>
                                    </div>

                                    <div className="section">
                                      <div className="label">Mash Bill</div>
                                      <div className="value">{inventory?.mashBill || "-"}</div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="d-flex align-items-center gap-2 ms-auto flex-wrap justify-content-end">
                              <div className="total-quantity">
                                Quantity:
                                <span> {inventory.barrelNumbers.length}</span>
                              </div>
                              <button
                                className="remove-btn"
                                onClick={(e) =>
                                 tabId ? handleRemoveInventoryForTabs(e,inventory.lotNo, tabId) : handleRemoveInventory(e, inventory.lotNo)
                                }
                              >
                                {/* <RemoveIcon className="me-1" /> */}
                                <img
                                  src={TrashIcon}
                                  alt="TrashIcon"
                                  className="me-1"
                                />
                                Remove Item
                              </button>
                            </div>
                          </div>
                          <div
                            className={`total-barrel-list-wrapper ${
                              selectedServiceName ==
                                Constant.CustomerService.SELL_REQUEST &&
                              id &&
                              "edit-total-barrels"
                            }`}
                          >
                            <div className="bareels--list-wrapper">
                              {(selectedServiceName !=
                                Constant.CustomerService.SELL_REQUEST ||
                                !id) && (
                                <div className="d-flex flex-wrap gap-2 align-items-center mt-2">
                                  {inventory.barrelNumbers.map((barrel, barrelIndex) => (
                                    <div key={barrelIndex} className="barrel-item-outer cursor-pointer">
                                      <div className="barrel-item-wrapper d-flex align-items-center gap-1 w-100 cursor-pointer">
                                        <DoneIcon />

                                        <span>
                                          {barrel.barrelNumber}
                                        </span>
                                        <span className='source-name'>Source</span>
                                        <div className="barrel-type">
                                          {barrel.containerType}
                                        </div>
                                      </div>
                                      <OverlayTrigger
                                        trigger="click"
                                        placement="bottom-start"
                                        show={openPopupForBarrelId === barrel.barrelId}

                                        overlay={
                                          <div className="blending-dropdwon-wrapper">

                                            {/* ---------- FIX ADDED HERE ---------- */}
                                            {(() => {

                                              // 1 Get all selected container for THIS source barrel
                                              const selectedForThisBarrel =
                                                finalSelectedSourceToDestinationInventories
                                                  .flatMap(inv => inv.destinationBarrelNumberResponse || [])
                                                  .filter(b => b.sourceBarrelId === barrel.barrelId);

                                              // 2 Calculate Distributed Volume (keep original numbers)
                                              const distributedVolumes = selectedForThisBarrel.reduce((sum, b) => {
                                                const inputValue = barrelVolumes[b.sourceBarrelId]?.[b.barrelId];

                                                const volumeToUse =
                                                  (parseFloat(inputValue) || 0) +
                                                  (parseFloat(b.volume) || 0);

                                                return sum + (isNaN(volumeToUse) ? 0 : volumeToUse);
                                              }, 0);

                                              // Available Volume (keep math correct)
                                              const availableVolume = barrel.volume - distributedVolumes;

                                              // Values for display only (rounded down)
                                              const displayCurrentVolume = formatVolume(barrel.volume);
                                              const displayAvailableVolume = formatVolume(availableVolume);
                                              const displayDistributedVolumes = formatVolume(distributedVolumes);

                                              return (
                                                <div className="dropdown-header">
                                                  <div className="header-item">
                                                    <p className="header-item-key">Current Volume</p>
                                                    <p className="header-item-value">{displayCurrentVolume} Gal</p>
                                                  </div>

                                                  <div className="header-item">
                                                    <p className="header-item-key">Distributed Volume</p>
                                                    <p className="header-item-value">
                                                      {displayDistributedVolumes} Gal
                                                    </p>
                                                  </div>

                                                  <div className="header-item">
                                                    <p className="header-item-key">Available Volume</p>
                                                    <p className="header-item-value">
                                                      {displayAvailableVolume} Gal
                                                    </p>
                                                  </div>
                                                </div>
                                              );
                                            })()}

                                            {/* ---------- FIX ENDS HERE ---------- */}
                                            <div className="header-search-wrapper">
                                              <div className="position-relative">
                                                <SearchIcon
                                                  sx={{
                                                    position: "absolute",
                                                    top: "50%",
                                                    left: "15px",
                                                    transform: "translateY(-50%)",
                                                  }}
                                                />
                                                <input
                                                  type="text"
                                                  placeholder="Search by Container Id"
                                                  value={destinationBarrelSearchTerm}
                                                  disabled={isEditMode}
                                                  onChange={(e) => setDestinationBarrelSearchTerm(e.target.value)}
                                                  className="form-control service-req-input add-inventory"
                                                />
                                              </div>
                                            </div>

                                            <div className="dropdown-body">
                                              {searchedSourceToDestinationInventory.map((item, index) =>
                                                item.destinationBarrelNumberResponse
                                                  ?.filter((destinationBarrel) =>
                                                    destinationBarrel.barrelNumber
                                                      .toLowerCase()
                                                      .includes(destinationBarrelSearchTerm.toLowerCase())
                                                  )
                                                  .map((destinationBarrel, idx) => {
                                                    const isSelected = finalSelectedSourceToDestinationInventories.some(
                                                      (inv) =>
                                                        inv.destinationBarrelNumberResponse?.some(
                                                          (b) =>
                                                            b.barrelNumber === destinationBarrel.barrelNumber &&
                                                            b.sourceBarrelId === selectedSourceBarrel?.barrelId
                                                        )
                                                    );

                                                    return (
                                                      <div
                                                        key={`${item.inventoryId || index}-${destinationBarrel.barrelId || idx}`}
                                                        className={`barrel-detail-wrapper ${isSelected ? "selected" : ""}`}>
                                                        <div className="barrel-item">
                                                          <div className="barrel-number">
                                                            <span className="select-icon"
                                                              onClick={(e) => { e.stopPropagation();
                                                                if (isSelected) {
                                                                  handleUnselectDestinationBarrel(
                                                                    destinationBarrel.barrelId,
                                                                    selectedSourceBarrel?.barrelId
                                                                  );
                                                                } else {
                                                                  handleSelectDestinationBarrel(
                                                                    destinationBarrel.barrelNumber,
                                                                    selectedSourceBarrel?.barrelId,
                                                                    selectedSourceBarrel?.barrelNumber
                                                                  );
                                                                }
                                                              }}>{isSelected ? <DoneIcon /> : <AddIcon />}
                                                            </span>
                                                            {destinationBarrel?.containerType === "BARREL" && (
                                                              destinationBarrel?.containerCooperage === "NEW" ? (
                                                                <span className="cooperage-text new-text">N</span>
                                                              ) : destinationBarrel?.containerCooperage === "REUSED" ? (
                                                                <span className="cooperage-text">R</span>
                                                              ) : null
                                                            )}
                                                            {highlightMatchedForBarrels(
                                                              destinationBarrel.barrelNumber,
                                                              destinationBarrelSearchTerm
                                                            )}
                                                          </div>
                                                          <div className="barrel-type">{destinationBarrel.containerType}</div>
                                                        </div>

                                                        {isSelected && (
                                                          <>
                                                            <div className="fill-detail-wrapper">
                                                              <div className="d-flex align-items-center gap-1">
                                                                <div className="d-flex align-items-center gap-1">
                                                                  <div>
                                                                   {(() => {
                                                                      const inputValue = barrelVolumes[barrel.barrelId]?.[destinationBarrel.barrelId];
                                                                      const volumeToUse =
                                                                        inputValue !== undefined && inputValue !== ""
                                                                          ? parseFloat(inputValue)
                                                                          : parseFloat(destinationBarrel.volume || 0);

                                                                      const finalVolume = isNaN(volumeToUse) ? 0 : volumeToUse;

                                                                      return (finalVolume === 0 && inputValue !== "0") ? (
                                                                        <div className={
                                                                            destinationBarrel.volume === 0
                                                                              ? "fill-detail-item empty-item"
                                                                              : "fill-detail-item"
                                                                          }>
                                                                          <img
                                                                            src={destinationBarrel.volume === 0 ? EmptyBarrel : FilledBarrel}
                                                                            alt={destinationBarrel.volume === 0 ? "empty-barrel" : "filled-barrel"}
                                                                          />
                                                                          {(() => {
                                                                            const inputValue =
                                                                              barrelVolumes[barrel.barrelId]?.[destinationBarrel.barrelId] === undefined
                                                                                ? destinationBarrel.volume
                                                                                : barrelVolumes[barrel.barrelId]?.[destinationBarrel.barrelId];

                                                                            const maxVolume = formatVolume(barrel.volume);
                                                                            return `${formatVolume(destinationBarrel.volume)} / ${formatVolume(maxVolume)} Gal`;
                                                                          })()}
                                                                        </div>
                                                                      ) : (
                                                                         <div className={
                                                                            destinationBarrel.volume === 0
                                                                              ? "fill-detail-item empty-item"
                                                                              : "fill-detail-item"
                                                                          }>
                                                                          <img
                                                                            src={destinationBarrel.volume === 0 ? EmptyBarrel : FilledBarrel}
                                                                            alt={destinationBarrel.volume === 0 ? "empty-barrel" : "filled-barrel"}
                                                                          />
                                                                          {(() => {
                                                                            const inputValue =
                                                                              barrelVolumes[barrel.barrelId]?.[destinationBarrel.barrelId] === undefined
                                                                                ? destinationBarrel.volume
                                                                                : barrelVolumes[barrel.barrelId]?.[destinationBarrel.barrelId];

                                                                            const maxVolume = formatVolume(barrel.volume);
                                                                            return `${formatVolume(destinationBarrel.volume)} / ${formatVolume(maxVolume)} Gal`;
                                                                          })()}
                                                                        </div>
                                                                      );
                                                                    })()}
                                                                  </div>
                                                                </div>
                                                              </div>

                                                              <div className="vr"></div>

                                                              <div className="fill-detail-input-wrapper">
                                                              <input
                                                                  type="text"
                                                                  inputMode="decimal"
                                                                  placeholder="Enter Volume"
                                                                  value={
                                                                    barrelVolumes[barrel.barrelId]?.[destinationBarrel.barrelId] != null && barrelVolumes[barrel.barrelId]?.[destinationBarrel.barrelId] !== 0
                                                                      ? barrelVolumes[barrel.barrelId]?.[destinationBarrel.barrelId]
                                                                      : destinationBarrel.distributedVolume || ""
                                                                  }
                                                                  onClick={(e) => e.stopPropagation()}
                                                                  onChange={(e) => {
                                                                    const v = e.target.value;

                                                                    // Allow only numbers with an optional decimal point.
                                                                    if (!/^\d*\.?\d*$/.test(v)) {
                                                                      return;
                                                                    }

                                                                    setBarrelVolumes(prev => ({
                                                                      ...prev,
                                                                      [barrel.barrelId]: {
                                                                        ...(prev[barrel.barrelId] || {}),
                                                                        [destinationBarrel.barrelId]: v
                                                                      }
                                                                    }));

                                                                    const isRequiredError = v === "" || Number(v) <= 0;

                                                                    setBarrelErrors(prev => ({
                                                                      ...prev,
                                                                      [destinationBarrel.barrelId]: isRequiredError
                                                                    }));

                                                                    if (isRequiredError) {
                                                                      setBarrelCapacityErrors(prev => ({
                                                                        ...prev,
                                                                        [destinationBarrel.barrelId]: false
                                                                      }));
                                                                    }
                                                                  }}
                                                                  style={{
                                                                    borderColor:
                                                                      barrelErrors[destinationBarrel.barrelId] ? "red" : "#D1D1D1",
                                                                  }}
                                                                  />
                                                              </div>
                                                            </div>

                                                            {barrelErrors[destinationBarrel.barrelId] && (
                                                              <p className="fill-error" style={{ fontSize: "13px" }}>
                                                                Selected Container Volume is required
                                                              </p>
                                                            )}

                                                            {/* Here we check against distributedVolumes instead of destinationBarrel.volume */}
                                                            {(() => {
                                                              const inputValue = barrelVolumes[barrel.barrelId]?.[destinationBarrel.barrelId];

                                                              const enteredVolume = inputValue !== undefined && inputValue !== ""
                                                                  ? parseFloat(inputValue) : 0;

                                                              // 1 Total already filled (static volumes)
                                                              const alreadyDistributed =
                                                                barrel.finalSelectedDestinationInventoriesRequest
                                                                  ?.flatMap(f => f?.destinationBarrelNumberResponse || [])
                                                                  ?.reduce(
                                                                    (sum, d) => sum + (parseFloat(d.volume) || 0),
                                                                    0
                                                                  ) || 0;

                                                              // 2 Sum of inputs from OTHER container
                                                              const otherInputs =
                                                                barrel.finalSelectedDestinationInventoriesRequest
                                                                  ?.flatMap(f => f?.destinationBarrelNumberResponse || [])
                                                                  ?.reduce((sum, d) => {
                                                                    if (d.barrelId === destinationBarrel.barrelId) return sum;

                                                                    const v =
                                                                      barrelVolumes[barrel.barrelId]?.[d.barrelId];

                                                                    return sum + (parseFloat(v) || 0);
                                                                  }, 0) || 0;

                                                              // 3 Available volume
                                                              const availableVolume = barrel.volume - alreadyDistributed;

                                                              // 4 Max allowed for THIS input
                                                              const maxAllowed = availableVolume - otherInputs;

                                                              const enteredVolumeRounded = roundToPrecision(enteredVolume, 2);
                                                              const maxAllowedRounded = roundToPrecision(maxAllowed, 2);
                                                              const hasRequiredError = barrelErrors[destinationBarrel.barrelId];
                                                              const isCapacityExceeded = !hasRequiredError && enteredVolumeRounded > maxAllowedRounded;

                                                              // store error in state
                                                              if (barrelCapacityErrors[destinationBarrel.barrelId] !== isCapacityExceeded) {
                                                                setBarrelCapacityErrors(prev => ({
                                                                  ...prev,
                                                                  [destinationBarrel.barrelId]: isCapacityExceeded
                                                                }));
                                                              }
                                                              
                                                              if (!hasRequiredError && isCapacityExceeded) {
                                                                return (
                                                                  <p className="fill-error" style={{ fontSize: "13px" }}>
                                                                    This value exceeds the container’s maximum capacity of{" "}
                                                                    {formatVolume(maxAllowedRounded)} Gal. Enter a lower volume.
                                                                  </p>
                                                                );
                                                              }
                                                              return null;
                                                            })()}

                                                          </>
                                                        )}
                                                      </div>
                                                    );
                                                  })
                                              )}
                                            </div>

                                            <div className="dropdown-footer">
                                              <button
                                                className="done-btn"
                                                onClick={handleDone}>
                                                <DoneIcon className="me-1" />Done </button>
                                            </div>
                                          </div>
                                        }
                                      >
                                        <div
                                          className="link-btn-wrapper"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setSelectedSourceBarrel({
                                              barrelId: barrel.barrelId,
                                              barrelNumber: barrel.barrelNumber,
                                              lotNo: inventory.lotNo,
                                              productName: inventory.productName,
                                              volume: barrel.volume,
                                              containerType: barrel.containerType,
                                              dsp: barrel.dsp,
                                              mashBill: barrel.mashBill,
                                              description: barrel.description,
                                              producer: barrel.producer
                                            });

                                            if (!isEditMode) {
                                              fetchBarrelDestinationList("", field.serviceTypeServiceFieldId, tabId);
                                            }

                                            setOpenPopupForBarrelId((prev) =>
                                              prev === barrel.barrelId ? null : barrel.barrelId
                                            );
                                          }}
                                        >
                                          <LinkIcon
                                            sx={{ color: "#616161", transform: "rotate(-45deg)" }}
                                          />

                                          {finalSelectedSourceToDestinationInventories.length === 0 && (
                                            <>Link Destination Container(s)</>
                                          )}
                                          <span className="destination-text">Destination</span>

                                          {finalSelectedSourceToDestinationInventories.length > 0 &&
                                            (() => {
                                              const destList =
                                                finalSelectedSourceToDestinationInventories
                                                  .flatMap((inv) => inv.destinationBarrelNumberResponse)
                                                  .filter((b) => b.sourceBarrelId === barrel.barrelId);

                                              if (destList.length === 0)
                                                return <>Link Destination Container(s)</>;

                                              const firstBarrel = destList[0]?.barrelNumber;
                                              const count = destList.length - 1;

                                              return (
                                                <>
                                                  {/* <span className="selected-barrel-text"> */}
                                                  {firstBarrel}
                                                  {/* </span> */}
                                                  {count > 0 && (
                                                    <span className="barrel-count">+{count}</span>
                                                  )}
                                                </>
                                              );
                                            })()}

                                          <KeyboardArrowDownIcon sx={{ color: "#3A809E",marginTop:"3px" }} />
                                        </div>
                                      </OverlayTrigger>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>

                            {/* Sold container Section */}
                            {selectedServiceName ==
                              Constant.CustomerService.SELL_REQUEST &&
                              id && (
                                <>
                                  <div className="bareels--list-wrapper row m-0">
                                    {inventory.barrelNumbers.filter(
                                      (barrel) => barrel.isBarrelSold === true
                                    ).length > 0 && (
                                      <div
                                        className={`sold-barrels ${
                                          inventory.barrelNumbers.filter(
                                            (barrel) =>
                                              barrel.isBarrelSold !== true
                                          ).length === 0
                                            ? "col-12 border-0"
                                            : "col-md-6"
                                        }`}
                                      >
                                        <div className="barrel-section">
                                          <h6 className="barrel-section-title mb-2">
                                            Sold (
                                            {
                                              inventory.barrelNumbers.filter(
                                                (barrel) =>
                                                  barrel.isBarrelSold === true
                                              ).length
                                            }
                                            )
                                            <LocalOfferOutlinedIcon
                                              sx={{ color: "#858585" }}
                                            />
                                          </h6>
                                          <div className="d-flex flex-wrap gap-2 align-items-center">
                                            {inventory.barrelNumbers
                                              .filter(
                                                (barrel) =>
                                                  barrel.isBarrelSold === true
                                              )
                                              .map((barrel, barrelIndex) => (
                                                <div
                                                  key={barrelIndex}
                                                  className=""
                                                >
                                                  <div className="barrel-item-wrapper d-flex align-items-center gap-1 w-100">
                                                    <DoneIcon />
                                                    <span>
                                                      {barrel.barrelNumber}
                                                    </span>
                                                  </div>
                                                </div>
                                              ))}
                                          </div>
                                          {inventory.barrelNumbers.filter(
                                            (barrel) =>
                                              barrel.isBarrelSold === true
                                          ).length === 0 && (
                                            <p className="text-muted small">
                                              No sold container
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                    )}

                                    {/* Ready to Sell Container Section */}
                                    {inventory.barrelNumbers.filter(
                                      (barrel) => barrel.isBarrelSold !== true
                                    ).length > 0 && (
                                      <div
                                        className={`${
                                          inventory.barrelNumbers.filter(
                                            (barrel) =>
                                              barrel.isBarrelSold === true
                                          ).length === 0
                                            ? " col-12"
                                            : "col-md-6"
                                        }`}
                                      >
                                        <div className="barrel-section">
                                          <h6 className="barrel-section-title mb-2">
                                            Ready to Sell (
                                            {
                                              inventory.barrelNumbers.filter(
                                                (barrel) =>
                                                  barrel.isBarrelSold !== true
                                              ).length
                                            }
                                            )
                                            <ShoppingCartOutlinedIcon
                                              sx={{ color: "#858585" }}
                                            />
                                          </h6>
                                          <div className="d-flex flex-wrap gap-2 align-items-center">
                                            {inventory.barrelNumbers
                                              .filter(
                                                (barrel) =>
                                                  barrel.isBarrelSold !== true
                                              )
                                              .map((barrel, barrelIndex) => (
                                                <div
                                                  key={barrelIndex}
                                                  className=""
                                                >
                                                  <div className="barrel-item-wrapper d-flex align-items-center gap-1 w-100">
                                                    <DoneIcon />
                                                    <span>
                                                      {barrel.barrelNumber}
                                                    </span>
                                                  </div>
                                                </div>
                                              ))}
                                          </div>
                                          {inventory.barrelNumbers.filter(
                                            (barrel) =>
                                              barrel.isBarrelSold !== true
                                          ).length === 0 && (
                                            <p className="text-muted small">
                                              No ready to sell container
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </>
                              )}
                          </div>
                        </div>
                      )
                    )}
                  </div>
                )}
              {field.mandatory &&
                (tabId
                  ? errorsForTabs[tabId]?.[field.serviceTypeServiceFieldId]
                  : errors[field.serviceTypeServiceFieldId]) && (
                  <span className="error-message">This field is required</span>
              )}
            </div>
          </div>
        );
      case Constant.FIELD_TYPES.ADD_INVENTORY:
      case Constant.FIELD_TYPES.ADD_CONTAINER:
        return (
          <div className="col-12">
            <div key={field.fieldName} className="form__field--wrapper">
              {/* Field Label */}
              <label className="block mb-2 form-label">
                {field.fieldName}
                {field.mandatory && (
                  <span className="star-required text-danger">*</span>
                )}
              </label>
              <div className="position-relative">
                  <SearchIcon
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: "15px",
                      transform: "translateY(-50%)",
                    }}
                  />
                <input
                  type="text"
                  value={searchTerm}
                  placeholder="Search by Product Name, Lot ID or Container Id"
                  onClick={(e) =>
                  handleSearchInventory(
                      e.currentTarget.value,
                      field.serviceTypeServiceFieldId,
                      tabId
                    )
                  }
                  onChange={(e) =>
                    handleSearchInventory(
                      e.target.value,
                      field.serviceTypeServiceFieldId,
                      tabId
                    )
                  }
                  className={`form-control service-req-input add-inventory ${
                    field.mandatory &&
                    (
                      tabId
                        ? errorsForTabs[tabId]?.[field.serviceTypeServiceFieldId]
                        : errors[field.serviceTypeServiceFieldId]
                    )
                      ? "is_invalid"
                      : ""
                  }`}
                />

                <div className="position-absolute top-100 left-0 right-0 bottom-0 w-100 z-2">
                  {/* {!isSearch && isInventoryNotFound && !errors[field.serviceTypeServiceFieldId] && (<span>No inventory found</span>)} */}
                  {(isSearch || searchedInventories.length > 0 || isInventoryNotFound) && (
                    <div className="serched-inventory-modal row m-0 w-100 bg-white">
                      <div
                        className={`px-0 ${
                          !searchSelectedInventory ? (isInventoryNotFound ? "col-lg-12 d-block" : "col-lg-12 d-none"): "col-lg-3 d-block"
                        }`}
                      >
                        {!isSearch &&
                          isInventoryNotFound &&
                          !errors[field.serviceTypeServiceFieldId] && (
                            <div className="p-2 support-no-record-found">
                              <span>No container found</span>
                            </div>
                          )}

                        {searchedInventories.length > 0 && (
                          <div className="list-wrapper">
                            {filteredSearchedInventories
                              .filter((inventory) => {
                                // Apply filtering logic based on selectedMashBill, selectedDsp, and selectedBatchId
                                const matchMashBill =
                                  !selectedMashBill ||
                                  inventory.mashBill === selectedMashBill;
                                const matchDsp =
                                  !selectedDsp || inventory.dsp === selectedDsp;
                                return matchMashBill && matchDsp;
                              })
                              .map((inventory, index) => (
                                <div
                                  key={index}
                                  className={`list-item-wrapper ${
                                    selectedInventory === inventory ? "" : ""
                                  }`}
                                  onClick={() => {
                                    setDesiredQuantity("");
                                    // Always use original unfiltered inventory so all barrels are available
                                    const originalInv = searchedInventories.find(inv => inv.lotNo === inventory.lotNo);
                                    setSearchSelectedInventory(originalInv || inventory);
                                  }}
                                  style={{
                                    backgroundColor:
                                      searchSelectedInventory != inventory
                                        ? "#f0f0f0"
                                        : "#fff",
                                  }}
                                >
                                  <div className='d-flex justify-content-between gap-1 w-100 align-items-center flex-wrap'>
                                    <div>
                                  <p className="list-inventory-title">
                                    {highlightMatchedForBarrels(
                                      inventory.title,
                                      searchTerm
                                    )}{" "}
                                  </p>
                                    <p className="list-lot-no">
                                      Lot ID : {inventory?.lotNo}
                                    </p>
                                    </div>
                                    
                                    <div className='text-end ms-auto text-nowrap'>

                                    <span className="own-barrels">
                                      {inventory.barrelNumbers.length} Owned Container
                                    </span>
                                    <span className='d-block'>
                                       {(tabId
                                  ? finalSelectedInventoriesWithBarrelForTabs[tabId]
                                      ?.find(inv => inv.lotNo === inventory.lotNo && inv.barrelNumbers.length > 0)
                                      ?.barrelNumbers.length > 0
                                  : finalSelectedInventoriesWithBarrels
                                      ?.find(inv => inv.lotNo === inventory.lotNo && inv.barrelNumbers.length > 0)
                                      ?.barrelNumbers.length > 0 ) && (
                                    <span
                                      className="barrel-count"
                                      style={{
                                        backgroundColor:
                                          searchSelectedInventory != inventory
                                            ? "#fff"
                                            : "#f0f0f0",
                                      }}
                                    >
                                       <span className='me-1'>{tabId
                                        ? finalSelectedInventoriesWithBarrelForTabs[tabId]
                                            ?.find(inv => inv.lotNo === inventory.lotNo && inv.barrelNumbers.length > 0)
                                            ?.barrelNumbers.length
                                        : finalSelectedInventoriesWithBarrels
                                            ?.find(inv => inv.lotNo === inventory.lotNo && inv.barrelNumbers.length > 0)
                                            ?.barrelNumbers.length
                                        }
                                        </span>
                                         Selected Container
                                    </span>
                                  )}
                                    </span>
                                    </div>
                                    </div>
                                  {/* {(tabId
                                  ? finalSelectedInventoriesWithBarrelForTabs[tabId]
                                      ?.find(inv => inv.lotNo === inventory.lotNo && inv.barrelNumbers.length > 0)
                                      ?.barrelNumbers.length > 0
                                  : finalSelectedInventoriesWithBarrels
                                      ?.find(inv => inv.lotNo === inventory.lotNo && inv.barrelNumbers.length > 0)
                                      ?.barrelNumbers.length > 0 ) && (
                                    <span
                                      className="barrel-count"
                                      style={{
                                        backgroundColor:
                                          searchSelectedInventory != inventory
                                            ? "#fff"
                                            : "#f0f0f0",
                                      }}
                                    >
                                       {tabId
                                        ? finalSelectedInventoriesWithBarrelForTabs[tabId]
                                            ?.find(inv => inv.lotNo === inventory.lotNo && inv.barrelNumbers.length > 0)
                                            ?.barrelNumbers.length
                                        : finalSelectedInventoriesWithBarrels
                                            ?.find(inv => inv.lotNo === inventory.lotNo && inv.barrelNumbers.length > 0)
                                            ?.barrelNumbers.length
                                        }
                                        Selected Container
                                    </span>
                                  )} */}
                                </div>
                              ))}
                          </div>
                        )}
                      </div>
                      {searchSelectedInventory && (
                        <div className="col-lg-9 px-0">
                          {/* Barrel Numbers Display */}

                          <div className="searched-inventory-modal--right">
                            <div className="right-header d-flex flex-column flex-lg-row align-items-lg-center justify-content-lg-between gap-2">
                              <div className="d-flex border overflow-hidden searched-inventory-modal-floating-action">
                                
                                <button
                                  type="button"
                                  onClick={() => {
                                    setManagedByWhitedogFilter('all');
                                    // setSearchSelectedInventory(null);
                                  }}
                                  className={`px-2 py-1 border-0 filter-btn ${
                                    managedByWhitedogFilter === 'all'
                                      ? 'filter-btn--active'
                                      : 'filter-btn--inactive'
                                  }`}
                                >
                                  All Lot(s)
                                </button>

                                <button
                                  type="button"
                                  onClick={() => {
                                    setManagedByWhitedogFilter('managed');
                                    // setSearchSelectedInventory(null);
                                  }}
                                  className={`px-2 py-1 border-0 filter-btn ${
                                    managedByWhitedogFilter === 'managed'
                                      ? 'filter-btn--active'
                                      : 'filter-btn--inactive'
                                  }`}
                                >
                                  Whitedog Managed
                                </button>

                              </div>                             
                              {/* <div> */}
                              {/* Barrel Search and Random Selection */}
                              <div className="search-input-wrapper position-relative">
                                {/* Search Input */}
                                <SearchIcon
                                  sx={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "15px",
                                    transform: "translateY(-50%)",
                                  }}
                                />
                                <input
                                  type="text"
                                  placeholder="Search container id"
                                  value={barrelSearchTerm}
                                  onChange={(e) =>
                                    setBarrelSearchTerm(e.target.value)
                                  }
                                  className="form-control flex-grow"
                                />
                              </div>
                              <div className="d-flex align-items-center gap-md-4 gap-3  ms-auto flex-wrap">
                                {/* Select All Checkbox */}
                                <div className="header-field-wrapper">
                                  <input
                                    type="checkbox"
                                    id="select-all-barrels"
                                    checked={(() => {
                                      if (filteredBarrelNumbers.length === 0) return false;

                                      const filteredBarrelNumberSet = new Set(
                                        filteredBarrelNumbers
                                          .filter((b) => b.isBarrelSold !== true)
                                          .map((b) => b.barrelNumber)
                                      );

                                      const selectedBarrels = tabId
                                        ? finalSelectedInventoriesWithBarrelForTabs[tabId]
                                          ?.find((inv) => inv.lotNo === searchSelectedInventory.lotNo)
                                          ?.barrelNumbers ?? []
                                        : finalSelectedInventoriesWithBarrels
                                          ?.find((inv) => inv.lotNo === searchSelectedInventory.lotNo)
                                          ?.barrelNumbers ?? [];

                                      const selectedFilteredCount = selectedBarrels.filter(
                                        (b) => b.isBarrelSold !== true && filteredBarrelNumberSet.has(b.barrelNumber)
                                      ).length;

                                      return selectedFilteredCount === filteredBarrelNumberSet.size && filteredBarrelNumberSet.size > 0;
                                    })()}
                                    onChange={(e) => tabId ? handleSelectAllBarrelsForTabs(tabId, field.serviceTypeServiceFieldId) : handleSelectAllBarrels()}
                                    className="me-2 form-check-input"
                                  />
                                  <label
                                    htmlFor="select-all-barrels"
                                    className="header-field-label"
                                  >
                                    Select All
                                  </label>
                                </div>
                                <div className="header-field-wrapper d-flex align-items-center gap-2">
                                  <label className="header-field-label text-nowrap">
                                    Selected Quantity:
                                  </label>
                                  <div style={{ width: "70px" }}>
                                    <input
                                      type="number"
                                      // placeholder="Qty"
                                      value={desiredQuantity}
                                      onChange={(e) =>
                                        tabId ? handleRandomSelectionForTabs(e.target.value, tabId, field.serviceTypeServiceFieldId) : handleRandomSelection(e.target.value)
                                      }
                                      className="form-control"
                                      min="1"
                                    />
                                  </div>
                                </div>
                                {/* </div> */}
                              </div>
                            </div>

                            {/* Barrel Numbers List */}
                            {tabId ? (
                              <div className="barrel-list-wrapper ">
                              <div className="d-flex flex-wrap align-items-center gap-2">
                                {filteredBarrelNumbers.map((barrel, index) => (
                                  <div
                                    key={index}
                                    className={`inventery-barrel-wrapper ${
                                      finalSelectedInventoriesWithBarrelForTabs[tabId]?.find(
                                          (inv) =>
                                            inv.lotNo ===
                                            searchSelectedInventory.lotNo
                                        )
                                        ?.barrelNumbers.some(
                                          (selectedBarrel) =>
                                            selectedBarrel.barrelNumber ===
                                            barrel.barrelNumber
                                        )
                                        ? "bg-green-100 border-green-300"
                                        : "bg-gray-50 hover:bg-gray-100"
                                    }`}
                                  >
                                    {/* <div className="d-flex align-items-center gap-2 "> */}

                                    <span
                                      onClick={() =>
                                        handleSelectBarrelForTabs(barrel.barrelNumber, tabId, field.serviceTypeServiceFieldId)
                                      }
                                      className="barrel-number--inner d-flex align-items-center gap-1"
                                      style={{
                                        backgroundColor:
                                          finalSelectedInventoriesWithBarrelForTabs[tabId]?.find(
                                              (inv) =>
                                                inv.lotNo ===
                                                searchSelectedInventory.lotNo
                                            )
                                            ?.barrelNumbers.some(
                                              (selectedBarrel) =>
                                                selectedBarrel.barrelNumber ===
                                                barrel.barrelNumber
                                            )
                                            ? "transparent"
                                            : "#F7F7F7",
                                        borderColor:
                                          finalSelectedInventoriesWithBarrelForTabs[tabId]?.find(
                                              (inv) =>
                                                inv.lotNo ===
                                                searchSelectedInventory.lotNo
                                            )
                                            ?.barrelNumbers.some(
                                              (selectedBarrel) =>
                                                selectedBarrel.barrelNumber ===
                                                barrel.barrelNumber
                                            )
                                            ? "#8F9195"
                                            : "transparent",
                                      }}
                                    >
                                      {finalSelectedInventoriesWithBarrelForTabs[tabId]?.find(
                                          (inv) =>
                                            inv.lotNo ===
                                            searchSelectedInventory.lotNo
                                        )
                                        ?.barrelNumbers.some(
                                          (selectedBarrel) =>
                                            selectedBarrel.barrelNumber ===
                                            barrel.barrelNumber
                                        ) ? (
                                        <DoneIcon />
                                      ) : (
                                        <AddSharpIcon sx={{ mr: 0.5 }} />
                                      )}
                                      <span className="barrel-number">
                                        {highlightMatchedForBarrels(
                                          barrel.barrelNumber,
                                          barrelSearchTerm
                                        )}
                                      </span>
                                    </span>
                                    {/* </div> */}
                                  </div>
                                ))}
                              </div>
                            </div>
                            ) : 
                            (<div className="barrel-list-wrapper ">
                              <div className="d-flex flex-wrap align-items-center gap-2">
                                {filteredBarrelNumbers.map((barrel, index) => (
                                  <div
                                    key={index}
                                    className={`inventery-barrel-wrapper ${
                                      finalSelectedInventoriesWithBarrels
                                        .find(
                                          (inv) =>
                                            inv.lotNo ===
                                            searchSelectedInventory.lotNo
                                        )
                                        ?.barrelNumbers.some(
                                          (selectedBarrel) =>
                                            selectedBarrel.barrelNumber ===
                                            barrel.barrelNumber
                                        )
                                        ? "bg-green-100 border-green-300"
                                        : "bg-gray-50 hover:bg-gray-100"
                                    }`}
                                  >
                                    {/* <div className="d-flex align-items-center gap-2 "> */}

                                    <span
                                      onClick={() =>
                                        handleSelectBarrel(barrel.barrelNumber)
                                      }
                                      className="barrel-number--inner d-flex align-items-center gap-1"
                                      style={{
                                        backgroundColor:
                                          finalSelectedInventoriesWithBarrels
                                            .find(
                                              (inv) =>
                                                inv.lotNo ===
                                                searchSelectedInventory.lotNo
                                            )
                                            ?.barrelNumbers.some(
                                              (selectedBarrel) =>
                                                selectedBarrel.barrelNumber ===
                                                barrel.barrelNumber
                                            )
                                            ? "transparent"
                                            : "#F7F7F7",
                                        borderColor:
                                          finalSelectedInventoriesWithBarrels
                                            .find(
                                              (inv) =>
                                                inv.lotNo ===
                                                searchSelectedInventory.lotNo
                                            )
                                            ?.barrelNumbers.some(
                                              (selectedBarrel) =>
                                                selectedBarrel.barrelNumber ===
                                                barrel.barrelNumber
                                            )
                                            ? "#8F9195"
                                            : "transparent",
                                      }}
                                    >
                                      {finalSelectedInventoriesWithBarrels
                                        .find(
                                          (inv) =>
                                            inv.lotNo ===
                                            searchSelectedInventory.lotNo
                                        )
                                        ?.barrelNumbers.some(
                                          (selectedBarrel) =>
                                            selectedBarrel.barrelNumber ===
                                            barrel.barrelNumber
                                        ) ? (
                                        <DoneIcon />
                                      ) : (
                                        <AddSharpIcon sx={{ mr: 0.5 }} />
                                      )}
                                      <span className="barrel-number">
                                        {highlightMatchedForBarrels(
                                          barrel.barrelNumber,
                                          barrelSearchTerm
                                        )}
                                      </span>
                                    </span>
                                    {/* </div> */}
                                  </div>
                                ))}
                              </div>
                            </div>)}


                            <div className="modal-footer-wrapper">
                              <button
                                onClick={handleDoneSelection}
                                className="done-btn"
                                // disabled={
                                //   !finalSelectedInventoriesWithBarrels.find(
                                //     (inv) =>
                                //       inv.lotId ===
                                //       searchSelectedInventory.lotNo
                                //   )?.barrelNumbers.length
                                // }
                              >
                                <DoneIcon className="me-1" />
                                Done
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                    {isSearch && (  
                      <div className='col-12 px-0'>
                        <div className='d-flex align-items-center justify-content-center loader-wrapper'>
                        <div className='position-relative'>
                          <span className='loader-border'>
                            <svg width="128" height="128" viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M123.754 63.9999C123.754 50.8191 119.396 38.0079 111.358 27.5615C103.32 17.1151 92.0535 9.61938 79.3128 6.24159C66.5721 2.86382 53.0721 3.79381 40.9147 8.88614C28.7572 13.9785 18.6247 22.9478 12.0948 34.3974C5.56485 45.847 3.00364 59.1343 4.8104 72.1907C6.61719 85.247 12.6903 97.3398 22.0841 106.586C31.478 115.832 43.6659 121.713 56.7494 123.312C69.8327 124.911 83.0779 122.14 94.4224 115.429C95.4315 114.832 96.7335 115.166 97.3306 116.175C97.9276 117.185 97.5934 118.487 96.5841 119.084C84.4334 126.272 70.2471 129.24 56.234 127.527C42.2208 125.814 29.1669 119.516 19.1054 109.612C9.04397 99.7094 2.53947 86.7572 0.604239 72.773C-1.33094 58.7888 1.41186 44.557 8.40578 32.2937C15.3998 20.0305 26.2523 10.4233 39.2737 4.96908C52.2951 -0.485167 66.7549 -1.4805 80.4011 2.13733C94.0471 5.75518 106.114 13.7833 114.723 24.972C123.332 36.1609 128 49.8824 128 63.9999C128 65.1725 127.049 66.1231 125.877 66.1231C124.704 66.1231 123.754 65.1725 123.754 63.9999Z" fill="#3A809E"/>
                            </svg>
                          </span>
                          <span className='loader-image'>
                            <img src={LoaderImage} alt='Loader Image'/>
                          </span>
                        </div>  
                        </div>
                      </div>
                    )}
                    </div>
                   )}
                </div>
              </div>
              {/* Final Selected Container Display */}
              {isDoneButtonClicked &&
                (finalSelectedInventoriesWithBarrels.length > 0 || finalSelectedInventoriesWithBarrelForTabs[tabId]?.length > 0) && (
                  <div className="selected-inventory-detail-wrapper">
                    {(tabId
                      ? finalSelectedInventoriesWithBarrelForTabs[tabId] || []
                      : finalSelectedInventoriesWithBarrels
                    ).map(
                      (inventory, index) => (
                        <div
                          key={index}
                          className="selected-inventory-detail-inner"
                        >
                          <div className="header-wrapper d-flex flex-column flex-lg-row align-items-lg-center justify-content-lg-between gap-2">
                             <div className="detail-heading">
                              {inventory.productName}{" "}
                              <span className="font-semibold text-gray-800">
                                ({inventory.lotNo})
                              </span>
                              <div className='lot-info-icon-wrapper'>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M10 1.875C8.39303 1.875 6.82214 2.35152 5.486 3.24431C4.14985 4.1371 3.10844 5.40605 2.49348 6.8907C1.87852 8.37535 1.71762 10.009 2.03112 11.5851C2.34463 13.1612 3.11846 14.6089 4.25476 15.7452C5.39106 16.8815 6.8388 17.6554 8.41489 17.9689C9.99099 18.2824 11.6247 18.1215 13.1093 17.5065C14.594 16.8916 15.8629 15.8502 16.7557 14.514C17.6485 13.1779 18.125 11.607 18.125 10C18.1227 7.84581 17.266 5.78051 15.7427 4.25727C14.2195 2.73403 12.1542 1.87727 10 1.875ZM9.6875 5.625C9.87292 5.625 10.0542 5.67998 10.2084 5.783C10.3625 5.88601 10.4827 6.03243 10.5536 6.20373C10.6246 6.37504 10.6432 6.56354 10.607 6.7454C10.5708 6.92725 10.4815 7.0943 10.3504 7.22541C10.2193 7.35652 10.0523 7.44581 9.8704 7.48199C9.68854 7.51816 9.50004 7.49959 9.32874 7.42864C9.15743 7.35768 9.01101 7.23752 8.908 7.08335C8.80499 6.92918 8.75 6.74792 8.75 6.5625C8.75 6.31386 8.84878 6.0754 9.02459 5.89959C9.20041 5.72377 9.43886 5.625 9.6875 5.625ZM10.625 14.375C10.2935 14.375 9.97554 14.2433 9.74112 14.0089C9.5067 13.7745 9.375 13.4565 9.375 13.125V10C9.20924 10 9.05027 9.93415 8.93306 9.81694C8.81585 9.69973 8.75 9.54076 8.75 9.375C8.75 9.20924 8.81585 9.05027 8.93306 8.93306C9.05027 8.81585 9.20924 8.75 9.375 8.75C9.70652 8.75 10.0245 8.8817 10.2589 9.11612C10.4933 9.35054 10.625 9.66848 10.625 10V13.125C10.7908 13.125 10.9497 13.1908 11.0669 13.3081C11.1842 13.4253 11.25 13.5842 11.25 13.75C11.25 13.9158 11.1842 14.0747 11.0669 14.1919C10.9497 14.3092 10.7908 14.375 10.625 14.375Z" fill="#616161"/>
                                </svg>
                                <div className='info-card-wrapper'>
                                  <div className="info-card">
                                    <div className="section">
                                      <div className="label">Age</div>
                                      <div className="value">
                                        {getDurationFromDate(inventory?.fillDate)}
                                      </div>
                                    </div>

                                    <div className="section">
                                      <div className="label">Mash Bill</div>
                                      <div className="value">{inventory?.mashBill || "-"}</div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="d-flex align-items-center gap-2 ms-auto flex-wrap justify-content-end">
                              <div className="total-quantity">
                                Quantity:
                                <span> {inventory.barrelNumbers.length}</span>
                              </div>
                              <button
                                className="remove-btn"
                                onClick={(e) =>
                                 tabId ? handleRemoveInventoryForTabs(e,inventory.lotNo, tabId) : handleRemoveInventory(e, inventory.lotNo)
                                }
                              >
                                {/* <RemoveIcon className="me-1" /> */}
                                <img
                                  src={TrashIcon}
                                  alt="TrashIcon"
                                  className="me-1"
                                />
                                Remove Item
                              </button>
                            </div>
                          </div>
                          <div
                            className={`total-barrel-list-wrapper ${
                              selectedServiceName ==
                                Constant.CustomerService.SELL_REQUEST &&
                              id &&
                              "edit-total-barrels"
                            }`}
                          >
                            <div className="bareels--list-wrapper">
                              {(selectedServiceName !=
                                Constant.CustomerService.SELL_REQUEST ||
                                !id) && (
                                <div className="d-flex flex-wrap gap-2 align-items-center mt-2">
                                  {inventory.barrelNumbers.map(
                                    (barrel, barrelIndex) => (
                                      <div key={barrelIndex} className="">
                                        <div className="barrel-item-wrapper d-flex align-items-center gap-1 w-100">
                                          <DoneIcon />
                                          <span>{barrel.barrelNumber}</span>
                                        </div>
                                      </div>
                                    )
                                  )}
                                </div>
                              )}
                            </div>

                            {/* Sold Container Section */}
                            {selectedServiceName ==
                              Constant.CustomerService.SELL_REQUEST &&
                              id && (
                                <>
                                  <div className="bareels--list-wrapper row m-0">
                                    {inventory.barrelNumbers.filter(
                                      (barrel) => barrel.isBarrelSold === true
                                    ).length > 0 && (
                                      <div
                                        className={`sold-barrels ${
                                          inventory.barrelNumbers.filter(
                                            (barrel) =>
                                              barrel.isBarrelSold !== true
                                          ).length === 0
                                            ? "col-12 border-0"
                                            : "col-md-6"
                                        }`}
                                      >
                                        <div className="barrel-section">
                                          <h6 className="barrel-section-title mb-2">
                                            Sold (
                                            {
                                              inventory.barrelNumbers.filter(
                                                (barrel) =>
                                                  barrel.isBarrelSold === true
                                              ).length
                                            }
                                            )
                                            <LocalOfferOutlinedIcon
                                              sx={{ color: "#858585" }}
                                            />
                                          </h6>
                                          <div className="d-flex flex-wrap gap-2 align-items-center">
                                            {inventory.barrelNumbers
                                              .filter(
                                                (barrel) =>
                                                  barrel.isBarrelSold === true
                                              )
                                              .map((barrel, barrelIndex) => (
                                                <div
                                                  key={barrelIndex}
                                                  className=""
                                                >
                                                  <div className="barrel-item-wrapper d-flex align-items-center gap-1 w-100">
                                                    <DoneIcon />
                                                    <span>
                                                      {barrel.barrelNumber}
                                                    </span>
                                                  </div>
                                                </div>
                                              ))}
                                          </div>
                                          {inventory.barrelNumbers.filter(
                                            (barrel) =>
                                              barrel.isBarrelSold === true
                                          ).length === 0 && (
                                            <p className="text-muted small">
                                              No sold container
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                    )}

                                    {/* Ready to Sell Container Section */}
                                    {inventory.barrelNumbers.filter(
                                      (barrel) => barrel.isBarrelSold !== true
                                    ).length > 0 && (
                                      <div
                                        className={`${
                                          inventory.barrelNumbers.filter(
                                            (barrel) =>
                                              barrel.isBarrelSold === true
                                          ).length === 0
                                            ? " col-12"
                                            : "col-md-6"
                                        }`}
                                      >
                                        <div className="barrel-section">
                                          <h6 className="barrel-section-title mb-2">
                                            Ready to Sell (
                                            {
                                              inventory.barrelNumbers.filter(
                                                (barrel) =>
                                                  barrel.isBarrelSold !== true
                                              ).length
                                            }
                                            )
                                            <ShoppingCartOutlinedIcon
                                              sx={{ color: "#858585" }}
                                            />
                                          </h6>
                                          <div className="d-flex flex-wrap gap-2 align-items-center">
                                            {inventory.barrelNumbers
                                              .filter(
                                                (barrel) =>
                                                  barrel.isBarrelSold !== true
                                              )
                                              .map((barrel, barrelIndex) => (
                                                <div
                                                  key={barrelIndex}
                                                  className=""
                                                >
                                                  <div className="barrel-item-wrapper d-flex align-items-center gap-1 w-100">
                                                    <DoneIcon />
                                                    <span>
                                                      {barrel.barrelNumber}
                                                    </span>
                                                  </div>
                                                </div>
                                              ))}
                                          </div>
                                          {inventory.barrelNumbers.filter(
                                            (barrel) =>
                                              barrel.isBarrelSold !== true
                                          ).length === 0 && (
                                            <p className="text-muted small">
                                              No ready to sell container
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </>
                              )}
                          </div>
                        </div>
                      )
                    )}
                  </div>
                )}
              {field.mandatory &&
                (tabId
                  ? errorsForTabs[tabId]?.[field.serviceTypeServiceFieldId]
                  : errors[field.serviceTypeServiceFieldId]) && (
                  <span className="error-message">This field is required</span>
              )}

              {/* Searched Inventories Display */}

              {/* Barrel Numbers Display */}

              {/* Final Selected Container Display */}
            </div>
          </div>
        );
      case Constant.FIELD_TYPES.PRODUCT_DROPDOWN:
        return (
          <div className="mb-6 form__field--wrapper">
            <label htmlFor="service-dropdown" className="block mb-2 form-label">
              {field.fieldName}
              {field.mandatory && (
                <span className="star-required text-danger">*</span>
              )}
            </label>
            <select
              id="company-dropdown"
              value={selectedInventory}
              onChange={(e) =>
                handleInventoryChange(
                  e.target.value,
                  field.serviceTypeServiceFieldId
                )
              }
              onBlur={() =>
                handleInventoryBlur(field.serviceTypeServiceFieldId)
              }
              className={`select-dropdown ${
                field.mandatory && errors[field.serviceTypeServiceFieldId]
                  ? "is_invalid"
                  : ""
              }`}
            >
              <option value="">Select Product</option>
              {inventoriesList.map((inventory) => (
                <option key={inventory.barrelId} value={inventory.barrelId}>
                  {inventory?.inventoryName}
                </option>
              ))}
            </select>
            {field.mandatory && errors[field.serviceTypeServiceFieldId] && (
              <span className="error-message ">Please select a product</span>
            )}
          </div>
        );
      case Constant.FIELD_TYPES.FEE_TYPE_DROPDOWN:
        if (CommonService.isAdmin()) {
          return (
            <div className="col-sm-6 col-lg-4">
              <div className="mb-6 form__field--wrapper">
                <label
                  htmlFor="service-dropdown"
                  className="block mb-2 form-label"
                >
                  {field.fieldName}
                  {field.mandatory && (
                    <span className="star-required text-danger">*</span>
                  )}
                </label>
                <div className="w-100">
                  <select
                    id="fee-type-dropdown"
                    style={{ cursor: "pointer" }}
                    value={formData[field.serviceTypeServiceFieldId] || ""}
                    onChange={(e) =>
                      handleFieldChange(
                        e.target.value,
                        field.serviceTypeServiceFieldId
                      )
                    }
                    onBlur={(e) =>
                      handleFieldBlur(
                        e.target.value,
                        field.serviceTypeServiceFieldId
                      )
                    }
                    className={`select-dropdown w-100 ${
                      field.mandatory && errors[field.serviceTypeServiceFieldId]
                        ? "is_invalid"
                        : ""
                    }`}
                  >
                    <option value="">Select Fee Type</option>
                    <option value="FLAT">Flat</option>
                    <option value="PERCENTAGE">Percentage</option>
                  </select>
                </div>
                {field.mandatory && errors[field.serviceTypeServiceFieldId] && (
                  <span className="error-message ">
                    Please select a fee type
                  </span>
                )}
              </div>
            </div>
          );
        }
        return null;
      case Constant.FIELD_TYPES.PRICE:
        return (
          <div key={field.fieldName} className="col-sm-6 col-lg-4">
            <div className="form__field--wrapper">
              <label className="block mb-2 form-label">
                {field.fieldName == "Price"
                  ? `${field.fieldName}/Container`
                  : field.fieldName}
                {field.mandatory && (
                  <span className="star-required text-danger">*</span>
                )}
              </label>
              <input
                type="number"
                value={formData[field.serviceTypeServiceFieldId] || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  if (!/^-?\d*\.?\d*$/.test(value)) return;
                  handleFieldChange(
                    e.target.value,
                    field.serviceTypeServiceFieldId
                  );
                }}
                onKeyDown={(e) => {
                  if (e.key === "-" || e.key === "e" || e.key === "+") {
                    e.preventDefault(); // Prevent entering '-' or invalid characters
                  }
                }}
                onPaste={(e) => {
                  const pasteData = e.clipboardData.getData("text");
                  if (pasteData.includes("-")) {
                    e.preventDefault(); // Prevent pasting invalid characters
                  }
                }}
                onBlur={(e) => {
                  const value = e.target.value;
                  if (value.includes("-")) {
                    handleFieldChange("", field.serviceTypeServiceFieldId); // Reset if invalid
                  }
                  handleNumberOnBlur(
                    e.target.value,
                    field.serviceTypeServiceFieldId
                  );
                }}
                className={`form-control service-req-input no-spinner ${
                  field.mandatory && errors[field.serviceTypeServiceFieldId]
                    ? "is_invalid"
                    : ""
                }`}
                placeholder={`Enter ${field.fieldName}`}
              />
              {field.mandatory && errors[field.serviceTypeServiceFieldId] && (
                <span className="error-message">This field is required</span>
              )}
            </div>
          </div>
        );
      case Constant.FIELD_TYPES.QUANTITY:
        return (
          <div key={field.fieldName} className="mb-4 form__field--wrapper">
            <label className="block mb-2 form-label">
              {field.fieldName}
              {field.mandatory && (
                <span className="star-required text-danger">*</span>
              )}
            </label>
            <input
              type="number"
              value={quantity}
              onChange={(e) =>
                handleQuantityChange(
                  e.target.value,
                  field.serviceTypeServiceFieldId
                )
              }
              onBlur={(e) =>

                !tabId &&
                handleNumberOnBlur(
                  e.target.value,
                  field.serviceTypeServiceFieldId
                )
              }
              className={`form-control service-req-input ${
                field.mandatory && errors[field.serviceTypeServiceFieldId]
                  ? "is_invalid"
                  : ""
              }`}
            />
            {field.mandatory && errors[field.serviceTypeServiceFieldId] && (
              <span className="error-message ">This field is required </span>
            )}
          </div>
        );
      case Constant.FIELD_TYPES.NUMBER:
        return (
          <div key={field.fieldName} className="col-sm-6 col-lg-4">
            <div className="form__field--wrapper">
              <label className="block mb-2 form-label">
                {field.fieldName == "Price"
                  ? `${field.fieldName}/Container`
                  : field.fieldName}
                {field.mandatory && (
                  <span className="star-required text-danger">*</span>
                )}
              </label>
              <input
                type="number"
                value={(tabId ? formDataForTabs[tabId]?.[field.serviceTypeServiceFieldId]:formData[field.serviceTypeServiceFieldId]) || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  if (!/^-?\d*\.?\d*$/.test(value)) return;

                  tabId ? 
                  handleFieldChangeForTabs(e.target.value, field.serviceTypeServiceFieldId, tabId) :
                  handleFieldChange(
                    e.target.value,
                    field.serviceTypeServiceFieldId
                  );
                }}
                onKeyDown={(e) => {
                  if (e.key === "-" || e.key === "e" || e.key === "+") {
                    e.preventDefault(); // Prevent entering '-' or invalid characters
                  }
                }}
                onPaste={(e) => {
                  const pasteData = e.clipboardData.getData("text");
                  if (pasteData.includes("-")) {
                    e.preventDefault(); // Prevent pasting invalid characters
                  }
                }}
                onBlur={(e) => {
                  const value = e.target.value;
                  if (value.includes("-")) {
                    tabId ? handleFieldChangeForTabs("", field.serviceTypeServiceFieldId, tabId) :
                    handleFieldChange("", field.serviceTypeServiceFieldId); // Reset if invalid
                  }
                  handleNumberOnBlur(
                    e.target.value,
                    field.serviceTypeServiceFieldId
                  );
                }}
                className={`form-control service-req-input no-spinner ${
                  field.mandatory && 
                  (tabId
                      ? errorsForTabs[tabId]?.[field.serviceTypeServiceFieldId]
                      : errors[field.serviceTypeServiceFieldId])
                      ? "is_invalid"
                      : ""
                }`}
                placeholder={`Enter ${field.fieldName}`}
              />
              {field.mandatory &&
                (tabId
                  ? errorsForTabs[tabId]?.[field.serviceTypeServiceFieldId]
                  : errors[field.serviceTypeServiceFieldId]) && (
                  <span className="error-message">This field is required</span>
                )}
            </div>
          </div>
        );
      case Constant.FIELD_TYPES.RADIO:
        return (
          <div key={field.fieldName} className="col-sm-6 col-lg-4">
            <div className="form__field--wrapper">
              <div className="d-flex flex-column gap-3">
                <label className="block form-label mb-0">
                  {field.fieldName}
                  {field.mandatory && (
                    <span className="star-required text-danger">*
                    {selectedServiceName === Constant.CustomerService.LOGISTIC && (
                    <Tooltip title={field.fieldName == 'Is Loose Pack?' ? "Select 'Yes' if container are shipped individually, without pallets."
                        : field.fieldName == 'Is Palletized?' ? "Select 'Yes' if the container are shipped on pallets for easier handling."
                        : field.fieldName == 'Does the company own the uploaded inventory?' ? "Select “Yes” if the uploaded inventory is owned by your company."
                        : "Select “Yes” if the inventories are stored at a facility operated by another company."}>
                      <img src={InfoIcon} alt="Info" className="inline-block ms-2"/>
                    </Tooltip>
                    )}
                    </span>
                  )}
                </label>

                <div className="d-flex align-items-center">
                  <div className="d-inline-flex">
                    <input
                      type="radio"
                      name={field.fieldName}
                      id={`${field.fieldName}-yes`}
                      className="custom-radio service-req-input"
                      value="yes"
                      checked={
                        isInventoryUploadRadioField(field.fieldName) ? formDataForInventoryUpload[field.serviceTypeServiceFieldId] === true : formData[field.serviceTypeServiceFieldId] === true
                      }
                      onChange={(e) =>
                        isInventoryUploadRadioField(field.fieldName) 
                        ? handleInventoryUploadFieldChange(
                          e.target.value,
                          field.serviceTypeServiceFieldId
                        ): handleFieldChange(
                          e.target.value,
                          field.serviceTypeServiceFieldId
                        )
                      }
                    />
                    <label
                      className="custom-radio-label"
                      htmlFor={`${field.fieldName}-yes`}
                    >
                      Yes
                    </label>
                  </div>
                  <div className="d-inline-flex ms-2 me-2">
                    <input
                      type="radio"
                      name={field.fieldName}
                      id={`${field.fieldName}-no`}
                      className="custom-radio service-req-input"
                      value="no"
                      checked={
                        isInventoryUploadRadioField(field.fieldName) ? formDataForInventoryUpload[field.serviceTypeServiceFieldId] === false : formData[field.serviceTypeServiceFieldId] === false
                      }
                      onChange={(e) =>
                        isInventoryUploadRadioField(field.fieldName) 
                        ? handleInventoryUploadFieldChange(
                          e.target.value,
                          field.serviceTypeServiceFieldId
                        ): handleFieldChange(
                          e.target.value,
                          field.serviceTypeServiceFieldId
                        )
                      }
                    />
                    <label
                      className="custom-radio-label"
                      htmlFor={`${field.fieldName}-no`}
                    >
                      No
                    </label>
                  </div>
                </div>
              </div>
              {field.mandatory && (
                <>
                  {isInventoryUploadRadioField(field.fieldName)
                    ? errorsForInventoryUpload[field.serviceTypeServiceFieldId] && (
                        <span className="error-message">
                          {errorsForInventoryUpload[field.serviceTypeServiceFieldId]}
                        </span>
                      )
                    : errors[field.serviceTypeServiceFieldId] && (
                        <span className="error-message">
                          {errors[field.serviceTypeServiceFieldId]}
                        </span>
                      )}
                </>
              )}
            </div>
          </div>
        );
      case Constant.FIELD_TYPES.TEXT:
        return (
          <div key={field.fieldName} className="col-sm-6 col-lg-4">
            <div className="form__field--wrapper">
              <label className="block mb-2 form-label">
                {field.fieldName}
                {field.mandatory && (
                  <span className="star-required text-danger">*
                  {selectedServiceName === Constant.CustomerService.LOGISTIC && (
                    <Tooltip title={field.fieldName == 'Logistic from Facility' ? "Enter the facility where the container will be shipped from (origin facility)." : field.fieldName == 'Logistic to Facility' ? "Enter the destination facility where container will be delivered." : field.fieldName == 'Logistic from Contact' ? "Provide the name of the contact person at the shipping origin." : field.fieldName == 'Logistic to Contact' ? "Name the main contact at the container destination facility." : "Input the Transfer in Bond number for container"}>
                      <img src={InfoIcon} alt="Info" className="inline-block ms-2"/>
                    </Tooltip>
                  )}
                  </span>
                )}
              </label>
              <input
                type="text"
                placeholder={selectedServiceName === Constant.CustomerService.LOGISTIC && field.fieldName== 'Logistic from TIB Number' || field.fieldName== 'Logistic from Contact' || field.fieldName== 'Logistic to TIB Number' || field.fieldName== 'Logistic to Contact' || field.fieldName== 'TIB Number'  ? ' ' :  `Enter ${field.fieldName}`}
                value={formData[field.serviceTypeServiceFieldId]}
                onChange={(e) => {
                  const value = e.target.value;
                  handleFieldChange(value, field.serviceTypeServiceFieldId);
                }}
                onBlur={(e) =>
                  handleFieldBlur(
                    e.target.value,
                    field.serviceTypeServiceFieldId
                  )
                }
                className={`form-control service-req-input ${
                  field.mandatory && errors[field.serviceTypeServiceFieldId]
                    ? "is_invalid"
                    : ""
                }`}
                disabled={isDisabled}
              />
              {/* Error message for "Owner Name" */}
              {field.fieldName === "Owner Name" && ownerNameError && (
                <span className="error-message text-danger">
                  {ownerNameError}
                </span>
              )}
              {field.fieldName === Constant.Field.RECEIVING_COMPANY && receivingCompanyError && (
                <span className="error-message text-danger">
                  {receivingCompanyError}
                </span>
              )}
              {field.mandatory && errors[field.serviceTypeServiceFieldId] && (
                <span className="error-message ">This field is required </span>
              )}
            </div>
          </div>
        );
      case Constant.FIELD_TYPES.OWNER_NAME_DROPDOWN:
        return (
          <div key={field.fieldName} className="col-sm-6 col-lg-4">
            <div className="form__field--wrapper">
              <label className="block mb-2 form-label">
                {field.fieldName}
                {field.mandatory && (
                  <span className="star-required text-danger">*</span>
                )}
              </label>
              <Select
                placeholder="Select owner name"
                styles={customStyles}
                onChange={(selectedOption) => {
                  if (selectedOption.value === "add_owner") {
                    const url = CommonService.isAdmin()
                      ? "/master/add-owner"
                      : "/user/add-owner";
                    window.open(url, "_blank"); // ✅ open in new tab
                  } else {
                    (selectedServiceName == Constant.CustomerService.LOGISTIC && barrelSource == Constant.BarrelSource.SHIP_BY_UPLOAD_INVENTORY) ?
                    handleInventoryUploadFieldChange (
                      selectedOption?.value, // this will be ownerName
                      field.serviceTypeServiceFieldId
                    ) : handleFieldChange(
                      selectedOption?.value, // this will be ownerName
                      field.serviceTypeServiceFieldId
                    )
                  }
                }}
                options={options}
                value={
                  (selectedServiceName == Constant.CustomerService.LOGISTIC && barrelSource == Constant.BarrelSource.SHIP_BY_UPLOAD_INVENTORY)
                  ? (formDataForInventoryUpload[field.serviceTypeServiceFieldId]
                    ? {
                        label: formDataForInventoryUpload[field.serviceTypeServiceFieldId],
                        value: formDataForInventoryUpload[field.serviceTypeServiceFieldId],
                      }
                    : null)
                  : (formData[field.serviceTypeServiceFieldId]
                    ? {
                        label: formData[field.serviceTypeServiceFieldId],
                        value: formData[field.serviceTypeServiceFieldId],
                      }
                    : null)
                }
                className={`w-100 select-dropdown multi-select-dropdown ${
                  (selectedServiceName === Constant.CustomerService.LOGISTIC &&
                  barrelSource === Constant.BarrelSource.SHIP_BY_UPLOAD_INVENTORY)
                    ? (field.mandatory && errorsForInventoryUpload[field.serviceTypeServiceFieldId] ? "is_invalid" : "")
                    : (field.mandatory && errors[field.serviceTypeServiceFieldId] ? "is_invalid" : "")
                }`}
                components={{
                  DropdownIndicator: () => <ExpandMoreRoundedIcon />,
                  IndicatorSeparator: () => null,
                }}
                isSearchable
                isDisabled={(selectedServiceName == Constant.CustomerService.LOGISTIC && barrelSource == Constant.BarrelSource.SHIP_BY_UPLOAD_INVENTORY) ? isOwnerDropdownDisabled : isDisabled}
                formatOptionLabel={formatOptionLabel}
              />

              {field.mandatory &&
              ((selectedServiceName === Constant.CustomerService.LOGISTIC &&
                barrelSource === Constant.BarrelSource.SHIP_BY_UPLOAD_INVENTORY)
                ? errorsForInventoryUpload[field.serviceTypeServiceFieldId]
                : errors[field.serviceTypeServiceFieldId]) && (
                <span className="error-message">This field is required</span>
              )}
            </div>
          </div>
        );
      case Constant.FIELD_TYPES.COMMENT:
        return (
          <div
            key={field.fieldName}
            className="col-sm-6 col-lg-6"
          >
            <div className="form__field--wrapper">
              <label className="block mb-2 form-label">
                {field.fieldName}
                {field.mandatory && (
                  <span className="star-required text-danger">*</span>
                )}
              </label>
              <textarea
                value={tabId ? commentForTabs[tabId] : requestDescription}
                placeholder="Enter Text"
                onChange={(e) =>

                  tabId ? handleRequestDescriptionChangeForTabs(e.target.value, field.serviceTypeServiceFieldId, tabId) :
                  handleRequestDescriptionChange(
                    e.target.value,
                    field.serviceTypeServiceFieldId
                  )
                }
                className={`form-control service-req-input ${
                  field.mandatory && errors[field.serviceTypeServiceFieldId]
                    ? "is_invalid"
                    : ""
                }`}
                rows={3}
                style={{ resize: "none" }}
              />
              {field.mandatory && errors[field.serviceTypeServiceFieldId] && (
                <span className="error-message ">This field is required </span>
              )}
            </div>
          </div>
        );
      case Constant.FIELD_TYPES.RICH_TEXT:
        return (
          <div key={field.fieldName} className="col-sm-12 col-lg-12">
            <div className="form__field--wrapper">
              <label className="block mb-2 form-label">
                {field.fieldName}
                {field.mandatory && (
                  <span className="star-required text-danger">*</span>
                )}
              </label>
              <CKEditor
                editor={ClassicEditor}
                data={formData[field.serviceTypeServiceFieldId] || ""}
                onInit={(editor) => {
                  // You can store the "editor" and use when it is needed.
                  console.log("Editor is ready to use!", editor.state);
                }}
                // data = "<p>Hello from CKEditor 5!</p>"
                config={{
                  toolbar: {
                    items: [
                      "bold",
                      "italic",
                      "underline",
                      "|",
                      "bulletedList",
                      "numberedList",
                      "|",
                      "undo",
                      "redo",
                    ],
                  },
                  // Ensure these plugins are not removed
                  removePlugins: [
                    "MediaEmbed",
                    "Link",
                    "ImageUpload",
                    "BlockQuote",
                    "Table",
                  ],
                }}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  handleCkeditorContentChange(
                    data,
                    field.serviceTypeServiceFieldId
                  );
                }}
                onBlur={(event, editor) => {
                  const data = editor.getData();
                  handleFieldBlur(data, field.serviceTypeServiceFieldId);
                }}
              />
              {field.mandatory && errors[field.serviceTypeServiceFieldId] && (
                <span className="error-message">This field is required</span>
              )}
            </div>
          </div>
        );
      case Constant.FIELD_TYPES.DATE:
        return (
          <div key={field.fieldName} className="col-sm-6 col-lg-4">
            <div className=" form__field--wrapper">
              <label className="block mb-2 form-label">
                {field.fieldName}
                {field.mandatory && (
                  <span className="star-required text-danger">*</span>
                )}
              </label>
              <input
                type="date"
                value={formData[field.serviceTypeServiceFieldId]}
                onChange={(e) =>
                  handleFieldChange(
                    e.target.value,
                    field.serviceTypeServiceFieldId
                  )
                }
                onBlur={(e) =>
                  handleDateBlur(
                    e.target.value,
                    field.serviceTypeServiceFieldId
                  )
                }
                className={`form-control service-req-input ${
                  field.mandatory && errors[field.serviceTypeServiceFieldId]
                    ? "is_invalid"
                    : ""
                }`}
                name="date"
                min={CommonService.getTodayInTimeZone()}
                readOnly={
                  isEditMode && field.fieldName === "Preferred Date and Time?"
                }
                style={
                  isEditMode && field.fieldName === "Preferred Date and Time?"
                    ? {
                        backgroundColor: "#eef1f4",
                        color: "#333333"
                      }
                    : {}
                }
              />
              {field.mandatory && errors[field.serviceTypeServiceFieldId] && (
                <span className="error-message">
                  {errors[field.serviceTypeServiceFieldId] === "error"
                    ? "This field is required"
                    : errors[field.serviceTypeServiceFieldId]}
                </span>
              )}
            </div>
          </div>
        );
      case Constant.FIELD_TYPES.UPLOAD_FILE:
        return (
          <>
            {!isEditMode && ( // Hide the entire block in edit mode
              <div className="col-sm-6 col-lg-4">
                <label className="block form-label mb-2">Upload Inventory (CSV/Excel File)<span className="star-required text-danger">*</span></label>
                <div className="">
                  <div className="create-ticket-attachement-wrapper d-flex align-items-center">
                    <div className='d-flex align-items-center gap-1'>
                    <IconButton
                      type="button"
                      aria-label="submit"
                      sx={{
                        transform: "rotate(45deg)",
                        padding: "0",
                      }}
                      onClick={handleSingleButtonClick}
                    >
                      <AttachFileIcon />
                    </IconButton>
                    <span
                      className="cursor-pointer"
                      onClick={handleSingleButtonClick}
                    >
                      {/* {field.fieldName} */}

                      Upload File
                    </span>
                    </div>
                      <span>
                        <svg width="67" height="13" viewBox="0 0 67 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.33203 8.26953H0.0664062V6.93359H4.33203V8.26953ZM7.76953 8.26953H3.50391V6.93359H7.76953V8.26953ZM11.207 8.26953H6.94141V6.93359H11.207V8.26953ZM14.6445 8.26953H10.3789V6.93359H14.6445V8.26953ZM56.2533 8.26953H51.9877V6.93359H56.2533V8.26953ZM59.6908 8.26953H55.4252V6.93359H59.6908V8.26953ZM63.1283 8.26953H58.8627V6.93359H63.1283V8.26953ZM66.5658 8.26953H62.3002V6.93359H66.5658V8.26953Z" fill="#CCCCCC"/>
                        <path d="M27.1289 12.1602C25.5143 12.1602 24.2201 11.6367 23.2461 10.5898C22.2773 9.54297 21.793 8.18099 21.793 6.50391C21.793 4.70182 22.2878 3.26432 23.2773 2.19141C24.2669 1.11849 25.6107 0.582031 27.3086 0.582031C28.8815 0.582031 30.1471 1.10286 31.1055 2.14453C32.069 3.1862 32.5508 4.54818 32.5508 6.23047C32.5508 8.05859 32.0586 9.50391 31.0742 10.5664C30.0898 11.6289 28.7747 12.1602 27.1289 12.1602ZM27.2148 2.21484C26.1888 2.21484 25.3529 2.59766 24.707 3.36328C24.0664 4.12891 23.7461 5.13672 23.7461 6.38672C23.7461 7.63151 24.0586 8.63411 24.6836 9.39453C25.3086 10.1549 26.1263 10.5352 27.1367 10.5352C28.2096 10.5352 29.056 10.1732 29.6758 9.44922C30.2956 8.72526 30.6055 7.71224 30.6055 6.41016C30.6055 5.07161 30.3034 4.03776 29.6992 3.30859C29.1003 2.57943 28.2721 2.21484 27.2148 2.21484ZM43.5817 11.9727H41.4098L39.6208 8.97266C39.4593 8.69661 39.3005 8.46224 39.1442 8.26953C38.9932 8.07161 38.8369 7.91016 38.6755 7.78516C38.5192 7.66016 38.3473 7.56901 38.1598 7.51172C37.9723 7.45443 37.7614 7.42578 37.527 7.42578H36.777V11.9727H34.9255V0.769531H38.613C39.139 0.769531 39.6234 0.832031 40.0661 0.957031C40.5088 1.08203 40.8942 1.27214 41.2223 1.52734C41.5505 1.77734 41.8057 2.09245 41.988 2.47266C42.1755 2.84766 42.2692 3.28776 42.2692 3.79297C42.2692 4.1888 42.2093 4.55339 42.0895 4.88672C41.9749 5.21484 41.8083 5.50911 41.5895 5.76953C41.376 6.02474 41.1156 6.24349 40.8083 6.42578C40.5062 6.60807 40.1651 6.7487 39.7848 6.84766V6.87891C39.988 6.99349 40.1651 7.12109 40.3161 7.26172C40.4671 7.39714 40.6104 7.53776 40.7458 7.68359C40.8812 7.82943 41.014 7.99609 41.1442 8.18359C41.2796 8.36589 41.4281 8.57943 41.5895 8.82422L43.5817 11.9727ZM36.777 2.27734V5.91797H38.3239C38.6104 5.91797 38.8734 5.8737 39.113 5.78516C39.3578 5.69661 39.5687 5.56901 39.7458 5.40234C39.9229 5.23568 40.0609 5.03255 40.1598 4.79297C40.2588 4.55339 40.3083 4.28516 40.3083 3.98828C40.3083 3.45182 40.139 3.03255 39.8005 2.73047C39.4619 2.42839 38.9749 2.27734 38.3395 2.27734H36.777Z" fill="#A1A1A1"/>
                        </svg>
                      </span>
                          <button
                            className="btn d-inline-flex align-items-center bg-transparent p-0"
                            onClick={(e) => {
                              e.preventDefault(); // Prevent form submission
                              e.stopPropagation(); // Prevent event bubbling
                              downloadTemplateFile();
                            }}
                            disabled={isLoading}
                            style={{
                              border: "unset",
                              outline: "unset",
                            }}
                          >
                            <LoginIcon
                              sx={{ rotate: "90deg", mr: 0.5, fill: "#3A809E" }}
                            />
                            <Typography
                              component="span"
                              variant="body2"
                              sx={{
                                color: "#3A809E",
                                fontWeight: 600,
                                cursor: "pointer",
                                fontSize: "16px",
                              }}
                            >
                              Download Template File
                            </Typography>
                          </button>

                    {/* {field.mandatory && (
                      <span className="star-required text-danger">*</span>
                    )} */}
                  </div>
                  <div className="d-flex align-items-center gap-2 flex-wrap mt-2">
                    {file && (
                      <div className="file__upload--info d-flex align-items-center mb-1 me-2">
                        <div className="file-name me-3">{file.name}</div>
                        <div className="file-delete">
                          <img
                            src={TrashIcon}
                            alt="TrashIcon"
                            onClick={() =>
                              handleSingleDeleteFile(
                                field.serviceTypeServiceFieldId
                              )
                            }
                          />
                        </div>
                      </div>
                    )}

                    {/* if user or admin edits the service request, show already uploaded file */}
                    {id &&
                      serviceDocDetails?.map((serviceDoc, index) => (
                        <div
                          className="file__upload--info d-flex align-items-center mb-1 me-2"
                          key={index}
                        >
                          <div className="file-name me-3">
                            {serviceDoc?.fileName.split("_").slice(1).join("_")}
                          </div>
                          <div className="file-delete">
                            <img
                              src={TrashIcon}
                              alt="TrashIcon"
                              onClick={() => handleDeleteDoc(serviceDoc?.id)}
                            />
                          </div>
                        </div>
                      ))}
                  </div>
                  <div style={{ position: "relative" }}>
                    <input
                      type="file"
                      ref={singleFileInputRef}
                      style={{ display: "none" }}
                      accept=".csv, .xls, .xlsx"
                      onChange={(e) =>
                        handleSingleFileChange(
                          e,
                          field.serviceTypeServiceFieldId
                        )
                      }
                    />
                    {field.mandatory &&
                    ((selectedServiceName === Constant.CustomerService.LOGISTIC &&
                      barrelSource === Constant.BarrelSource.SHIP_BY_UPLOAD_INVENTORY)
                      ? errorsForInventoryUpload[field.serviceTypeServiceFieldId]
                      : errors[field.serviceTypeServiceFieldId]) && (
                      <span className="error-message">Please select csv or xlsx file.</span>
                    )}
                  </div>
                </div>
              </div>
            )}
          </>
        );
      case Constant.FIELD_TYPES.UPLOAD_DOC:
        return (
          <>
            {!isEditMode && ( // Hide the entire block in edit mode
              <div className="col-sm-6 col-lg-4">
                <label className="block form-label mb-2">
                  Upload Supporting Documents (All File Types)
                  {selectedServiceName === Constant.CustomerService.BARREL_HEAD_PAINTING && (
                    <Tooltip title="All File Types Are Supported. Vector is Recommended for better quality">
                      <img src={InfoIcon} alt="Info" className="inline-block ms-2"/>
                    </Tooltip>
                  )}
                </label>               
                 <div className="">
                  <div className="create-ticket-attachement-wrapper d-flex flex-wrap flex-row align-items-center gap-1">
                    <IconButton
                      type="button"
                      aria-label="submit"
                      sx={{
                        transform: "rotate(45deg)",
                        padding: "0",
                      }}
                      onClick={handleButtonClick}
                    >
                      <AttachFileIcon />
                    </IconButton>
                    <span
                      className="cursor-pointer"
                      onClick={handleButtonClick}
                    >
                      {field.fieldName}
                    </span>
                    {field.mandatory && (
                      <span className="star-required text-danger">*</span>
                    )}
                  </div>
                  <div className="d-flex align-items-center gap-2 flex-wrap mt-2">
                    {(tabId
                      ? (tabFiles[tabId] ?? [])  // fallback to empty array
                      : (files ?? [])
                    ).map((file, index) => (
                      <div
                        className="file__upload--info d-flex align-items-center mb-1 me-2"
                        key={index}
                      >
                        <div className="file-name me-3">{file.name}</div>
                        <div className="file-delete">
                          <img
                            src={TrashIcon}
                            alt="TrashIcon"
                            onClick={() =>
                              tabId
                                ? handleDeleteFileForTabs(index, tabId)
                                : handleDeleteFile(index)
                            }
                          />
                        </div>
                      </div>
                    ))}

                    {/* Show already uploaded files if user/admin edits */}
                    {id &&
                      serviceDocDetails?.map((serviceDoc, index) => (
                        <div
                          className="file__upload--info d-flex align-items-center mb-1 me-2"
                          key={index}
                        >
                          <div className="file-name me-3">
                            {serviceDoc?.fileName.split("_").slice(1).join("_")}
                          </div>
                          <div className="file-delete">
                            <img
                              src={TrashIcon}
                              alt="TrashIcon"
                              onClick={() => handleDeleteDoc(serviceDoc?.id)}
                            />
                          </div>
                        </div>
                      ))}
                  </div>
                  <div style={{ position: "relative" }}>
                    <input
                      type="file"
                      ref={fileInputRef}
                      style={{ display: "none" }}
                      multiple
                      onChange={(e) => tabId ? handleFileChangeForTabs(e, tabId) : handleFileChange(e, field.serviceTypeServiceFieldId)}
                    />

                    {field.mandatory &&
                    (errors[field.serviceTypeServiceFieldId]) && (
                      <span className="error-message">This field is required.</span>
                    )}
                  </div>
                </div>
              </div>
            )}
          </>
        );
      case Constant.FIELD_TYPES.CURRENT_USER:
        return (
          <div className="col-sm-6 col-lg-4">
            <div className="form__field--wrapper">
              <label
                htmlFor="service-dropdown"
                className="block mb-2 form-label"
              >
                {field.fieldName}
                {field.mandatory && (
                  <span className="star-required text-danger">*</span>
                )}
              </label>
              <div className="w-100">
                <select
                  id="company-dropdown"
                  value={formData[field.serviceTypeServiceFieldId]}
                  onChange={(e) =>
                    handleCurrentUserChange(
                      e.target.value,
                      field.serviceTypeServiceFieldId
                    )
                  }
                  // onBlur = {() => handleUserBlur(field.serviceTypeServiceFieldId)}
                  className={`select-dropdown w-100 ${
                    field.mandatory && errors[field.serviceTypeServiceFieldId]
                      ? "is_invalid"
                      : ""
                  }`}
                >
                  <option>Current user</option>
                  {currentCompaniesUserList.map((user) => (
                    <option key={user.userId} value={user.userId}>
                      {user.userName}
                    </option>
                  ))}
                </select>
              </div>
              {field.mandatory && errors[field.serviceTypeServiceFieldId] && (
                <span className="error-message ">Please select a user </span>
              )}
            </div>
          </div>
        );
      case Constant.FIELD_TYPES.CURRENT_COMPANY:
        return (
          <div key={field.fieldName} className="col-sm-6 col-lg-4">
            <div className="form__field--wrapper">
              <label
                htmlFor="service-dropdown"
                className="block mb-2 form-label"
              >
                {field.fieldName}
                {field.mandatory && (
                  <span className="star-required text-danger">*</span>
                )}
              </label>
              <div className="w-100">
                <select
                  id="company-dropdown"
                  value={formData[field.serviceTypeServiceFieldId]}
                  // onBlur = {() => handleUserBlur(field.serviceTypeServiceFieldId)}
                  className={`select-dropdown w-100 ${
                    field.mandatory && errors[field.serviceTypeServiceFieldId]
                      ? "is_invalid"
                      : ""
                  }`}
                  disabled={true}
                >
                  <option>Current company</option>
                  {filteredCompaniesList.map((company) => (
                    <option key={company.id} value={company.id}>
                      {company.companyName}
                    </option>
                  ))}
                </select>
                {field.mandatory && errors[field.serviceTypeServiceFieldId] && (
                  <span className="error-message ">
                    Please select a current company{" "}
                  </span>
                )}
              </div>
            </div>
          </div>
        );
      case Constant.FIELD_TYPES.SIZE_DROPDOWN:
        return (
          <div key={field.fieldName} className="col-sm-6 col-lg-4">
            <div className="form__field--wrapper">
              <label htmlFor="size" className="form-label">
                {field.fieldName}
                {field.mandatory && (
                  <span className="star-required text-danger">*</span>
                )}
              </label>
              {/* <div className="col"> */}
                <select
                  id="size"
                  className={`form-select select-dropdown ${
                    field.mandatory && 
                     (tabId
                      ? errorsForTabs[tabId]?.[field.serviceTypeServiceFieldId]
                      : errors[field.serviceTypeServiceFieldId])
                      ? "is_invalid"
                      : ""
                  }`}
                  style={{ cursor: "pointer" }}
                  value={(tabId ? formDataForTabs[tabId]?.[field.serviceTypeServiceFieldId]:formData[field.serviceTypeServiceFieldId])|| ""}
                  onChange={(e) =>
                    tabId ? 
                    handleFieldChangeForTabs(e.target.value, field.serviceTypeServiceFieldId, tabId):
                    handleFieldChange(
                      e.target.value,
                      field.serviceTypeServiceFieldId
                    )
                  }
                >
                  <option value="">Select Size</option>
                  <option value="750mL">750mL</option>
                  <option value="200mL">200mL</option>
                  <option value="100mL">100mL</option>
                </select>
        
                {field.mandatory &&
                (tabId
                  ? errorsForTabs[tabId]?.[field.serviceTypeServiceFieldId]
                  : errors[field.serviceTypeServiceFieldId]) && (
                  <span className="error-message">This field is required{" "}</span>
                )}
              {/* </div> */}
            </div>
          </div>
        );
      case Constant.FIELD_TYPES.PURPOSE_DROPDOWN:
        return (
          <div key={field.fieldName} className="col-6">
            <div className="form__field--wrapper">
              <label htmlFor="size" className="mb-2 form-label">
                {field.fieldName}
                {field.mandatory && (
                  <span className="star-required text-danger">*</span>
                )}
              </label>
              <div className="col">
                <select
                  id="purpose"
                  style={{ cursor: "pointer" }}
                  className={`form-control ${
                    field.mandatory && errors[field.serviceTypeServiceFieldId]
                      ? "is_invalid"
                      : ""
                  }`}
                  value={formData[field.serviceTypeServiceFieldId] || ""}
                  onChange={(e) =>
                    handleFieldChange(
                      e.target.value,
                      field.serviceTypeServiceFieldId
                    )
                  }
                >
                  <option value="">Select Purpose</option>
                  <option value="Taste Profile Analysis">
                    Taste Profile Analysis
                  </option>
                  <option value="Product Testing">Product Testing</option>
                  <option value="Quantity Testing">Quantity Testing</option>
                </select>
                {field.mandatory && errors[field.serviceTypeServiceFieldId] && (
                  <span className="error-message ">
                    This field is required{" "}
                  </span>
                )}
              </div>
            </div>
          </div>
        );
      case Constant.FIELD_TYPES.CONTACT_NUMBER:
        return (
          <div key={field.fieldName} className="col-sm-6 col-lg-4">
            <div className="form__field--wrapper">
              <label className="block mb-2 form-label">
                {field.fieldName}
                {field.mandatory && (
                  <span className="star-required text-danger">*
                  {selectedServiceName === Constant.CustomerService.LOGISTIC && (field.fieldName == 'Logistic from Contact Phone' || field.fieldName == 'Logistic to Contact Phone') && (
                    <Tooltip title={field.fieldName == 'Logistic from Contact Phone' ? "Enter the phone number for the shipping origin contact person." : "Enter the recipient's phone number for delivery coordination."}>
                      <img src={InfoIcon} alt="Info" className="inline-block ms-2"/>
                    </Tooltip>
                  )}
                  </span>
                )}
              </label>
              <input
                type="number"
                // placeholder={field.fieldName}
                value={formData[field.serviceTypeServiceFieldId]}
                onChange={(e) =>
                  handleFieldChange(
                    e.target.value,
                    field.serviceTypeServiceFieldId
                  )
                }
                onBlur={(e) =>
                  handleContactBlur(
                    e.target.value,
                    field.serviceTypeServiceFieldId
                  )
                }
                className={`form-control service-req-input no-spinner ${
                  field.mandatory && errors[field.serviceTypeServiceFieldId]
                    ? "is_invalid"
                    : ""
                }`}
              />
              {field.mandatory && errors[field.serviceTypeServiceFieldId] && (
                <span className="error-message ">
                  {errors[field.serviceTypeServiceFieldId]}
                </span>
              )}
            </div>
          </div>
        );
      case Constant.FIELD_TYPES.EMAIL:
        return (
          <div key={field.fieldName} className="col-sm-6 col-lg-4">
            <div className="form__field--wrapper">
              <label className="block mb-2 form-label">
                {field.fieldName}
                {field.mandatory && (
                  <span className="star-required text-danger">*
                  {selectedServiceName === Constant.CustomerService.LOGISTIC && (
                    <Tooltip title={field.fieldName == 'Logistic from Contact Email' ? "Provide the email address for the origin contact." : "Provide the recipient's email address for delivery"}>
                      <img src={InfoIcon} alt="Info" className="inline-block ms-2"/>
                    </Tooltip>
                  )}
                  </span>
                )}
              </label>
              <input
                type="email"
                placeholder={selectedServiceName === Constant.CustomerService.LOGISTIC && field.fieldName === 'Logistic from Contact Email'  || field.fieldName === 'Logistic to Contact Email' ? ' ' : `Enter ${field.fieldName}`}
                value={formData[field.serviceTypeServiceFieldId]}
                onChange={(e) =>
                  handleFieldChange(
                    e.target.value,
                    field.serviceTypeServiceFieldId
                  )
                }
                onBlur={(e) =>
                  handleEmailBlur(
                    e.target.value,
                    field.serviceTypeServiceFieldId
                  )
                }
                className={`form-control service-req-input ${
                  field.mandatory && errors[field.serviceTypeServiceFieldId]
                    ? "is_invalid"
                    : ""
                }`}
              />
              {field.mandatory && errors[field.serviceTypeServiceFieldId] && (
                <span className="error-message ">
                  {errors[field.serviceTypeServiceFieldId]}{" "}
                </span>
              )}
            </div>
          </div>
        );
      case Constant.FIELD_TYPES.PRIVATE_BUYER_COMPANY:
        return (
          <div key={field.fieldName} className="col-sm-6 col-lg-4">
            <div className="form__field--wrapper position-relative">
              <label className="block mb-2 form-label">
                {field.fieldName}
                {field.mandatory && (
                  <span className="star-required text-danger">*</span>
                )}
              </label>
              <div>
                <input
                  type="text"
                  placeholder={field.fieldName}
                  value={formData[field.serviceTypeServiceFieldId]}
                  onChange={(e) => {
                    handleOptionChange(
                      "COMPANY",
                      e.target.value,
                      field.serviceTypeServiceFieldId
                    );
                  }}
                  onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}
                  className={`form-control service-req-input ${
                    field.mandatory && errors[field.serviceTypeServiceFieldId]
                      ? "is_invalid"
                      : ""
                  }`}
                />
                {showCompanyDropdown && filteredCompanyOptions.length > 0 && (
                  <ul className="private-sell-dropdown">
                    {filteredCompanyOptions.map((option) => (
                      <li
                        key={option.id}
                        onClick={() =>
                          handleOptionClick(
                            "COMPANY",
                            option.id,
                            option.companyName,
                            field.serviceTypeServiceFieldId
                          )
                        }
                        className="private-sell-dropdown-item"
                      >
                        {option.companyName}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              {field.mandatory && errors[field.serviceTypeServiceFieldId] && (
                <span className="error-message ">
                  {errors[field.serviceTypeServiceFieldId] === "error" &&
                    "This field is required"}
                  {errors[field.serviceTypeServiceFieldId] !== "error" &&
                    errors[field.serviceTypeServiceFieldId]}
                </span>
              )}
            </div>
          </div>
        );
      case Constant.FIELD_TYPES.CARRIER:
        return (
          <div className="col-sm-6 col-lg-4">
            <div className="form__field--wrapper position-relative">
              <label
                htmlFor="service-dropdown"
                className="block mb-2 form-label"
              >
                {field.fieldName}
                {field.mandatory && (
                  <span className="star-required text-danger">*
                  {selectedServiceName === Constant.CustomerService.LOGISTIC && (
                    <Tooltip title="Select or add the shipping carrier responsible for transporting the container.">
                      <img src={InfoIcon} alt="Info" className="inline-block ms-2" />
                    </Tooltip>
                  )}
                  </span>
                )}
              </label>
              <CreatableSelect
                isClearable
                options={carrierList.map((c: any) => ({ value: c.id, label: c.name }))}
                value={
                  formData[field.serviceTypeServiceFieldId]
                    ? { value: formData[field.serviceTypeServiceFieldId], label: carrierInputValue }
                    : carrierInputValue
                      ? { value: carrierInputValue, label: carrierInputValue }
                      : null
                }
                onChange={(selected: any) => {
                  setErrors((prev) => ({ ...prev, [field.serviceTypeServiceFieldId]: "" }));
                  if (selected) {
                    setCarrierInputValue(selected.label);
                    setSelectedCarrierId(selected.value);
                    setFormData((prevFormData) => ({
                      ...prevFormData,
                      [field.serviceTypeServiceFieldId]: selected.__isNew__ ? null : selected.value,
                    }));
                    setShowCarrierMessage(selected.__isNew__ ? true : false);
                  } else {
                    setCarrierInputValue('');
                    setSelectedCarrierId(null);
                    setFormData((prevFormData) => ({
                      ...prevFormData,
                      [field.serviceTypeServiceFieldId]: null,
                    }));
                    setShowCarrierMessage(false);
                  }
                }}
                onCreateOption={(inputValue: string) => {
                  setErrors((prev) => ({ ...prev, [field.serviceTypeServiceFieldId]: "" }));
                  setCarrierInputValue(inputValue);
                  setSelectedCarrierId(null);
                  setFormData((prevFormData) => ({
                    ...prevFormData,
                    [field.serviceTypeServiceFieldId]: null,
                  }));
                  setShowCarrierMessage(true);
                }}
                placeholder="Select or add a new Carrier"
                className={`w-100 select-dropdown multi-select-dropdown ${field.mandatory && errors[field.serviceTypeServiceFieldId] ? "is_invalid" : ""
                  }`}
                classNamePrefix="select-dropdown"
              />
              {!errors[field.serviceTypeServiceFieldId] &&
                isShowCarrierMessage && carrierInputValue?.trim()?.length > 1 && !formData[field.serviceTypeServiceFieldId] && (
                  <span className='carrier-info-message'>
                    This Carrier will be added only when you submit the request.
                  </span>
              )}
              {field.mandatory && errors[field.serviceTypeServiceFieldId] && (
                <span className="error-message ">
                  {errors[field.serviceTypeServiceFieldId] === "error" &&
                    "Please select a user"}
                  {errors[field.serviceTypeServiceFieldId] !== "error" &&
                    errors[field.serviceTypeServiceFieldId]}
                </span>
              )}
            </div>
          </div>
        );
      case Constant.FIELD_TYPES.PRIVATE_BUYER_USER:
        return (
          <div className="col-sm-6 col-lg-4">
            <div className="form__field--wrapper position-relative">
              <label
                htmlFor="service-dropdown"
                className="block mb-2 form-label"
              >
                {field.fieldName}
                {field.mandatory && (
                  <span className="star-required text-danger">*</span>
                )}
              </label>
              <div>
                <input
                  type="text"
                  placeholder={field.fieldName}
                  value={formData[field.serviceTypeServiceFieldId]}
                  onChange={(e) => {
                    handleOptionChange(
                      "USER",
                      e.target.value,
                      field.serviceTypeServiceFieldId
                    );
                  }}
                  className={`form-control service-req-input ${
                    field.mandatory && errors[field.serviceTypeServiceFieldId]
                      ? "is_invalid"
                      : ""
                  }`}
                />
                {showUserDropdown && filteredUserOptions.length > 0 && (
                  <ul className="private-sell-dropdown">
                    {filteredUserOptions.map((option) => (
                      <li
                        key={option.userId}
                        onClick={() =>
                          handleOptionClick(
                            "USER",
                            option.userId,
                            option.userName,
                            field.serviceTypeServiceFieldId
                          )
                        }
                        className="private-sell-dropdown-item"
                      >
                        {option.userName}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              {field.mandatory && errors[field.serviceTypeServiceFieldId] && (
                <span className="error-message ">
                  {errors[field.serviceTypeServiceFieldId] === "error" &&
                    "Please select a user"}
                  {errors[field.serviceTypeServiceFieldId] !== "error" &&
                    errors[field.serviceTypeServiceFieldId]}
                </span>
              )}
            </div>
          </div>
        );
      case Constant.FIELD_TYPES.COMMISSION_FEE:
        const feeTypeKey = Object.keys(formData).find((key) => ["FLAT", "PERCENTAGE", ""].includes(formData[key]));
        const selectedFeeType = feeTypeKey ? formData[feeTypeKey] : undefined;

        const feeLabel = selectedFeeType === "FLAT" ? `${field.fieldName} ($)/Container` : selectedFeeType === "PERCENTAGE"
                        ? `${field.fieldName} (%)/Container`: field.fieldName;

        return (
          <div key={field.fieldName} className="col-sm-6 col-lg-4">
            <div className="form__field--wrapper">
              <label className="block mb-2 form-label">
                {feeLabel}
                {field.mandatory && (
                  <span className="star-required text-danger">*</span>
                )}
              </label>
              <input
                type="number"
                value={formData[field.serviceTypeServiceFieldId] || ""}
                placeholder="Enter commission fee"
                onChange={(e) => {
                  const value = e.target.value;
                  if (!/^-?\d*\.?\d*$/.test(value)) return;
                  handleFieldChange(
                    e.target.value,
                    field.serviceTypeServiceFieldId
                  );
                }}
                onKeyDown={(e) => {
                  if (e.key === "-" || e.key === "e" || e.key === "+") {
                    e.preventDefault(); // Prevent entering '-' or invalid characters
                  }
                }}
                onPaste={(e) => {
                  const pasteData = e.clipboardData.getData("text");
                  if (pasteData.includes("-")) {
                    e.preventDefault(); // Prevent pasting invalid characters
                  }
                }}
                onBlur={(e) => {
                  const value = e.target.value;
                  if (value.includes("-")) {
                    handleSellRequestFeeOnBlur(
                      "",
                      field.serviceTypeServiceFieldId
                    );
                  }
                  handleSellRequestFeeOnBlur(
                    e.target.value,
                    field.serviceTypeServiceFieldId
                  );
                }}
                className={`form-control service-req-input no-spinner ${
                  field.mandatory && errors[field.serviceTypeServiceFieldId]
                    ? "is_invalid"
                    : ""
                }`}
              />

              {field.mandatory && errors[field.serviceTypeServiceFieldId] && (
                <span className="error-message ">This field is required </span>
              )}
            </div>
          </div>
        );
      case Constant.FIELD_TYPES.OWNER_DROPDOWN:
        const baseOwnerOptions = ownerList.map((owner) => {
          const label = owner.email
            ? `${owner.ownerName} (${owner.email})`
            : owner.ownerName;

          return {
            label,
            value: owner.id,
          };
        });

        const shouldShowAddOwner = CommonService.isUser(); // ✅ condition check
        const ownerOptions = shouldShowAddOwner
          ? [
              ...baseOwnerOptions,
              {
                value: "add_owner",
                label: "Add New Owner",
              },
            ]
          : baseOwnerOptions;
        return (
          <div key={field.fieldName} className="col-sm-6 col-lg-4">
            <div className="form__field--wrapper">
              <label className="block mb-2 form-label">
                {field.fieldName || "Select an Owner"}
                {field.mandatory && (
                  <span className="star-required text-danger">*</span>
                )}
              </label>
              <Select
                placeholder="Select owner"
                styles={customStyles}
                onChange={(selectedOption) => {
                  if (selectedOption?.value === "add_owner") {
                    const url = CommonService.isAdmin()
                      ? "/master/add-owner"
                      : "/user/add-owner";
                    window.open(url, "_blank"); 
                  } else {
                    handleFieldChange(
                      selectedOption?.value, // this is owner.id
                      field.serviceTypeServiceFieldId
                    );
                  }
                }}
                value={
                  formData[field.serviceTypeServiceFieldId]
                    ? ownerOptions.find(
                        (opt) =>
                          opt.value ===
                          formData[field.serviceTypeServiceFieldId]
                      )
                    : null
                }
                options={ownerOptions}
                className={`w-100 select-dropdown multi-select-dropdown ${
                  field.mandatory && errors[field.serviceTypeServiceFieldId]
                    ? "is_invalid"
                    : ""
                }`}
                components={{
                  DropdownIndicator: () => <ExpandMoreRoundedIcon />,
                  IndicatorSeparator: () => null,
                }}
                isSearchable
                isDisabled={isDisabled}
                formatOptionLabel={formatOptionLabel}
              />
              {field.mandatory && errors[field.serviceTypeServiceFieldId] && (
                <span className="error-message">Please select an owner</span>
              )}
            </div>
          </div>
        );
      case Constant.FIELD_TYPES.TRANSFER_REQUEST_DROPDOWN:
        return (
          <div className="col-12">
            <div key={field.fieldName} className="form__field--wrapper">
              {/* Field Label */}
              <label className="block mb-2 form-label">
                {field.fieldName}
                {field.mandatory && (
                  <span className="star-required text-danger">*</span>
                )}
              </label>

              {/* Custom dropdown wrapper */}
              <div className="position-relative">
                <input
                  type="text"
                  readOnly
                  value={formData[field.serviceTypeServiceFieldId] ? getRequestDetailsById(formData[field.serviceTypeServiceFieldId]) : ''}
                  placeholder="Select Request Type"
                  className={`form-control service-req-input ${
                    field.mandatory && errors[field.serviceTypeServiceFieldId]
                      ? "is_invalid"
                      : ""
                  }`}
                  style={{paddingLeft:formData[field.serviceTypeServiceFieldId] ? "42px" :"inhiret", color:"#3A809E", fontWeight:"600", fontSize:"16px"}}
                  onClick={() => handleShowDropdown(formData[field.serviceTypeServiceFieldId])}
                />
                 {/* Show view icon only if a request is selected */}
                {formData[field.serviceTypeServiceFieldId] && (
                  <RemoveRedEyeOutlinedIcon
                    className="cursor-pointer top-50 translate-middle-y position-absolute"
                    sx={{height:20, width:20, color:"#3A809E", left:10}}
                    onClick={() =>
                      handleViewRequest(formData[field.serviceTypeServiceFieldId])
                    }
                  />
                )}
                 {field.mandatory && errors[field.serviceTypeServiceFieldId] && (
                    <span className="error-message">This field is required</span>
                 )}

                {showDropdown && (
                  <div className="position-absolute top-100 left-0 right-0 bottom-0 w-100 z-2">
                    <div className="serched-inventory-modal req-type-modal row m-0 w-100 bg-white">
                      <div className={`px-0 ${ !selectedType  ? "col-12" : "col-md-3"}`}>
                        <div className="list-wrapper">
                          {requestTypes.map((type) => (
                            <div
                              key={type.key}
                              className="list-item-wrapper d-flex align-items-center"
                              onClick={() => {
                                setSelectedType(type.key);
                              }}
                              style={{
                                backgroundColor:
                                  selectedType !== type.key
                                    ? "#f0f0f0"
                                    : "#fff",
                                cursor: "pointer",
                              }}
                            >
                              <p className="list-inventory-title mb-0">
                                {type.label}
                              </p>
                            </div>
                          ))}
                        </div>
                      </div>
                      <div className={`col-md-9 barrel-count-list-wrapper ${selectedType  ? "d-block" : "d-none"}`}>
                        {/* Show transfer requests when a type is selected */}
                        {selectedType && (
                          <div className="barrel-count-list h-100">
                            <div className="d-flex flex-wrap align-items-start flex-column h-100">
                              {transferRequests.filter((req) => req.requestType === selectedType).length > 0 ? (
                                transferRequests
                                  .filter((req) => req.requestType === selectedType)
                                  .map((req, index) => (
                                    <div
                                      key={index}
                                      className={`inventery-barrel-wrapper w-100 ${req.requestId == formData[field.serviceTypeServiceFieldId] && "selected-barrels"}`}
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        handleFieldChange(req?.requestId, field.serviceTypeServiceFieldId);
                                        setShowDropdown(false);
                                      }}
                                    >
                                      <span className="barrel-number--inner d-flex align-items-center gap-1">
                                        <span
                                          onClick={(e) => {
                                            e.stopPropagation(); // prevent parent click
                                            showRequestDetails(selectedType, req?.requestId);
                                          }}
                                          style={{ cursor: "pointer" }}
                                        >
                                          <RemoveRedEyeOutlinedIcon sx={{height:20, width:20, color:"#3A809E", verticalAlign:"bottom"}}/>
                                        </span>
                                        <span>
                                        {req.requestNumber} – {req.totalBarrels} Container
                                        </span>
                                      </span>
                                    </div>
                                  ))
                              ) : (
                                <div className='d-flex align-items-center justify-content-center h-100 w-100'>
                                <p className="text-muted">There is no {selectedType} for shipment</p>
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
      );
      case Constant.FIELD_TYPES.SHIP_FROM_FACILITY:
        return (
          <div className="col-sm-6 col-lg-4">
            <div className="form__field--wrapper position-relative">
              <label
                htmlFor="service-dropdown"
                className="block mb-2 form-label"
              >
                {field.fieldName}
                {field.mandatory && (
                  <span className="star-required text-danger">*
                  {selectedServiceName === Constant.CustomerService.LOGISTIC && (
                    <Tooltip title="Enter the facility where the container will be shipped from (origin facility).">
                      <img src={InfoIcon} alt="Info" className="inline-block ms-2"/>
                    </Tooltip>
                  )}
                  </span>
                )}
              </label>
              <div className='position-relative'>
                <input
                  type="text"
                  // placeholder='Search or add a new Logistic from Facility'
                  value={shipFromAddressInputValue}
                  onBlur={() => setShipFromAddressMessage(true)}
                  onChange={(e) =>
                    handleShipFromAddressChange(e, field.serviceTypeServiceFieldId)
                  }
                  onFocus={() => setShowShipFromAddressDropdown(true)}
                  className={`form-control service-req-input ${
                    field.mandatory && errors[field.serviceTypeServiceFieldId]
                      ? "is_invalid"
                      : ""
                  }`}
                  style={{paddingRight:"45px"}}
                />
                <SearchIcon
                    sx={{
                      color:"#616161",
                      position: "absolute",
                      top: "50%",
                      right: "15px",
                      transform: "translateY(-50%)",
                    }}
                  />
                </div>
                {/* Suggestions */}
                {showShipFromAddressDropdown && filteredShipFromAddressOptions.length > 0 && (
                  <ul className="private-sell-dropdown carrie-dropdown">
                    {filteredShipFromAddressOptions.map((option) => (
                      <li
                        key={option.id}
                        onClick={() =>
                          handleShipFromAddressSelect(
                            option,
                            field.serviceTypeServiceFieldId
                          )
                        }
                        className="private-sell-dropdown-item"
                      >
                        {option.facilityName}
                      </li>
                    ))}
                  </ul>
                )}
              
              {!errors[field.serviceTypeServiceFieldId] &&
                isShowShipFromAddressMessage && shipFromAddressInputValue?.trim()?.length > 1 && !formData[field.serviceTypeServiceFieldId] && (
                  <span className='carrier-info-message'>
                    This Logistic from Facility will be added only when you submit the request.
                  </span>
              )}
              {field.mandatory && errors[field.serviceTypeServiceFieldId] && (
                <span className="error-message ">
                  {errors[field.serviceTypeServiceFieldId] === "error" &&
                    "Please select a user"}
                  {errors[field.serviceTypeServiceFieldId] !== "error" &&
                    errors[field.serviceTypeServiceFieldId]}
                </span>
              )}
            </div>
          </div>
        );
      case Constant.FIELD_TYPES.SHIP_TO_FACILITY:
        return (
          <div className="col-sm-6 col-lg-4">
            <div className="form__field--wrapper position-relative">
              <label
                htmlFor="service-dropdown"
                className="block mb-2 form-label"
              >
                {field.fieldName}
                {field.mandatory && (
                  <span className="star-required text-danger">*
                  {selectedServiceName === Constant.CustomerService.LOGISTIC && (
                    <Tooltip title="Enter the facility where the container will be delivered (destination facility).">
                      <img src={InfoIcon} alt="Info" className="inline-block ms-2"/>
                    </Tooltip>
                  )}
                  </span>
                )}
              </label>
              <div className='position-relative'>
                <input
                  type="text"
                  // placeholder='Search or add a new Logistic to Facility'
                  value={shipToAddressInputValue}
                  onBlur={() => setShipToAddressMessage(true)}
                  onChange={(e) =>
                    handleShipToAddressChange(e, field.serviceTypeServiceFieldId)
                  }
                  onFocus={() => setShowShipToAddressDropdown(true)}
                  className={`form-control service-req-input ${
                    field.mandatory && errors[field.serviceTypeServiceFieldId]
                      ? "is_invalid"
                      : ""
                  }`}
                  style={{paddingRight:"45px"}}
                />
                <SearchIcon
                    sx={{
                      color:"#616161",
                      position: "absolute",
                      top: "50%",
                      right: "15px",
                      transform: "translateY(-50%)",
                    }}
                  />
                </div>
                {/* Suggestions */}
                {showShipToAddressDropdown && filteredShipToAddressOptions.length > 0 && (
                  <ul className="private-sell-dropdown carrie-dropdown">
                    {filteredShipToAddressOptions.map((option) => (
                      <li
                        key={option.id}
                        onClick={() =>
                          handleShipToAddressSelect(
                            option,
                            field.serviceTypeServiceFieldId
                          )
                        }
                        className="private-sell-dropdown-item"
                      >
                        {option.facilityName}
                      </li>
                    ))}
                  </ul>
                )}
              
              {!errors[field.serviceTypeServiceFieldId] &&
                isShowShipToAddressMessage && shipToAddressInputValue?.trim()?.length > 1 && !formData[field.serviceTypeServiceFieldId] && (
                  <span className='carrier-info-message'>
                    This Logistic to Facility will be added only when you submit the request.
                  </span>
              )}
              {field.mandatory && errors[field.serviceTypeServiceFieldId] && (
                <span className="error-message ">
                  {errors[field.serviceTypeServiceFieldId] === "error" &&
                    "Please select a user"}
                  {errors[field.serviceTypeServiceFieldId] !== "error" &&
                    errors[field.serviceTypeServiceFieldId]}
                </span>
              )}
            </div>
          </div>
        );
      case Constant.FIELD_TYPES.AGE_START:
        const ageYearsField = fields.find(
          (f) => f.dataType === Constant.FIELD_TYPES.AGE_END
        );

        return (
          <div key="age-group" className="col-lg-4 col-sm-12">
            <div className="form__field--wrapper">
              <label className="block mb-2 form-label">
                Age (in Years)
                {field.mandatory && <span className="star-required text-danger">*
                  <Tooltip title="Provide the age range in years. For example, enter 4 and 20 for an age range of 4–20 years.">
                    <img src={InfoIcon} alt="Info" className="inline-block ms-2"/>
                  </Tooltip>
                </span>}
              </label>

              <div className="d-flex align-items-center gap-2">
                {/* Age From */}
                <input
                  type="number"
                  value={formData[field.serviceTypeServiceFieldId] || ""}
                  onChange={(e) =>
                    handleFieldChange(e.target.value, field.serviceTypeServiceFieldId)
                  }
                  placeholder="Enter Start Age (From)"
                  className="form-control service-req-input no-spinner"
                />
                <span>to</span>

                {/* Age To */}
                <input
                  type="number"
                  value={
                    ageYearsField
                      ? formData[ageYearsField.serviceTypeServiceFieldId] || ""
                      : ""
                  }
                  onChange={(e) =>
                    ageYearsField &&
                    handleFieldChange(e.target.value, ageYearsField.serviceTypeServiceFieldId)
                  }
                  placeholder="Enter End Age (To)"
                  className="form-control service-req-input no-spinner"
                />
              </div>
              {field.mandatory && errors[field.serviceTypeServiceFieldId] && (
                <span className="error-message">This field is required</span>
              )}
            </div>
          </div>
        );

      case Constant.FIELD_TYPES.PROOFING_MIN:
        const proofingMaxField = fields.find(
          (f) => f.dataType === Constant.FIELD_TYPES.PROOFIND_MAX
        );

        return (
          <div key="proofing-group" className="col-lg-4 col-sm-12">
            <div className="form__field--wrapper">
              <label className="block mb-2 form-label">
                Proofing
                {field.mandatory && <span className="star-required text-danger">*
                  <Tooltip title="Enter the starting and ending proof values, For Example, 120.43 to 124.22">
                    <img src={InfoIcon} alt="Info" className="inline-block ms-2"/>
                  </Tooltip>
                </span>}
              </label>

              <div className="d-flex align-items-center gap-2">
                {/* Proofing Min */}
                <input
                  type="number"
                  value={formData[field.serviceTypeServiceFieldId] || ""}
                  onChange={(e) =>
                    handleFieldChange(e.target.value, field.serviceTypeServiceFieldId)
                  }
                  placeholder="Enter Proofing Min"
                  className="form-control service-req-input no-spinner"
                />
                <span>to</span>

                {/* Proofing Max */}
                <input
                  type="number"
                  value={
                    proofingMaxField
                      ? formData[proofingMaxField.serviceTypeServiceFieldId] || ""
                      : ""
                  }
                  onChange={(e) =>
                    proofingMaxField &&
                    handleFieldChange(e.target.value, proofingMaxField.serviceTypeServiceFieldId)
                  }
                  placeholder="Enter Proofing Max"
                  className="form-control service-req-input no-spinner"
                />
              </div>
              {field.mandatory && errors[field.serviceTypeServiceFieldId] && (
                <span className="error-message">This field is required</span>
              )}
            </div>
          </div>
        );
      case Constant.FIELD_TYPES.MASH_BILL:
        const currentFieldId = field.serviceTypeServiceFieldId;
        const currentVal = formData[currentFieldId];

        // Only prefill if we haven't done it yet AND there is no existing data
        if (!hasPrefilled.current && !currentVal) {
            setMashBillInputValue(PREFILL_TEMPLATE);
            setFormData(prev => ({ ...prev, [currentFieldId]: PREFILL_TEMPLATE }));
            hasPrefilled.current = true; // Mark as done forever
        }
        
        // Also, if currentVal exists (like from an API), but local state is empty, 
        // we should sync it once.
        if (!hasPrefilled.current && currentVal) {
            setMashBillInputValue(currentVal);
            hasPrefilled.current = true;
        }
        return (
          <div className="col-sm-6 col-lg-4">
            <div className="form__field--wrapper position-relative">
              <label
                htmlFor="service-dropdown"
                className="block mb-2 form-label"
              >
                {field.fieldName}
                {field.mandatory && (
                  <span className="star-required text-danger">*
                  <Tooltip  title={
                                    <>
                                      Enter Mash Bill in the following format:
                                      <br />
                                      00% Ingredient Name, 00% Ingredient Name
                                      <br />
                                      Example:
                                      <br />
                                      20% Corn, 30% Rye, 40% Wheat, 10% Malted Barley
                                    </>
                                  }>
                      <img src={InfoIcon} alt="Info" className="inline-block ms-2"/>
                    </Tooltip></span>
                )}
              </label>
              <div className='position-relative'>
                <input
                  type="text"
                  placeholder='00% Corn, 00% Rye, 00% Wheat, 00% Malted Barley'
                  value={mashBillInputValue}
                  onChange={(e) =>
                    handleMashBillChange(e, field.serviceTypeServiceFieldId)
                  }
                  onFocus={() => setShowMashBillDropdown(true)}
                  onBlur={() => {
                    setTimeout(() => {
                      setShowMashBillDropdown(false);
                      setShowMashBillMessage(true);
                    }, 200); 
                  }}
                  className={`form-control service-req-input ${
                    field.mandatory && errors[field.serviceTypeServiceFieldId]
                      ? "is_invalid"
                      : ""
                  }`}
                />
                <SearchIcon
                    sx={{
                      color:"#616161",
                      position: "absolute",
                      top: "50%",
                      right: "15px",
                      transform: "translateY(-50%)",
                    }}
                  />
                </div>
                {/* Suggestions */}
                {showMashBillDropdown && filteredMashBillOptions.length > 0 && (
                  <ul className="private-sell-dropdown carrie-dropdown">
                    {filteredMashBillOptions.map((option) => (
                      <li
                        key={option.id}
                        onClick={() =>
                          handleMashBillSelect(
                            option,
                            field.serviceTypeServiceFieldId
                          )
                        }
                        className="private-sell-dropdown-item"
                      >
                        {option.name}
                      </li>
                    ))}
                  </ul>
                )}
              
              {!errors[field.serviceTypeServiceFieldId] &&
                isShowMashBillMessage && 
                mashBillInputValue?.trim() !== PREFILL_TEMPLATE && // Don't show if it's just the template
                mashBillInputValue?.trim()?.length > 1 && 
                !formData[field.serviceTypeServiceFieldId] && (
                  <span className='carrier-info-message'>
                    This Mash Bill will be added only when you submit the request.
                  </span>
              )}
              {field.mandatory && errors[field.serviceTypeServiceFieldId] && (
                <span className="error-message ">
                  {errors[field.serviceTypeServiceFieldId] === "error" &&
                    "Please select a user"}
                  {errors[field.serviceTypeServiceFieldId] !== "error" &&
                    errors[field.serviceTypeServiceFieldId]}
                </span>
              )}
            </div>
          </div>
        );
      case Constant.FIELD_TYPES.CONTAINER_TYPE_DROPDOWN:
        return (
          <div key={field.serviceTypeServiceFieldId} className="col-lg-4 position-relative z-2">
            <div className="form__field--wrapper">
              <label htmlFor={`container-type-${field.serviceTypeServiceFieldId}`} className="form-label">
                {field.fieldName}
                {field.mandatory && (
                  <span className="star-required text-danger">*</span>
                )}
              </label>
              <select
                id={`container-type-${field.serviceTypeServiceFieldId}`}
                className={`form-select select-dropdown ${
                  field.mandatory && errors[field.serviceTypeServiceFieldId] ? "is_invalid" : ""
                }`}
                value={formData[field.serviceTypeServiceFieldId] || ""}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    [field.serviceTypeServiceFieldId]: e.target.value,
                  }))
                }
              >
                <option value="">Select a Container Type</option>
                <option value="Tote">Tote</option>
                <option value="Drum">Drum</option>
                <option value="Barrel">Barrel</option>
              </select>

              {field.mandatory && errors[field.serviceTypeServiceFieldId] && (
                <span className="error-message">This field is required</span>
              )}
            </div>
          </div>
        );
      case Constant.FIELD_TYPES.LOGISTIC_TYPE_DROPDOWN:
        return (
          <div key={field.serviceTypeServiceFieldId} className="col-lg-4">
            <div className="form__field--wrapper">
              <label
                htmlFor={`logistic-type-${field.serviceTypeServiceFieldId}`}
                className="form-label"
              >
                {field.fieldName}
                {field.mandatory && (
                  <span className="star-required text-danger">*</span>
                )}
              </label>

              <select
                id={`logistic-type-${field.serviceTypeServiceFieldId}`}
                value={formData[field.serviceTypeServiceFieldId] ?? ""}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    [field.serviceTypeServiceFieldId]: e.target.value,
                  }))
                }
                className={`form-select ${
                  field.mandatory &&
                  !formData[field.serviceTypeServiceFieldId]
                    ? "is_invalid"
                    : ""
                }`}
              >
                <option value="Inbound">Inbound</option>
                <option value="Outbound">Outbound</option>
                <option value="External">External</option>
              </select>

              {/* ❗ Error only when value is EMPTY */}
              {field.mandatory &&
                !formData[field.serviceTypeServiceFieldId] && (
                  <span className="error-message">
                    This field is required
                  </span>
                )}
            </div>
          </div>
        );
      case Constant.FIELD_TYPES.SHIP_FROM_DSP:
        return (
          <div key={field.fieldName} className="col-sm-6 col-lg-4">
            <div className="form__field--wrapper">
              <label className="block mb-2 form-label">
                {field.fieldName}
                {field.mandatory && (
                  <span className="star-required text-danger">*
                  {selectedServiceName === Constant.CustomerService.LOGISTIC && (
                    <Tooltip title="Enter the dsp where the container will be shipped from (origin facility).">
                      <img src={InfoIcon} alt="Info" className="inline-block ms-2"/>
                    </Tooltip>
                  )}
                  </span>
                )}
              </label>
              <input
                type="text"
                // placeholder={`Enter ${field.fieldName}`}
                value={formData[field.serviceTypeServiceFieldId]}
                onChange={(e) =>
                  handleFieldChange(
                    e.target.value,
                    field.serviceTypeServiceFieldId
                  )
                }
                onBlur={(e) =>
                  handleFieldBlur(
                    e.target.value,
                    field.serviceTypeServiceFieldId
                  )
                }
                className={`form-control service-req-input ${
                  field.mandatory && errors[field.serviceTypeServiceFieldId]
                    ? "is_invalid"
                    : ""
                }`}
                disabled={isDisabled}
              />
              {field.mandatory && errors[field.serviceTypeServiceFieldId] && (
                <span className="error-message ">This field is required </span>
              )}
            </div>
          </div>
        );
      case Constant.FIELD_TYPES.SHIP_TO_DSP:
        return (
          <div key={field.fieldName} className="col-sm-6 col-lg-4">
            <div className="form__field--wrapper">
              <label className="block mb-2 form-label">
                {field.fieldName}
                {field.mandatory && (
                  <span className="star-required text-danger">*
                  {selectedServiceName === Constant.CustomerService.LOGISTIC && (
                    <Tooltip title="Enter the dsp where the container will be shipped to (destination facility).">
                      <img src={InfoIcon} alt="Info" className="inline-block ms-2"/>
                    </Tooltip>
                  )}
                  </span>
                )}
              </label>
              <input
                type="text"
                // placeholder={`Enter ${field.fieldName}`}
                value={formData[field.serviceTypeServiceFieldId]}
                onChange={(e) =>
                  handleFieldChange(
                    e.target.value,
                    field.serviceTypeServiceFieldId
                  )
                }
                onBlur={(e) =>
                  handleFieldBlur(
                    e.target.value,
                    field.serviceTypeServiceFieldId
                  )
                }
                className={`form-control service-req-input ${
                  field.mandatory && errors[field.serviceTypeServiceFieldId]
                    ? "is_invalid"
                    : ""
                }`}
                disabled={isDisabled}
              />
              {field.mandatory && errors[field.serviceTypeServiceFieldId] && (
                <span className="error-message ">This field is required </span>
              )}
            </div>
          </div>
        );
      case Constant.FIELD_TYPES.SHIP_FROM_ADDRESS:
        return (
          <div key={field.fieldName} className="col-sm-6 col-lg-4">
            <div className="form__field--wrapper">
              <label className="block mb-2 form-label">
                {field.fieldName}
                {field.mandatory && (
                  <span className="star-required text-danger">*
                  {selectedServiceName === Constant.CustomerService.LOGISTIC && (
                    <Tooltip title="Enter the pickup address for the container shipment.">
                      <img src={InfoIcon} alt="Info" className="inline-block ms-2"/>
                    </Tooltip>
                  )}
                  </span>
                )}
              </label>
              <input
                type="text"
                // placeholder={`Enter ${field.fieldName}`}
                value={formData[field.serviceTypeServiceFieldId]}
                onChange={(e) =>
                  handleFieldChange(
                    e.target.value,
                    field.serviceTypeServiceFieldId
                  )
                }
                onBlur={(e) =>
                  handleFieldBlur(
                    e.target.value,
                    field.serviceTypeServiceFieldId
                  )
                }
                className={`form-control service-req-input ${
                  field.mandatory && errors[field.serviceTypeServiceFieldId]
                    ? "is_invalid"
                    : ""
                }`}
                disabled={isDisabled}
              />
              {field.mandatory && errors[field.serviceTypeServiceFieldId] && (
                <span className="error-message ">This field is required </span>
              )}
            </div>
          </div>
        );
      case Constant.FIELD_TYPES.SHIP_TO_ADDRESS:
        return (
          <div key={field.fieldName} className="col-sm-6 col-lg-4">
            <div className="form__field--wrapper">
              <label className="block mb-2 form-label">
                {field.fieldName}
                {field.mandatory && (
                  <span className="star-required text-danger">*
                  {selectedServiceName === Constant.CustomerService.LOGISTIC && (
                    <Tooltip title="Enter the destination address for the container delivery.">
                      <img src={InfoIcon} alt="Info" className="inline-block ms-2"/>
                    </Tooltip>
                  )}
                  </span>
                )}
              </label>
              <input
                type="text"
                // placeholder={`Enter ${field.fieldName}`}
                value={formData[field.serviceTypeServiceFieldId]}
                onChange={(e) =>
                  handleFieldChange(
                    e.target.value,
                    field.serviceTypeServiceFieldId
                  )
                }
                onBlur={(e) =>
                  handleFieldBlur(
                    e.target.value,
                    field.serviceTypeServiceFieldId
                  )
                }
                className={`form-control service-req-input ${
                  field.mandatory && errors[field.serviceTypeServiceFieldId]
                    ? "is_invalid"
                    : ""
                }`}
                disabled={isDisabled}
              />
              {field.mandatory && errors[field.serviceTypeServiceFieldId] && (
                <span className="error-message ">This field is required </span>
              )}
            </div>
          </div>
        );
       case Constant.FIELD_TYPES.SHIP_FROM_CONTACT:
        return (
          <div key={field.fieldName} className="col-sm-6 col-lg-4">
            <div className="form__field--wrapper">
              <label className="block mb-2 form-label">
                {field.fieldName}
                {field.mandatory && (
                  <span className="star-required text-danger">*
                  {selectedServiceName === Constant.CustomerService.LOGISTIC && (
                    <Tooltip title="Enter the Address where the container will be shipped to (origin facility).">
                      <img src={InfoIcon} alt="Info" className="inline-block ms-2"/>
                    </Tooltip>
                  )}
                  </span>
                )}
              </label>
              <input
                type="text"
                // placeholder={`Enter ${field.fieldName}`}
                value={formData[field.serviceTypeServiceFieldId]}
                onChange={(e) =>
                  handleFieldChange(
                    e.target.value,
                    field.serviceTypeServiceFieldId
                  )
                }
                onBlur={(e) =>
                  handleFieldBlur(
                    e.target.value,
                    field.serviceTypeServiceFieldId
                  )
                }
                className={`form-control service-req-input ${
                  field.mandatory && errors[field.serviceTypeServiceFieldId]
                    ? "is_invalid"
                    : ""
                }`}
                disabled={isDisabled}
              />
              {field.mandatory && errors[field.serviceTypeServiceFieldId] && (
                <span className="error-message ">This field is required </span>
              )}
            </div>
          </div>
        );
      case Constant.FIELD_TYPES.SHIP_TO_CONTACT:
        return (
          <div key={field.fieldName} className="col-sm-6 col-lg-4">
            <div className="form__field--wrapper">
              <label className="block mb-2 form-label">
                {field.fieldName}
                {field.mandatory && (
                  <span className="star-required text-danger">*
                  {selectedServiceName === Constant.CustomerService.LOGISTIC && (
                    <Tooltip title="Enter the Address where the container will be shipped to (origin facility).">
                      <img src={InfoIcon} alt="Info" className="inline-block ms-2"/>
                    </Tooltip>
                  )}
                  </span>
                )}
              </label>
              <input
                type="text"
                // placeholder={`Enter ${field.fieldName}`}
                value={formData[field.serviceTypeServiceFieldId]}
                onChange={(e) =>
                  handleFieldChange(
                    e.target.value,
                    field.serviceTypeServiceFieldId
                  )
                }
                onBlur={(e) =>
                  handleFieldBlur(
                    e.target.value,
                    field.serviceTypeServiceFieldId
                  )
                }
                className={`form-control service-req-input ${
                  field.mandatory && errors[field.serviceTypeServiceFieldId]
                    ? "is_invalid"
                    : ""
                }`}
                disabled={isDisabled}
              />
              {field.mandatory && errors[field.serviceTypeServiceFieldId] && (
                <span className="error-message ">This field is required </span>
              )}
            </div>
          </div>
        );
      }
    };

    // Get the rendered JSX element for the field
    const element = getFieldElement();

    // If it's a non-creation field during logistics request creation, add the CSS class to hide the asterisk
    if (element && isNonCreationLogistic) {
      const existingClassName = element.props.className || '';
      return React.cloneElement(element, {
        className: `${existingClassName} logistic-non-creation-field`
      });
    }

    return element;
  };

  const getClosedRequestCount = async () => {
    try {
      const response = await Service.getCloseSupportRequestCount(
        CommonService.isUser() ? CommonService.getCompanyId() : null
      );
      setClosedRequestCount(response.data);
    } catch (error) {
      console.error("Error fetching closed request count:", error);
    }
  };

  const getOpenRequestCount = async () => {
    try {
      const response = await Service.getOpenSupportRequestCount(
        CommonService.isUser() ? CommonService.getCompanyId() : null
      );
      setOpenRequestCount(response.data);
    } catch (error) {
      console.error("Error fetching open request count:", error);
    }
  };

  const downloadTemplateFile = async () => {
    try {
      const response: any = await InventoryApiService.downloadInventoryTemplate();
      // Assuming response.data is the blob data
      const blob = new Blob([response.data], {
        type: "application/octet-stream",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      a.download = "WDTP_Inventory_upload_template.xlsx"; // Specify the download filename
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleTabChange = (newValue: string) => {
    setActiveTab(newValue);
    setSelectedRequest(null);
    if (newValue !== "create") {
      setNewTicket(false);
      // loadSupportRequests(newValue.toUpperCase());
    }
  };

  // Filter the list whenever `search` changes
  const filteredItems = useMemo(
    () =>
      supportRequests.filter(
        (item) =>
          item.companyName.toLowerCase().includes(search.toLowerCase()) ||
          item.latestComment.toLowerCase().includes(search.toLowerCase()) ||
          item.name.toLowerCase().includes(search.toLowerCase())
      ),
    [supportRequests, search]
  );

  return (
    <div className="group-chat-wrapper support-main-wrapper">
      {/* {CommonService.isAdmin() && ( */}
      <div className="d-flex align-items-center justify-content-between flex-wrap header-wrapper mt-0 gap-2">
        {CommonService.isAdmin() && (
          <>
            <div className="d-flex align-items-center gap-2">
              <div className="back__button" onClick={() => history.goBack()}>
                <IconButton
                  aria-label="ArrowBackIcon"
                  sx={{ backgroundColor: "#FFF" }}
                >
                  <ArrowBackIcon sx={{ color: "#1C1B1F" }} />
                </IconButton>
              </div>
              <Typography
                variant="h1"
                gutterBottom
                className="mb-0"
                sx={{
                  fontSize: "24px",
                  fontWeight: 700,
                  color: "#242424",
                  lineHeight: "22px",
                }}
              >
                {id ? "Update Customer Service Request" : "Create New Request"}
              </Typography>
            </div>
          </>
        )}
        <div className="ms-auto">
          <button className="support-faq-btn" onClick={handleShowFaq}>
            Click here for FAQs and Tutorials
          </button>
        </div>
      </div>
      {/* )} */}

      {/* <div className="d-flex"> */}
      <div
        className="group-chat-container service--req-wrapper position-relative"
        style={{
          minHeight: CommonService.isAdmin() ? "calc(100vh - 167px)" : "",
        }}
      >
        {viewFaq && <SupportFaqPanel handleCloseFaq={handleCloseFaq} />}

        <div className="container">
          {isNewTicket && (
            <div className="service-req--inner">
              <div className="service-req-form-wrapper">
                <form
                  noValidate
                  onSubmit={handleSubmit}
                  className="service-req-form"
                >
                  <div className=" form__field--wrapper">
                    <div className="row m-0 g-4">

                      {!(id && selectedServiceName === Constant.CustomerService.CUSTOM_SAMPLE_REQUEST) && (
                      <div className="col-lg-4">
                        <label
                          htmlFor="service-dropdown"
                          className="form-label"
                        >
                          Select a Request
                          <span className="star-required text-danger">*</span>
                        </label>
                        <div className="w-100">
                          <select
                            id="service-dropdown"
                            value={selectedService}
                            onChange={(e) => {
                              const selectedServiceId = e.target.value;
                              const selectedServiceObject = services.find(
                                (service) => service.id === selectedServiceId
                              );
                              handleServiceChange(
                                selectedServiceId,
                                selectedServiceObject?.serviceName
                              );
                            }}
                            className="select-dropdown w-100"
                            required
                            // Disable when Shipment is auto-created from Blending/Bottling/Dumping or when id exists
                            disabled={ id ? true
                                : selectedServiceName === Constant.CustomerService.LOGISTIC && isCreateShipment}>
                            {isRequestLoading ? (
                              <option>Loading...</option> // Show spinner while loading
                            ) : (
                              <>
                                <option value="">Select</option>
                                {/*services.map((service) => (
                                  <option key={service.id} value={service.id}>
                                    {service.serviceName}
                                  </option>
                                ))*/
                                
                                services.filter((service) => {
                                  // Always exclude if service name is not LOGISTIC
                                  if (service.serviceName !== Constant.CustomerService.LOGISTIC) return true;

                                  // Only include LOGISTIC if user is admin
                                  return CommonService.isAdmin();
                                })
                                .map((service) => (
                                  <option key={service.id} value={service.id}>
                                    {service.serviceName}
                                  </option>
                                ))}
                              </>
                            )}
                          </select>
                        </div>
                      </div>)}

                      {CommonService.isAdmin() && isAdminSelectService && selectedServiceName !== undefined && !(!id && selectedServiceName == Constant.CustomerService.CUSTOM_SAMPLE_REQUEST) && (
                        <>
                        <div className="col-lg-4 z-3 position-relative">
                          <label
                            htmlFor="user-company-dropdown"
                            className="form-label"
                          >
                           {selectedServiceName == Constant.CustomerService.LOGISTIC ? 'Requesting Company' : 'Select a Company'} 
                            <span className="star-required text-danger">*</span>
                          </label>
                         
                          <div className="w-100">
                              <Select
                                id="user-company-dropdown"
                                className={`w-100 select-dropdown multi-select-dropdown ${
                                  selectedCompanyError ? "is_invalid" : ""
                                }`}
                                options={companyOptions}
                                isLoading={loadingCompanies}
                                placeholder="Select"
                                value={
                                  selectedCompany
                                    ? companyOptions.find(
                                        (option) =>
                                          option.value === selectedCompany
                                      )
                                    : null
                                }
                                onChange={(selectedOption) =>
                                  handleUserCompanyChange(selectedOption?.value)
                                }
                                components={{
                                  DropdownIndicator: () => (
                                    <ExpandMoreRoundedIcon />
                                  ),
                                  IndicatorSeparator: () => null, // Remove the default separator
                                }}
                                isSearchable
                                isDisabled={id ? true : false}
                              />
                          </div>

                            
                            {selectedCompanyError && (
                              <span className="error-message ">
                                {selectedCompanyError}{" "}
                              </span>
                            )}
                            </div>
                           {!id && selectedServiceName == Constant.CustomerService.LOGISTIC && (<div className="col-lg-4 z-2 position-relative">
                          <label
                            htmlFor="user-company-dropdown"
                            className="form-label"
                          >
                            Select Logistic Method
                            <span className="star-required text-danger">*</span>
                          </label>
                          <div className="w-100">
                             <select
                              id="size"
                              className={`form-select select-dropdown ${
                                barrelSourceError
                                  ? "is_invalid"
                                  : ""
                              }`}
                              style={{ cursor: "pointer" }}
                              value={barrelSource}
                              onChange={(e) => {
                                if(!id) {
                                   setBarrelSource(e.target.value);
                                   fetchFieldsByServiceType(selectedService, selectedServiceName, e.target.value);
                                }
                              }}
                              disabled={id ? true : false}
                            >
                              <option value="Manual Barrel Selection">Manual Container Selection</option>
                              <option value="Logistic from Existing Request">Logistic from Existing Request</option>
                              <option value="Upload Inventory for Logistic">Upload Inventory for Logistic</option>
                            </select>
                          </div>

                          {barrelSourceError && (
                            <span className="error-message ">
                              Please select Container Source
                            </span>
                          )}
                        </div>)}
                        </>
                        )} 
                            
                      

                       {(id && selectedServiceName === Constant.CustomerService.CUSTOM_SAMPLE_REQUEST) &&
                          ( <div className="col-lg-4 z-3 position-relative">
                            <div className="form__field--wrapper">
                              <label
                                htmlFor="user-company-dropdown"
                                className="form-label"
                              >
                                Title
                                <span className="star-required text-danger">
                                  *
                                </span>
                              </label>
                              <div className="w-100">
                                <input
                                  id="title"
                                  className={`form-control service-req-input ${
                                    titleError ? "is_invalid" : ""
                                  }`}
                                  placeholder="Enter title"
                                  value={selectedTitle}
                                  onChange={handleTitleChange}
                                />
                              </div>

                          
                            {titleError && (
                              <span className="error-message ">
                                This field is required
                              </span>
                            )}
                            </div>
                          </div>
                        )}

                      {/*Requesting Organization Fields Show in Custom Sample Request*/}
                      {(id || selectedServiceName != Constant.CustomerService.CUSTOM_SAMPLE_REQUEST) &&
                        fields.filter(
                            (field) => field.fieldName === Constant.Field.REQUESTING_ORGANIZATION
                          ).map((field) => renderField(field))}
                      {!id &&
                    selectedServiceName ==
                      Constant.CustomerService.CUSTOM_SAMPLE_REQUEST && (
                      <div className="col-lg-4 z-3 position-relative">
                        <div className="form__field--wrapper">
                          <label
                            htmlFor="user-company-dropdown"
                            className="form-label"
                          >
                            Title
                            <span className="star-required text-danger">*</span>
                          </label>
                          <div className="w-100">
                            <input
                              id="title"
                              type="text"
                              className={`form-control service-req-input ${
                                titleError ? "is_invalid" : ""
                              }`}
                              placeholder="Enter title"
                              value={selectedTitle}
                              onChange={handleTitleChange}
                            />
                          </div>

                        {titleError && (
                          <span className="error-message ">
                            Please enter title
                          </span>
                        )}
                      </div>
                      </div>
                    )}
                    
                  </div>

                  {isServiceFieldLoading && (
                    <div className="text-center py-4">Loading...</div>
                  )}

                  {!isServiceFieldLoading && fields.length > 0  && (id ||
                      selectedServiceName !=
                        Constant.CustomerService.CUSTOM_SAMPLE_REQUEST)&& (
                    <>
                      <div className="space-y-4 row m-0 g-4">
                        {selectedServiceName == Constant.CustomerService.LOGISTIC && barrelSource == Constant.BarrelSource.SHIP_BY_UPLOAD_INVENTORY &&(
                          fieldsForUploadInventory.map((field) => renderField(field))
                        )}

                        {fields.filter((field) => field.fieldName !== Constant.Field.REQUESTING_ORGANIZATION)
                          .map((field) => renderField(field))}
                      </div>
                      <div className="req-footer-wrapper px-0 mt-4">
                        {isValidated && !isLoading && (
                          <>
                            <div className="error-wrapper">
                              <div className="error-header">
                                <p className="file-error-heading">
                                  <WarningRoundedIcon
                                    sx={{ color: "#B10E1C" }}
                                  />
                                  Please fix below errors and re-upload
                                  inventory file
                                </p>
                                <button
                                  className="close-error-btn"
                                  onClick={handleClose}
                                >
                                  <CloseIcon />
                                  Close
                                </button>
                              </div>
                              <List className="warning-list">
                                {validationsList?.map((validation, index) => (
                                  <React.Fragment key={index}>
                                    <ListItem
                                      alignItems="flex-start"
                                      sx={{
                                        display: "flex",
                                        paddingInline: "0px",
                                        paddingRight: "70px",
                                      }}
                                    >
                                      <ListItemAvatar
                                        sx={{
                                          minWidth: "unset",
                                          marginTop: 0,
                                          marginRight: "2px",
                                        }}
                                      ></ListItemAvatar>
                                      <ListItemText
                                        sx={{
                                          margin: 0,
                                          display: "flex",
                                          justifyContent: "space-between",
                                        }}
                                        primary={
                                          <React.Fragment>
                                            <Typography
                                              component="span"
                                              variant="body2"
                                              sx={{
                                                color: "#B10E1C",
                                                fontWeight: 700,
                                                wordBreak: "break-all",
                                                fontSize: 15,
                                              }}
                                            >
                                              Row # {validation?.rowNumber} -
                                            </Typography>
                                            <Typography
                                              component="span"
                                              variant="body2"
                                              sx={{
                                                color: "#B10E1C",
                                                fontWeight: 400,
                                                marginLeft: "4px",
                                                fontSize: 15,
                                              }}
                                            >
                                              {validation?.errorMessages}
                                            </Typography>
                                          </React.Fragment>
                                        }
                                        secondary={
                                          <React.Fragment>
                                            <Typography
                                              component="span"
                                              variant="body2"
                                              sx={{
                                                color: "#496673",
                                                fontWeight: 400,
                                                cursor: "pointer",
                                              }}
                                            ></Typography>
                                          </React.Fragment>
                                        }
                                      />
                                    </ListItem>
                                    <Divider
                                      variant="inset"
                                      component="li"
                                      sx={{
                                        marginLeft: 0,
                                        backgroundColor: "#D9D9D9",
                                      }}
                                    />
                                    </React.Fragment>
                                  ))}
                                </List>
                              </div>
                            </>
                          )}
                          <div
                            className={`req-footer-inner gap-3 ${
                              isValidated && "mt-3"
                            }`}
                          >
                            <button
                              type="reset"
                              className="secondary-btn"
                              onClick={() => history.goBack()}
                              disabled={isLoading}
                            >
                              Cancel
                            </button>
                            <button
                              type="submit"
                              className="primary-btn"
                              disabled={isLoading}
                            >
                              {isLoading && <Spinner />}
                              {getButtonLabel()}
                            </button>
                          </div>
                        </div>
                      </>
                  )}

                  {!id &&
                    selectedServiceName ==
                      Constant.CustomerService.CUSTOM_SAMPLE_REQUEST && (
                        <>
                      <div className='row m-0'>
                        <div className='col-12'>
                        <div className="sample-nav-tabs nav-tabs-wrapper mt-4 d-flex align-items-center">
                          <ul className="nav nav-tabs d-flex align-items-center">
                            {tabs.map((tab) => (
                              <li className="nav-item" key={tab.id}>
                                <button
                                  className={`nav-link d-flex align-items-center ${
                                    activeTabId === tab.id ? "active" : ""
                                  }`}
                                  onClick={() => handleChangeTab(tab.id)}
                                >
                                  {getCompanyNameById(selectedCompanies[tab.id]) || "Request"}

                                  {tabs.length > 1 && ( // Only show the icon if there's more than one tab
                                    
                                    <span className='delete-icon' onClick={(e) => {
                                        e.stopPropagation();
                                        handleRemoveTab(tab.id);
                                      }}>
                                      <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M20.25 5.6875H16.5V4.9375C16.5 4.34076 16.2629 3.76847 15.841 3.34651C15.419 2.92455 14.8467 2.6875 14.25 2.6875H9.75C9.15326 2.6875 8.58097 2.92455 8.15901 3.34651C7.73705 3.76847 7.5 4.34076 7.5 4.9375V5.6875H3.75C3.55109 5.6875 3.36032 5.76652 3.21967 5.90717C3.07902 6.04782 3 6.23859 3 6.4375C3 6.63641 3.07902 6.82718 3.21967 6.96783C3.36032 7.10848 3.55109 7.1875 3.75 7.1875H4.5V20.6875C4.5 21.0853 4.65804 21.4669 4.93934 21.7482C5.22064 22.0295 5.60218 22.1875 6 22.1875H18C18.3978 22.1875 18.7794 22.0295 19.0607 21.7482C19.342 21.4669 19.5 21.0853 19.5 20.6875V7.1875H20.25C20.4489 7.1875 20.6397 7.10848 20.7803 6.96783C20.921 6.82718 21 6.63641 21 6.4375C21 6.23859 20.921 6.04782 20.7803 5.90717C20.6397 5.76652 20.4489 5.6875 20.25 5.6875ZM9 4.9375C9 4.73859 9.07902 4.54782 9.21967 4.40717C9.36032 4.26652 9.55109 4.1875 9.75 4.1875H14.25C14.4489 4.1875 14.6397 4.26652 14.7803 4.40717C14.921 4.54782 15 4.73859 15 4.9375V5.6875H9V4.9375ZM18 20.6875H6V7.1875H18V20.6875ZM10.5 10.9375V16.9375C10.5 17.1364 10.421 17.3272 10.2803 17.4678C10.1397 17.6085 9.94891 17.6875 9.75 17.6875C9.55109 17.6875 9.36032 17.6085 9.21967 17.4678C9.07902 17.3272 9 17.1364 9 16.9375V10.9375C9 10.7386 9.07902 10.5478 9.21967 10.4072C9.36032 10.2665 9.55109 10.1875 9.75 10.1875C9.94891 10.1875 10.1397 10.2665 10.2803 10.4072C10.421 10.5478 10.5 10.7386 10.5 10.9375ZM15 10.9375V16.9375C15 17.1364 14.921 17.3272 14.7803 17.4678C14.6397 17.6085 14.4489 17.6875 14.25 17.6875C14.0511 17.6875 13.8603 17.6085 13.7197 17.4678C13.579 17.3272 13.5 17.1364 13.5 16.9375V10.9375C13.5 10.7386 13.579 10.5478 13.7197 10.4072C13.8603 10.2665 14.0511 10.1875 14.25 10.1875C14.4489 10.1875 14.6397 10.2665 14.7803 10.4072C14.921 10.5478 15 10.7386 15 10.9375Z" fill="#3A809E" />
                                      </svg>
                                    </span>
                                  )}
                                </button>
                              </li>
                            ))}
                          </ul>
                          <button
                            className="add-another-btn mb-1 d-flex align-items-center gap-1"
                            onClick={handleAddTab}
                          >
                            <AddCircleOutlineIcon sx={{fill:"#737376"}}/>
                             Add Another
                          </button>
                        </div>
                      </div>
                      
                        <div className="tab-content">
                          {tabs.map((tab) => (
                            <div
                              key={tab.id}
                              className={`tab-pane ${
                                activeTabId === tab.id ? "active" : ""
                              }`}
                            >
                              {activeTabId === tab.id && (
                                <div className="space-y-4 row m-0 g-4">
                                  {CommonService.isAdmin() && (<div className="col-lg-4 position-relative" style={{zIndex:"4"}}>
                                    <div className="form__field--wrapper">
                                      <label
                                        htmlFor={`user-company-dropdown-${tab.id}`}
                                        className="form-label"
                                      >
                                        Select a Company
                                        <span className="star-required text-danger">
                                          *
                                        </span>
                                      </label>
                                      <div className="w-100">
                                        <Select
                                          id={`user-company-dropdown-${tab.id}`}
                                          className={`w-100 select-dropdown multi-select-dropdown ${
                                            selectedCompanyErrors[tab.id]
                                              ? "is_invalid"
                                              : ""
                                          }`}
                                          options={companyOptions}
                                          isLoading={loadingCompanies}
                                          placeholder="Select"
                                          value={
                                            selectedCompanies[tab.id]
                                              ? companyOptions.find(
                                                  (option) =>
                                                    option.value ===
                                                    selectedCompanies[tab.id]
                                                )
                                              : null
                                          }
                                          onChange={(selectedOption) =>
                                            handleUserCompanyChangeForTabs(
                                              selectedOption?.value,
                                              tab.id
                                            )
                                          }
                                          components={{
                                            DropdownIndicator: () => (
                                              <ExpandMoreRoundedIcon />
                                            ),
                                            IndicatorSeparator: () => null,
                                          }}
                                          isSearchable
                                          isDisabled={id ? true : false}
                                        />
                                      </div>

                                    {selectedCompanyErrors[tab.id] && (
                                      <span className="error-message">
                                        {selectedCompanyErrors[tab.id]}
                                      </span>
                                    )}
                                   </div>
                                  </div>
                                )}
                                  {fields.map((field) => {
                                    // Find the active tab to get the correct field value
                                    const activeTab = tabs.find(
                                      (t) => t.id === activeTabId
                                    );
                                    const value =
                                      activeTab?.fieldValues[field.fieldName] ||
                                      "";

                                    // Assumption: Your renderField function can be called like this
                                    return renderField(field, tab.id);
                                  })}
                                </div>
                                
                              )}
                            </div>
                          ))}
                        </div>
                        <div className='req-footer-wrapper px-0 mt-4'>
                        <div
                          className={`req-footer-inner gap-3 ${
                            isValidated && "mt-3"
                          }`}
                        >
                          <button
                            type="reset"
                            className="secondary-btn"
                            onClick={() => history.goBack()}
                            disabled={isLoading}
                            style={{minWidth:"162px"}}
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            className="primary-btn"
                            disabled={isLoading}
                            onClick={handleRequestWithTabs}
                          >
                            {isLoading && <Spinner />}
                            Submit all Requests
                          </button>
                        </div>
                        </div>
                      </div>
                      </>
                    )}
                    
              
        </div>
                </form>
        
            </div>

      
        </div>)}

        </div>

      {showPopup && (
        <BarrelOwnerAssignmentPopup
          onConfirm={handlePopupConfirm}
          onCancel={handlePopupCancel}
          conflictCount={conflictCount}
        />
      )}
      {isShowSellRequestEditValidationPopup && (
        <SellRequestEditValidationPopup
          redirectToDashboard={redirectToDashboard}
          onCancel={handlePopupCancel}
          type={sellRequestEditValidationType}
        />
      )}
    </div>
    </div>
  );
};

export default AddSupportRequest;
